/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * SmartDocz API
 * API Documentation for SmartDocz
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ArchivalClassificationDto,
  ArchivalClassificationFilter,
  ArchivalClassificationFiltroDto,
  ArchivalClassificationImportResultDto,
  ArchivalClassificationInput,
  BatchSignatureCancelInput,
  BatchSignatureInput,
  CacheDto,
  CountPendingDocumentsParams,
  CoverDto,
  CreateDocumentBody,
  DetailsParams,
  DigitalFileDto,
  DigitalFileSignatureCadesDigitalInput,
  DigitalFileSignatureCadesDigitalWithWebPkiInput,
  DigitalFileSignatureCadesElectronicInput,
  DigitalFileSignaturePadesDigitalInput,
  DigitalFileSignaturePadesDigitalWithWebPkiInput,
  DigitalFileSignaturePadesElectronicInput,
  DigitalFileSignatureXadesDigitalInput,
  DigitalFileSignatureXadesDigitalWithWebPkiInput,
  DigitalFileSignatureXadesElectronicInput,
  DigitalFileWithSignatureTokenDto,
  DigitalSignatureWithAllPropertiesDto,
  DocumentDto,
  DocumentExternalLinkDto,
  DocumentInputCreateWithExternalReferenceDto,
  DocumentProcessStartInput,
  DocumentTokenDto,
  DocumentWithAllPropertiesDto,
  DoczBffDetailDto,
  DoczBffLogDto,
  DoczBffOverviewDto,
  DoczBffOverviewFilterListDto,
  DownloadByArquivoId200,
  DownloadByArquivoIdParams,
  DownloadDocumentByToken200,
  DownloadFile200,
  DownloadFileByHash200,
  DownloadFileByHashParams,
  DownloadFileParams,
  DownloadMainFile200,
  DownloadMainFileParams,
  DownloadMainThumbnail200,
  DownloadStoredFile200,
  DownloadThumbnail200,
  DownloadThumbnailParams,
  EditDocumentBody,
  ElectronicSignatureCadesDigitalFileParams,
  ElectronicSignatureCadesParams,
  ElectronicSignaturePadesDigitalFileParams,
  ElectronicSignaturePadesParams,
  ElectronicSignatureXadesDigitalFileParams,
  ElectronicSignatureXadesParams,
  ExtensionDto,
  FindFolderByNameParams,
  FindWorkspaceByNameParams,
  FinishSignatureCadesDigitalFileParams,
  FinishSignaturePadesDigitalFileParams,
  FinishSignatureXadesDigitalFileParams,
  FolderInputDto,
  FolderWithParentAndWorkspaceInputDto,
  FormArchivalClassificationImportInput,
  GetFileDetails200,
  Health200,
  ImportArchivalClassificationParams,
  ListArchivalClassificationParams,
  ListArchivalClassificationPostParams,
  ListCoversParams,
  ListCoversToSignParams,
  ListDigitalFileParams,
  ListDocumentExternalLinkParams,
  ListDocumentLogParams,
  ListDocumentParams,
  ListExcludedDocumentParams,
  ListPendingDocumentParams,
  ListProcessExecutionHistoryParams,
  ListSignatureParams,
  ListSubDocumentTypeParams,
  LogsParams,
  OverviewFiltersParams,
  OverviewParams,
  PageArchivalClassificationDto,
  PageCoverDto,
  PageDigitalSignatureDto,
  PageDocumentDto,
  PageDocumentExternalLinkDto,
  PageDocumentLogDto,
  PageDocumentProcessStartExecutionLogDto,
  PagePendingDocumentDto,
  PageSubDocumentTypeDto,
  PendingDocumentDenyInput,
  PendingDocumentDto,
  PendingDocumentStatisticDto,
  PendingSituationDto,
  Problem,
  ProcessInstanceDto,
  ReasonRequestDto,
  Reindex200,
  SearchGetParams,
  SearchRequest,
  SearchResponse,
  SigiloDto,
  SignatureBatchResponse,
  SignatureCadesDigitalInput,
  SignatureCadesDigitalWithWebPkiInput,
  SignatureCadesElectronicForm,
  SignaturePadesDigitalInput,
  SignaturePadesDigitalWithWebPkiInput,
  SignaturePadesElectronicForm,
  SignatureStarterResultDto,
  SignatureXadesDigitalInput,
  SignatureXadesDigitalWithWebPkiInput,
  SignatureXadesElectronicForm,
  StartSignatureCadesDigitalFileParams,
  StartSignatureCadesParams,
  StartSignaturePadesDigitalFileParams,
  StartSignaturePadesParams,
  StartSignatureXadesDigitalFileParams,
  StartSignatureXadesParams,
  SubDocumentTypeDto,
  SubDocumentTypeExternalLinkDto,
  SubDocumentTypeExternalLinkInput,
  SubDocumentTypeInput,
  ValidListDocumentExternalLinkInput,
  VisualizeFile200,
  VisualizeFileParams,
  VisualizeMainFile200,
  VisualizeMainFileParams,
  WorkspaceDto,
  WorkspaceInputDto
} from './model';

import { customInstanceDocumentos } from '../axios-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type enableSubDocumentTypeResponse204 = {
  data: void
  status: 204
}

export type enableSubDocumentTypeResponse404 = {
  data: Problem
  status: 404
}

export type enableSubDocumentTypeResponseSuccess = (enableSubDocumentTypeResponse204) & {
  headers: Headers;
};
export type enableSubDocumentTypeResponseError = (enableSubDocumentTypeResponse404) & {
  headers: Headers;
};

export type enableSubDocumentTypeResponse = (enableSubDocumentTypeResponseSuccess | enableSubDocumentTypeResponseError)

export const getEnableSubDocumentTypeUrl = (tenant: string,
    subDocumentTypeId: number,) => {




  return `/${tenant}/sub-document-types/${subDocumentTypeId}/enable`
}

/**
 * @summary Ativa um sub tipo de documento por ID
 */
export const enableSubDocumentType = async (tenant: string,
    subDocumentTypeId: number, options?: RequestInit): Promise<enableSubDocumentTypeResponse> => {

  return customInstanceDocumentos<enableSubDocumentTypeResponse>(getEnableSubDocumentTypeUrl(tenant,subDocumentTypeId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getEnableSubDocumentTypeMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableSubDocumentType>>, TError,{tenant: string;subDocumentTypeId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof enableSubDocumentType>>, TError,{tenant: string;subDocumentTypeId: number}, TContext> => {

const mutationKey = ['enableSubDocumentType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableSubDocumentType>>, {tenant: string;subDocumentTypeId: number}> = (props) => {
          const {tenant,subDocumentTypeId} = props ?? {};

          return  enableSubDocumentType(tenant,subDocumentTypeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableSubDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof enableSubDocumentType>>>

    export type EnableSubDocumentTypeMutationError = Problem

    /**
 * @summary Ativa um sub tipo de documento por ID
 */
export const useEnableSubDocumentType = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableSubDocumentType>>, TError,{tenant: string;subDocumentTypeId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableSubDocumentType>>,
        TError,
        {tenant: string;subDocumentTypeId: number},
        TContext
      > => {
      return useMutation(getEnableSubDocumentTypeMutationOptions(options), queryClient);
    }

export type disableSubDocumentTypeResponse204 = {
  data: void
  status: 204
}

export type disableSubDocumentTypeResponse404 = {
  data: Problem
  status: 404
}

export type disableSubDocumentTypeResponseSuccess = (disableSubDocumentTypeResponse204) & {
  headers: Headers;
};
export type disableSubDocumentTypeResponseError = (disableSubDocumentTypeResponse404) & {
  headers: Headers;
};

export type disableSubDocumentTypeResponse = (disableSubDocumentTypeResponseSuccess | disableSubDocumentTypeResponseError)

export const getDisableSubDocumentTypeUrl = (tenant: string,
    subDocumentTypeId: number,) => {




  return `/${tenant}/sub-document-types/${subDocumentTypeId}/enable`
}

/**
 * @summary Inativa um sub tipo de documento por ID
 */
export const disableSubDocumentType = async (tenant: string,
    subDocumentTypeId: number, options?: RequestInit): Promise<disableSubDocumentTypeResponse> => {

  return customInstanceDocumentos<disableSubDocumentTypeResponse>(getDisableSubDocumentTypeUrl(tenant,subDocumentTypeId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisableSubDocumentTypeMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableSubDocumentType>>, TError,{tenant: string;subDocumentTypeId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof disableSubDocumentType>>, TError,{tenant: string;subDocumentTypeId: number}, TContext> => {

const mutationKey = ['disableSubDocumentType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableSubDocumentType>>, {tenant: string;subDocumentTypeId: number}> = (props) => {
          const {tenant,subDocumentTypeId} = props ?? {};

          return  disableSubDocumentType(tenant,subDocumentTypeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableSubDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof disableSubDocumentType>>>

    export type DisableSubDocumentTypeMutationError = Problem

    /**
 * @summary Inativa um sub tipo de documento por ID
 */
export const useDisableSubDocumentType = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableSubDocumentType>>, TError,{tenant: string;subDocumentTypeId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableSubDocumentType>>,
        TError,
        {tenant: string;subDocumentTypeId: number},
        TContext
      > => {
      return useMutation(getDisableSubDocumentTypeMutationOptions(options), queryClient);
    }

export type findSubDocumentTypeResponse404 = {
  data: Problem
  status: 404
}

;
export type findSubDocumentTypeResponseError = (findSubDocumentTypeResponse404) & {
  headers: Headers;
};

export type findSubDocumentTypeResponse = (findSubDocumentTypeResponseError)

export const getFindSubDocumentTypeUrl = (tenant: string,
    subDocumentTypeId: number,) => {




  return `/${tenant}/sub-document-types/${subDocumentTypeId}`
}

/**
 * @summary Busca um sub tipo de documento por ID
 */
export const findSubDocumentType = async (tenant: string,
    subDocumentTypeId: number, options?: RequestInit): Promise<findSubDocumentTypeResponse> => {

  return customInstanceDocumentos<findSubDocumentTypeResponse>(getFindSubDocumentTypeUrl(tenant,subDocumentTypeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindSubDocumentTypeQueryKey = (tenant: string,
    subDocumentTypeId: number,) => {
    return [
    `/${tenant}/sub-document-types/${subDocumentTypeId}`
    ] as const;
    }


export const getFindSubDocumentTypeQueryOptions = <TData = Awaited<ReturnType<typeof findSubDocumentType>>, TError = Problem>(tenant: string,
    subDocumentTypeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSubDocumentType>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindSubDocumentTypeQueryKey(tenant,subDocumentTypeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findSubDocumentType>>> = ({ signal }) => findSubDocumentType(tenant,subDocumentTypeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && subDocumentTypeId !== null && subDocumentTypeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findSubDocumentType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindSubDocumentTypeQueryResult = NonNullable<Awaited<ReturnType<typeof findSubDocumentType>>>
export type FindSubDocumentTypeQueryError = Problem


export function useFindSubDocumentType<TData = Awaited<ReturnType<typeof findSubDocumentType>>, TError = Problem>(
 tenant: string,
    subDocumentTypeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSubDocumentType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSubDocumentType>>,
          TError,
          Awaited<ReturnType<typeof findSubDocumentType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindSubDocumentType<TData = Awaited<ReturnType<typeof findSubDocumentType>>, TError = Problem>(
 tenant: string,
    subDocumentTypeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSubDocumentType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSubDocumentType>>,
          TError,
          Awaited<ReturnType<typeof findSubDocumentType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindSubDocumentType<TData = Awaited<ReturnType<typeof findSubDocumentType>>, TError = Problem>(
 tenant: string,
    subDocumentTypeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSubDocumentType>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca um sub tipo de documento por ID
 */

export function useFindSubDocumentType<TData = Awaited<ReturnType<typeof findSubDocumentType>>, TError = Problem>(
 tenant: string,
    subDocumentTypeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSubDocumentType>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindSubDocumentTypeQueryOptions(tenant,subDocumentTypeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editSubDocumentTypeResponse200 = {
  data: SubDocumentTypeDto
  status: 200
}

export type editSubDocumentTypeResponse404 = {
  data: Problem
  status: 404
}

export type editSubDocumentTypeResponseSuccess = (editSubDocumentTypeResponse200) & {
  headers: Headers;
};
export type editSubDocumentTypeResponseError = (editSubDocumentTypeResponse404) & {
  headers: Headers;
};

export type editSubDocumentTypeResponse = (editSubDocumentTypeResponseSuccess | editSubDocumentTypeResponseError)

export const getEditSubDocumentTypeUrl = (tenant: string,
    subDocumentTypeId: number,) => {




  return `/${tenant}/sub-document-types/${subDocumentTypeId}`
}

/**
 * @summary Atualiza um sub tipo de documento por ID
 */
export const editSubDocumentType = async (tenant: string,
    subDocumentTypeId: number,
    subDocumentTypeInput: SubDocumentTypeInput, options?: RequestInit): Promise<editSubDocumentTypeResponse> => {

  return customInstanceDocumentos<editSubDocumentTypeResponse>(getEditSubDocumentTypeUrl(tenant,subDocumentTypeId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(subDocumentTypeInput)
  }
);}




export const getEditSubDocumentTypeMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editSubDocumentType>>, TError,{tenant: string;subDocumentTypeId: number;data: SubDocumentTypeInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof editSubDocumentType>>, TError,{tenant: string;subDocumentTypeId: number;data: SubDocumentTypeInput}, TContext> => {

const mutationKey = ['editSubDocumentType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editSubDocumentType>>, {tenant: string;subDocumentTypeId: number;data: SubDocumentTypeInput}> = (props) => {
          const {tenant,subDocumentTypeId,data} = props ?? {};

          return  editSubDocumentType(tenant,subDocumentTypeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditSubDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof editSubDocumentType>>>
    export type EditSubDocumentTypeMutationBody = SubDocumentTypeInput
    export type EditSubDocumentTypeMutationError = Problem

    /**
 * @summary Atualiza um sub tipo de documento por ID
 */
export const useEditSubDocumentType = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editSubDocumentType>>, TError,{tenant: string;subDocumentTypeId: number;data: SubDocumentTypeInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editSubDocumentType>>,
        TError,
        {tenant: string;subDocumentTypeId: number;data: SubDocumentTypeInput},
        TContext
      > => {
      return useMutation(getEditSubDocumentTypeMutationOptions(options), queryClient);
    }

export type deleteSubDocumentTypeResponse204 = {
  data: void
  status: 204
}

export type deleteSubDocumentTypeResponse404 = {
  data: Problem
  status: 404
}

export type deleteSubDocumentTypeResponseSuccess = (deleteSubDocumentTypeResponse204) & {
  headers: Headers;
};
export type deleteSubDocumentTypeResponseError = (deleteSubDocumentTypeResponse404) & {
  headers: Headers;
};

export type deleteSubDocumentTypeResponse = (deleteSubDocumentTypeResponseSuccess | deleteSubDocumentTypeResponseError)

export const getDeleteSubDocumentTypeUrl = (tenant: string,
    subDocumentTypeId: number,) => {




  return `/${tenant}/sub-document-types/${subDocumentTypeId}`
}

/**
 * @summary Exclui um sub tipo de documento por ID
 */
export const deleteSubDocumentType = async (tenant: string,
    subDocumentTypeId: number, options?: RequestInit): Promise<deleteSubDocumentTypeResponse> => {

  return customInstanceDocumentos<deleteSubDocumentTypeResponse>(getDeleteSubDocumentTypeUrl(tenant,subDocumentTypeId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSubDocumentTypeMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSubDocumentType>>, TError,{tenant: string;subDocumentTypeId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSubDocumentType>>, TError,{tenant: string;subDocumentTypeId: number}, TContext> => {

const mutationKey = ['deleteSubDocumentType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSubDocumentType>>, {tenant: string;subDocumentTypeId: number}> = (props) => {
          const {tenant,subDocumentTypeId} = props ?? {};

          return  deleteSubDocumentType(tenant,subDocumentTypeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSubDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSubDocumentType>>>

    export type DeleteSubDocumentTypeMutationError = Problem

    /**
 * @summary Exclui um sub tipo de documento por ID
 */
export const useDeleteSubDocumentType = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSubDocumentType>>, TError,{tenant: string;subDocumentTypeId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSubDocumentType>>,
        TError,
        {tenant: string;subDocumentTypeId: number},
        TContext
      > => {
      return useMutation(getDeleteSubDocumentTypeMutationOptions(options), queryClient);
    }

export type enableArchivalClassificationResponse204 = {
  data: void
  status: 204
}

export type enableArchivalClassificationResponse404 = {
  data: Problem
  status: 404
}

export type enableArchivalClassificationResponseSuccess = (enableArchivalClassificationResponse204) & {
  headers: Headers;
};
export type enableArchivalClassificationResponseError = (enableArchivalClassificationResponse404) & {
  headers: Headers;
};

export type enableArchivalClassificationResponse = (enableArchivalClassificationResponseSuccess | enableArchivalClassificationResponseError)

export const getEnableArchivalClassificationUrl = (tenant: string,
    archivalClassificationId: number,) => {




  return `/${tenant}/archival-classifications/${archivalClassificationId}/enable`
}

/**
 * @summary Ativa uma classificação arquivística por ID
 */
export const enableArchivalClassification = async (tenant: string,
    archivalClassificationId: number, options?: RequestInit): Promise<enableArchivalClassificationResponse> => {

  return customInstanceDocumentos<enableArchivalClassificationResponse>(getEnableArchivalClassificationUrl(tenant,archivalClassificationId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getEnableArchivalClassificationMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableArchivalClassification>>, TError,{tenant: string;archivalClassificationId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof enableArchivalClassification>>, TError,{tenant: string;archivalClassificationId: number}, TContext> => {

const mutationKey = ['enableArchivalClassification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableArchivalClassification>>, {tenant: string;archivalClassificationId: number}> = (props) => {
          const {tenant,archivalClassificationId} = props ?? {};

          return  enableArchivalClassification(tenant,archivalClassificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableArchivalClassificationMutationResult = NonNullable<Awaited<ReturnType<typeof enableArchivalClassification>>>

    export type EnableArchivalClassificationMutationError = Problem

    /**
 * @summary Ativa uma classificação arquivística por ID
 */
export const useEnableArchivalClassification = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableArchivalClassification>>, TError,{tenant: string;archivalClassificationId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableArchivalClassification>>,
        TError,
        {tenant: string;archivalClassificationId: number},
        TContext
      > => {
      return useMutation(getEnableArchivalClassificationMutationOptions(options), queryClient);
    }

export type disableArchivalClassificationResponse204 = {
  data: void
  status: 204
}

export type disableArchivalClassificationResponse404 = {
  data: Problem
  status: 404
}

export type disableArchivalClassificationResponseSuccess = (disableArchivalClassificationResponse204) & {
  headers: Headers;
};
export type disableArchivalClassificationResponseError = (disableArchivalClassificationResponse404) & {
  headers: Headers;
};

export type disableArchivalClassificationResponse = (disableArchivalClassificationResponseSuccess | disableArchivalClassificationResponseError)

export const getDisableArchivalClassificationUrl = (tenant: string,
    archivalClassificationId: number,) => {




  return `/${tenant}/archival-classifications/${archivalClassificationId}/enable`
}

/**
 * @summary Inativa uma classificação arquivística por ID
 */
export const disableArchivalClassification = async (tenant: string,
    archivalClassificationId: number, options?: RequestInit): Promise<disableArchivalClassificationResponse> => {

  return customInstanceDocumentos<disableArchivalClassificationResponse>(getDisableArchivalClassificationUrl(tenant,archivalClassificationId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisableArchivalClassificationMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableArchivalClassification>>, TError,{tenant: string;archivalClassificationId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof disableArchivalClassification>>, TError,{tenant: string;archivalClassificationId: number}, TContext> => {

const mutationKey = ['disableArchivalClassification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableArchivalClassification>>, {tenant: string;archivalClassificationId: number}> = (props) => {
          const {tenant,archivalClassificationId} = props ?? {};

          return  disableArchivalClassification(tenant,archivalClassificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableArchivalClassificationMutationResult = NonNullable<Awaited<ReturnType<typeof disableArchivalClassification>>>

    export type DisableArchivalClassificationMutationError = Problem

    /**
 * @summary Inativa uma classificação arquivística por ID
 */
export const useDisableArchivalClassification = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableArchivalClassification>>, TError,{tenant: string;archivalClassificationId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableArchivalClassification>>,
        TError,
        {tenant: string;archivalClassificationId: number},
        TContext
      > => {
      return useMutation(getDisableArchivalClassificationMutationOptions(options), queryClient);
    }

export type findArchivalClassificationResponse404 = {
  data: Problem
  status: 404
}

;
export type findArchivalClassificationResponseError = (findArchivalClassificationResponse404) & {
  headers: Headers;
};

export type findArchivalClassificationResponse = (findArchivalClassificationResponseError)

export const getFindArchivalClassificationUrl = (tenant: string,
    archivalClassificationId: number,) => {




  return `/${tenant}/archival-classifications/${archivalClassificationId}`
}

/**
 * @summary Busca uma classificação arquivística por ID
 */
export const findArchivalClassification = async (tenant: string,
    archivalClassificationId: number, options?: RequestInit): Promise<findArchivalClassificationResponse> => {

  return customInstanceDocumentos<findArchivalClassificationResponse>(getFindArchivalClassificationUrl(tenant,archivalClassificationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindArchivalClassificationQueryKey = (tenant: string,
    archivalClassificationId: number,) => {
    return [
    `/${tenant}/archival-classifications/${archivalClassificationId}`
    ] as const;
    }


export const getFindArchivalClassificationQueryOptions = <TData = Awaited<ReturnType<typeof findArchivalClassification>>, TError = Problem>(tenant: string,
    archivalClassificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArchivalClassification>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindArchivalClassificationQueryKey(tenant,archivalClassificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findArchivalClassification>>> = ({ signal }) => findArchivalClassification(tenant,archivalClassificationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && archivalClassificationId !== null && archivalClassificationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findArchivalClassification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindArchivalClassificationQueryResult = NonNullable<Awaited<ReturnType<typeof findArchivalClassification>>>
export type FindArchivalClassificationQueryError = Problem


export function useFindArchivalClassification<TData = Awaited<ReturnType<typeof findArchivalClassification>>, TError = Problem>(
 tenant: string,
    archivalClassificationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArchivalClassification>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findArchivalClassification>>,
          TError,
          Awaited<ReturnType<typeof findArchivalClassification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindArchivalClassification<TData = Awaited<ReturnType<typeof findArchivalClassification>>, TError = Problem>(
 tenant: string,
    archivalClassificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArchivalClassification>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findArchivalClassification>>,
          TError,
          Awaited<ReturnType<typeof findArchivalClassification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindArchivalClassification<TData = Awaited<ReturnType<typeof findArchivalClassification>>, TError = Problem>(
 tenant: string,
    archivalClassificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArchivalClassification>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca uma classificação arquivística por ID
 */

export function useFindArchivalClassification<TData = Awaited<ReturnType<typeof findArchivalClassification>>, TError = Problem>(
 tenant: string,
    archivalClassificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArchivalClassification>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindArchivalClassificationQueryOptions(tenant,archivalClassificationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editArchivalClassificationResponse200 = {
  data: ArchivalClassificationDto
  status: 200
}

export type editArchivalClassificationResponse400 = {
  data: Problem
  status: 400
}

export type editArchivalClassificationResponseSuccess = (editArchivalClassificationResponse200) & {
  headers: Headers;
};
export type editArchivalClassificationResponseError = (editArchivalClassificationResponse400) & {
  headers: Headers;
};

export type editArchivalClassificationResponse = (editArchivalClassificationResponseSuccess | editArchivalClassificationResponseError)

export const getEditArchivalClassificationUrl = (tenant: string,
    archivalClassificationId: number,) => {




  return `/${tenant}/archival-classifications/${archivalClassificationId}`
}

/**
 * @summary Atualiza uma classificação arquivística por ID
 */
export const editArchivalClassification = async (tenant: string,
    archivalClassificationId: number,
    archivalClassificationInput: ArchivalClassificationInput, options?: RequestInit): Promise<editArchivalClassificationResponse> => {

  return customInstanceDocumentos<editArchivalClassificationResponse>(getEditArchivalClassificationUrl(tenant,archivalClassificationId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(archivalClassificationInput)
  }
);}




export const getEditArchivalClassificationMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editArchivalClassification>>, TError,{tenant: string;archivalClassificationId: number;data: ArchivalClassificationInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof editArchivalClassification>>, TError,{tenant: string;archivalClassificationId: number;data: ArchivalClassificationInput}, TContext> => {

const mutationKey = ['editArchivalClassification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editArchivalClassification>>, {tenant: string;archivalClassificationId: number;data: ArchivalClassificationInput}> = (props) => {
          const {tenant,archivalClassificationId,data} = props ?? {};

          return  editArchivalClassification(tenant,archivalClassificationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditArchivalClassificationMutationResult = NonNullable<Awaited<ReturnType<typeof editArchivalClassification>>>
    export type EditArchivalClassificationMutationBody = ArchivalClassificationInput
    export type EditArchivalClassificationMutationError = Problem

    /**
 * @summary Atualiza uma classificação arquivística por ID
 */
export const useEditArchivalClassification = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editArchivalClassification>>, TError,{tenant: string;archivalClassificationId: number;data: ArchivalClassificationInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editArchivalClassification>>,
        TError,
        {tenant: string;archivalClassificationId: number;data: ArchivalClassificationInput},
        TContext
      > => {
      return useMutation(getEditArchivalClassificationMutationOptions(options), queryClient);
    }

export type deleteArchivalClassificationResponse204 = {
  data: void
  status: 204
}

export type deleteArchivalClassificationResponse404 = {
  data: Problem
  status: 404
}

export type deleteArchivalClassificationResponseSuccess = (deleteArchivalClassificationResponse204) & {
  headers: Headers;
};
export type deleteArchivalClassificationResponseError = (deleteArchivalClassificationResponse404) & {
  headers: Headers;
};

export type deleteArchivalClassificationResponse = (deleteArchivalClassificationResponseSuccess | deleteArchivalClassificationResponseError)

export const getDeleteArchivalClassificationUrl = (tenant: string,
    archivalClassificationId: number,) => {




  return `/${tenant}/archival-classifications/${archivalClassificationId}`
}

/**
 * @summary Exclui uma classificação arquivística por ID
 */
export const deleteArchivalClassification = async (tenant: string,
    archivalClassificationId: number, options?: RequestInit): Promise<deleteArchivalClassificationResponse> => {

  return customInstanceDocumentos<deleteArchivalClassificationResponse>(getDeleteArchivalClassificationUrl(tenant,archivalClassificationId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteArchivalClassificationMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteArchivalClassification>>, TError,{tenant: string;archivalClassificationId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteArchivalClassification>>, TError,{tenant: string;archivalClassificationId: number}, TContext> => {

const mutationKey = ['deleteArchivalClassification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteArchivalClassification>>, {tenant: string;archivalClassificationId: number}> = (props) => {
          const {tenant,archivalClassificationId} = props ?? {};

          return  deleteArchivalClassification(tenant,archivalClassificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteArchivalClassificationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteArchivalClassification>>>

    export type DeleteArchivalClassificationMutationError = Problem

    /**
 * @summary Exclui uma classificação arquivística por ID
 */
export const useDeleteArchivalClassification = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteArchivalClassification>>, TError,{tenant: string;archivalClassificationId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteArchivalClassification>>,
        TError,
        {tenant: string;archivalClassificationId: number},
        TContext
      > => {
      return useMutation(getDeleteArchivalClassificationMutationOptions(options), queryClient);
    }

export type findWorkspaceResponse404 = {
  data: Problem
  status: 404
}

;
export type findWorkspaceResponseError = (findWorkspaceResponse404) & {
  headers: Headers;
};

export type findWorkspaceResponse = (findWorkspaceResponseError)

export const getFindWorkspaceUrl = (tenantId: string,
    workspaceId: number,) => {




  return `/${tenantId}/workspaces/${workspaceId}`
}

/**
 * @summary Busca um workspace por ID
 */
export const findWorkspace = async (tenantId: string,
    workspaceId: number, options?: RequestInit): Promise<findWorkspaceResponse> => {

  return customInstanceDocumentos<findWorkspaceResponse>(getFindWorkspaceUrl(tenantId,workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindWorkspaceQueryKey = (tenantId: string,
    workspaceId: number,) => {
    return [
    `/${tenantId}/workspaces/${workspaceId}`
    ] as const;
    }


export const getFindWorkspaceQueryOptions = <TData = Awaited<ReturnType<typeof findWorkspace>>, TError = Problem>(tenantId: string,
    workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findWorkspace>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindWorkspaceQueryKey(tenantId,workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findWorkspace>>> = ({ signal }) => findWorkspace(tenantId,workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && workspaceId !== null && workspaceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findWorkspace>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindWorkspaceQueryResult = NonNullable<Awaited<ReturnType<typeof findWorkspace>>>
export type FindWorkspaceQueryError = Problem


export function useFindWorkspace<TData = Awaited<ReturnType<typeof findWorkspace>>, TError = Problem>(
 tenantId: string,
    workspaceId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findWorkspace>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findWorkspace>>,
          TError,
          Awaited<ReturnType<typeof findWorkspace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindWorkspace<TData = Awaited<ReturnType<typeof findWorkspace>>, TError = Problem>(
 tenantId: string,
    workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findWorkspace>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findWorkspace>>,
          TError,
          Awaited<ReturnType<typeof findWorkspace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindWorkspace<TData = Awaited<ReturnType<typeof findWorkspace>>, TError = Problem>(
 tenantId: string,
    workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findWorkspace>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca um workspace por ID
 */

export function useFindWorkspace<TData = Awaited<ReturnType<typeof findWorkspace>>, TError = Problem>(
 tenantId: string,
    workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findWorkspace>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindWorkspaceQueryOptions(tenantId,workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editWorkspaceResponse200 = {
  data: WorkspaceDto
  status: 200
}

export type editWorkspaceResponse404 = {
  data: Problem
  status: 404
}

export type editWorkspaceResponseSuccess = (editWorkspaceResponse200) & {
  headers: Headers;
};
export type editWorkspaceResponseError = (editWorkspaceResponse404) & {
  headers: Headers;
};

export type editWorkspaceResponse = (editWorkspaceResponseSuccess | editWorkspaceResponseError)

export const getEditWorkspaceUrl = (tenantId: string,
    workspaceId: number,) => {




  return `/${tenantId}/workspaces/${workspaceId}`
}

/**
 * @summary Atualiza um workspace por ID
 */
export const editWorkspace = async (tenantId: string,
    workspaceId: number,
    workspaceInputDto: WorkspaceInputDto, options?: RequestInit): Promise<editWorkspaceResponse> => {

  return customInstanceDocumentos<editWorkspaceResponse>(getEditWorkspaceUrl(tenantId,workspaceId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(workspaceInputDto)
  }
);}




export const getEditWorkspaceMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editWorkspace>>, TError,{tenantId: string;workspaceId: number;data: WorkspaceInputDto}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof editWorkspace>>, TError,{tenantId: string;workspaceId: number;data: WorkspaceInputDto}, TContext> => {

const mutationKey = ['editWorkspace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editWorkspace>>, {tenantId: string;workspaceId: number;data: WorkspaceInputDto}> = (props) => {
          const {tenantId,workspaceId,data} = props ?? {};

          return  editWorkspace(tenantId,workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditWorkspaceMutationResult = NonNullable<Awaited<ReturnType<typeof editWorkspace>>>
    export type EditWorkspaceMutationBody = WorkspaceInputDto
    export type EditWorkspaceMutationError = Problem

    /**
 * @summary Atualiza um workspace por ID
 */
export const useEditWorkspace = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editWorkspace>>, TError,{tenantId: string;workspaceId: number;data: WorkspaceInputDto}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editWorkspace>>,
        TError,
        {tenantId: string;workspaceId: number;data: WorkspaceInputDto},
        TContext
      > => {
      return useMutation(getEditWorkspaceMutationOptions(options), queryClient);
    }

export type deleteWorkspaceResponse204 = {
  data: void
  status: 204
}

export type deleteWorkspaceResponse404 = {
  data: Problem
  status: 404
}

export type deleteWorkspaceResponseSuccess = (deleteWorkspaceResponse204) & {
  headers: Headers;
};
export type deleteWorkspaceResponseError = (deleteWorkspaceResponse404) & {
  headers: Headers;
};

export type deleteWorkspaceResponse = (deleteWorkspaceResponseSuccess | deleteWorkspaceResponseError)

export const getDeleteWorkspaceUrl = (tenantId: string,
    workspaceId: number,) => {




  return `/${tenantId}/workspaces/${workspaceId}`
}

/**
 * @summary Exclui um workspace por ID
 */
export const deleteWorkspace = async (tenantId: string,
    workspaceId: number, options?: RequestInit): Promise<deleteWorkspaceResponse> => {

  return customInstanceDocumentos<deleteWorkspaceResponse>(getDeleteWorkspaceUrl(tenantId,workspaceId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteWorkspaceMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspace>>, TError,{tenantId: string;workspaceId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspace>>, TError,{tenantId: string;workspaceId: number}, TContext> => {

const mutationKey = ['deleteWorkspace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkspace>>, {tenantId: string;workspaceId: number}> = (props) => {
          const {tenantId,workspaceId} = props ?? {};

          return  deleteWorkspace(tenantId,workspaceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkspaceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkspace>>>

    export type DeleteWorkspaceMutationError = Problem

    /**
 * @summary Exclui um workspace por ID
 */
export const useDeleteWorkspace = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspace>>, TError,{tenantId: string;workspaceId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkspace>>,
        TError,
        {tenantId: string;workspaceId: number},
        TContext
      > => {
      return useMutation(getDeleteWorkspaceMutationOptions(options), queryClient);
    }

export type denyDeleteRequestResponse204 = {
  data: Problem
  status: 204
}

export type denyDeleteRequestResponse404 = {
  data: Problem
  status: 404
}

export type denyDeleteRequestResponseSuccess = (denyDeleteRequestResponse204) & {
  headers: Headers;
};
export type denyDeleteRequestResponseError = (denyDeleteRequestResponse404) & {
  headers: Headers;
};

export type denyDeleteRequestResponse = (denyDeleteRequestResponseSuccess | denyDeleteRequestResponseError)

export const getDenyDeleteRequestUrl = (tenantId: string,
    pendingDocumentId: number,) => {




  return `/${tenantId}/pending-documents/${pendingDocumentId}/deny-delete-request`
}

/**
 * @summary Nega solicitação de exclusão do documento
 */
export const denyDeleteRequest = async (tenantId: string,
    pendingDocumentId: number,
    pendingDocumentDenyInput: PendingDocumentDenyInput, options?: RequestInit): Promise<denyDeleteRequestResponse> => {

  return customInstanceDocumentos<denyDeleteRequestResponse>(getDenyDeleteRequestUrl(tenantId,pendingDocumentId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pendingDocumentDenyInput)
  }
);}




export const getDenyDeleteRequestMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof denyDeleteRequest>>, TError,{tenantId: string;pendingDocumentId: number;data: PendingDocumentDenyInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof denyDeleteRequest>>, TError,{tenantId: string;pendingDocumentId: number;data: PendingDocumentDenyInput}, TContext> => {

const mutationKey = ['denyDeleteRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof denyDeleteRequest>>, {tenantId: string;pendingDocumentId: number;data: PendingDocumentDenyInput}> = (props) => {
          const {tenantId,pendingDocumentId,data} = props ?? {};

          return  denyDeleteRequest(tenantId,pendingDocumentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DenyDeleteRequestMutationResult = NonNullable<Awaited<ReturnType<typeof denyDeleteRequest>>>
    export type DenyDeleteRequestMutationBody = PendingDocumentDenyInput
    export type DenyDeleteRequestMutationError = Problem

    /**
 * @summary Nega solicitação de exclusão do documento
 */
export const useDenyDeleteRequest = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof denyDeleteRequest>>, TError,{tenantId: string;pendingDocumentId: number;data: PendingDocumentDenyInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof denyDeleteRequest>>,
        TError,
        {tenantId: string;pendingDocumentId: number;data: PendingDocumentDenyInput},
        TContext
      > => {
      return useMutation(getDenyDeleteRequestMutationOptions(options), queryClient);
    }

export type findFolderResponse404 = {
  data: Problem
  status: 404
}

;
export type findFolderResponseError = (findFolderResponse404) & {
  headers: Headers;
};

export type findFolderResponse = (findFolderResponseError)

export const getFindFolderUrl = (tenantId: string,
    pastaId: number,) => {




  return `/${tenantId}/folders/${pastaId}`
}

/**
 * @summary Busca uma pasta por ID
 */
export const findFolder = async (tenantId: string,
    pastaId: number, options?: RequestInit): Promise<findFolderResponse> => {

  return customInstanceDocumentos<findFolderResponse>(getFindFolderUrl(tenantId,pastaId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindFolderQueryKey = (tenantId: string,
    pastaId: number,) => {
    return [
    `/${tenantId}/folders/${pastaId}`
    ] as const;
    }


export const getFindFolderQueryOptions = <TData = Awaited<ReturnType<typeof findFolder>>, TError = Problem>(tenantId: string,
    pastaId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFolder>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindFolderQueryKey(tenantId,pastaId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findFolder>>> = ({ signal }) => findFolder(tenantId,pastaId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && pastaId !== null && pastaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findFolder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindFolderQueryResult = NonNullable<Awaited<ReturnType<typeof findFolder>>>
export type FindFolderQueryError = Problem


export function useFindFolder<TData = Awaited<ReturnType<typeof findFolder>>, TError = Problem>(
 tenantId: string,
    pastaId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFolder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findFolder>>,
          TError,
          Awaited<ReturnType<typeof findFolder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindFolder<TData = Awaited<ReturnType<typeof findFolder>>, TError = Problem>(
 tenantId: string,
    pastaId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFolder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findFolder>>,
          TError,
          Awaited<ReturnType<typeof findFolder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindFolder<TData = Awaited<ReturnType<typeof findFolder>>, TError = Problem>(
 tenantId: string,
    pastaId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFolder>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca uma pasta por ID
 */

export function useFindFolder<TData = Awaited<ReturnType<typeof findFolder>>, TError = Problem>(
 tenantId: string,
    pastaId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFolder>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindFolderQueryOptions(tenantId,pastaId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editFolderResponse200 = {
  data: DocumentDto
  status: 200
}

export type editFolderResponse404 = {
  data: Problem
  status: 404
}

export type editFolderResponseSuccess = (editFolderResponse200) & {
  headers: Headers;
};
export type editFolderResponseError = (editFolderResponse404) & {
  headers: Headers;
};

export type editFolderResponse = (editFolderResponseSuccess | editFolderResponseError)

export const getEditFolderUrl = (tenantId: string,
    pastaId: number,) => {




  return `/${tenantId}/folders/${pastaId}`
}

/**
 * @summary Atualiza uma pasta por ID
 */
export const editFolder = async (tenantId: string,
    pastaId: number,
    folderInputDto: FolderInputDto, options?: RequestInit): Promise<editFolderResponse> => {

  return customInstanceDocumentos<editFolderResponse>(getEditFolderUrl(tenantId,pastaId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(folderInputDto)
  }
);}




export const getEditFolderMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editFolder>>, TError,{tenantId: string;pastaId: number;data: FolderInputDto}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof editFolder>>, TError,{tenantId: string;pastaId: number;data: FolderInputDto}, TContext> => {

const mutationKey = ['editFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editFolder>>, {tenantId: string;pastaId: number;data: FolderInputDto}> = (props) => {
          const {tenantId,pastaId,data} = props ?? {};

          return  editFolder(tenantId,pastaId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditFolderMutationResult = NonNullable<Awaited<ReturnType<typeof editFolder>>>
    export type EditFolderMutationBody = FolderInputDto
    export type EditFolderMutationError = Problem

    /**
 * @summary Atualiza uma pasta por ID
 */
export const useEditFolder = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editFolder>>, TError,{tenantId: string;pastaId: number;data: FolderInputDto}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editFolder>>,
        TError,
        {tenantId: string;pastaId: number;data: FolderInputDto},
        TContext
      > => {
      return useMutation(getEditFolderMutationOptions(options), queryClient);
    }

export type deleteFolderResponse204 = {
  data: void
  status: 204
}

export type deleteFolderResponse404 = {
  data: Problem
  status: 404
}

export type deleteFolderResponseSuccess = (deleteFolderResponse204) & {
  headers: Headers;
};
export type deleteFolderResponseError = (deleteFolderResponse404) & {
  headers: Headers;
};

export type deleteFolderResponse = (deleteFolderResponseSuccess | deleteFolderResponseError)

export const getDeleteFolderUrl = (tenantId: string,
    pastaId: number,) => {




  return `/${tenantId}/folders/${pastaId}`
}

/**
 * @summary Exclui uma pasta por ID
 */
export const deleteFolder = async (tenantId: string,
    pastaId: number, options?: RequestInit): Promise<deleteFolderResponse> => {

  return customInstanceDocumentos<deleteFolderResponse>(getDeleteFolderUrl(tenantId,pastaId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteFolderMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,{tenantId: string;pastaId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,{tenantId: string;pastaId: number}, TContext> => {

const mutationKey = ['deleteFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFolder>>, {tenantId: string;pastaId: number}> = (props) => {
          const {tenantId,pastaId} = props ?? {};

          return  deleteFolder(tenantId,pastaId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFolderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFolder>>>

    export type DeleteFolderMutationError = Problem

    /**
 * @summary Exclui uma pasta por ID
 */
export const useDeleteFolder = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,{tenantId: string;pastaId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFolder>>,
        TError,
        {tenantId: string;pastaId: number},
        TContext
      > => {
      return useMutation(getDeleteFolderMutationOptions(options), queryClient);
    }

export type restoreExcludedDocumentResponse200 = {
  data: DocumentWithAllPropertiesDto
  status: 200
}

export type restoreExcludedDocumentResponseSuccess = (restoreExcludedDocumentResponse200) & {
  headers: Headers;
};
;

export type restoreExcludedDocumentResponse = (restoreExcludedDocumentResponseSuccess)

export const getRestoreExcludedDocumentUrl = (tenantId: string,
    documentId: number,) => {




  return `/${tenantId}/documents/${documentId}/restore-request`
}

/**
 * @summary Cria uma solicitação de restauração do documento excluido
 */
export const restoreExcludedDocument = async (tenantId: string,
    documentId: number,
    reasonRequestDto: ReasonRequestDto, options?: RequestInit): Promise<restoreExcludedDocumentResponse> => {

  return customInstanceDocumentos<restoreExcludedDocumentResponse>(getRestoreExcludedDocumentUrl(tenantId,documentId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reasonRequestDto)
  }
);}




export const getRestoreExcludedDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreExcludedDocument>>, TError,{tenantId: string;documentId: number;data: ReasonRequestDto}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreExcludedDocument>>, TError,{tenantId: string;documentId: number;data: ReasonRequestDto}, TContext> => {

const mutationKey = ['restoreExcludedDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreExcludedDocument>>, {tenantId: string;documentId: number;data: ReasonRequestDto}> = (props) => {
          const {tenantId,documentId,data} = props ?? {};

          return  restoreExcludedDocument(tenantId,documentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreExcludedDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof restoreExcludedDocument>>>
    export type RestoreExcludedDocumentMutationBody = ReasonRequestDto
    export type RestoreExcludedDocumentMutationError = unknown

    /**
 * @summary Cria uma solicitação de restauração do documento excluido
 */
export const useRestoreExcludedDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreExcludedDocument>>, TError,{tenantId: string;documentId: number;data: ReasonRequestDto}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restoreExcludedDocument>>,
        TError,
        {tenantId: string;documentId: number;data: ReasonRequestDto},
        TContext
      > => {
      return useMutation(getRestoreExcludedDocumentMutationOptions(options), queryClient);
    }

export type createDeleteRequestResponse200 = {
  data: PendingDocumentDto
  status: 200
}

export type createDeleteRequestResponseSuccess = (createDeleteRequestResponse200) & {
  headers: Headers;
};
;

export type createDeleteRequestResponse = (createDeleteRequestResponseSuccess)

export const getCreateDeleteRequestUrl = (tenantId: string,
    documentId: number,) => {




  return `/${tenantId}/documents/${documentId}/delete-request`
}

/**
 * @summary Cria uma solicitação de exclusão do documento
 */
export const createDeleteRequest = async (tenantId: string,
    documentId: number,
    reasonRequestDto: ReasonRequestDto, options?: RequestInit): Promise<createDeleteRequestResponse> => {

  return customInstanceDocumentos<createDeleteRequestResponse>(getCreateDeleteRequestUrl(tenantId,documentId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reasonRequestDto)
  }
);}




export const getCreateDeleteRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDeleteRequest>>, TError,{tenantId: string;documentId: number;data: ReasonRequestDto}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof createDeleteRequest>>, TError,{tenantId: string;documentId: number;data: ReasonRequestDto}, TContext> => {

const mutationKey = ['createDeleteRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDeleteRequest>>, {tenantId: string;documentId: number;data: ReasonRequestDto}> = (props) => {
          const {tenantId,documentId,data} = props ?? {};

          return  createDeleteRequest(tenantId,documentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDeleteRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createDeleteRequest>>>
    export type CreateDeleteRequestMutationBody = ReasonRequestDto
    export type CreateDeleteRequestMutationError = unknown

    /**
 * @summary Cria uma solicitação de exclusão do documento
 */
export const useCreateDeleteRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDeleteRequest>>, TError,{tenantId: string;documentId: number;data: ReasonRequestDto}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDeleteRequest>>,
        TError,
        {tenantId: string;documentId: number;data: ReasonRequestDto},
        TContext
      > => {
      return useMutation(getCreateDeleteRequestMutationOptions(options), queryClient);
    }

export type findDocumentResponse404 = {
  data: Problem
  status: 404
}

;
export type findDocumentResponseError = (findDocumentResponse404) & {
  headers: Headers;
};

export type findDocumentResponse = (findDocumentResponseError)

export const getFindDocumentUrl = (tenantId: string,
    documentId: number,) => {




  return `/${tenantId}/documents/${documentId}`
}

/**
 * @summary Busca uma documento por ID
 */
export const findDocument = async (tenantId: string,
    documentId: number, options?: RequestInit): Promise<findDocumentResponse> => {

  return customInstanceDocumentos<findDocumentResponse>(getFindDocumentUrl(tenantId,documentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindDocumentQueryKey = (tenantId: string,
    documentId: number,) => {
    return [
    `/${tenantId}/documents/${documentId}`
    ] as const;
    }


export const getFindDocumentQueryOptions = <TData = Awaited<ReturnType<typeof findDocument>>, TError = Problem>(tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindDocumentQueryKey(tenantId,documentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findDocument>>> = ({ signal }) => findDocument(tenantId,documentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof findDocument>>>
export type FindDocumentQueryError = Problem


export function useFindDocument<TData = Awaited<ReturnType<typeof findDocument>>, TError = Problem>(
 tenantId: string,
    documentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findDocument>>,
          TError,
          Awaited<ReturnType<typeof findDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindDocument<TData = Awaited<ReturnType<typeof findDocument>>, TError = Problem>(
 tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findDocument>>,
          TError,
          Awaited<ReturnType<typeof findDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindDocument<TData = Awaited<ReturnType<typeof findDocument>>, TError = Problem>(
 tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca uma documento por ID
 */

export function useFindDocument<TData = Awaited<ReturnType<typeof findDocument>>, TError = Problem>(
 tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindDocumentQueryOptions(tenantId,documentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editDocumentResponse200 = {
  data: DocumentWithAllPropertiesDto
  status: 200
}

export type editDocumentResponse404 = {
  data: Problem
  status: 404
}

export type editDocumentResponseSuccess = (editDocumentResponse200) & {
  headers: Headers;
};
export type editDocumentResponseError = (editDocumentResponse404) & {
  headers: Headers;
};

export type editDocumentResponse = (editDocumentResponseSuccess | editDocumentResponseError)

export const getEditDocumentUrl = (tenantId: string,
    documentId: number,) => {




  return `/${tenantId}/documents/${documentId}`
}

/**
 * @summary Atualiza um documento por ID
 */
export const editDocument = async (tenantId: string,
    documentId: number,
    editDocumentBody?: EditDocumentBody, options?: RequestInit): Promise<editDocumentResponse> => {
    const formData = new FormData();
if(editDocumentBody?.documentInput !== undefined) {
 formData.append(`documentInput`, JSON.stringify(editDocumentBody.documentInput));
 }
if(editDocumentBody?.files !== undefined) {
 formData.append(`files`, editDocumentBody.files);
 }

  return customInstanceDocumentos<editDocumentResponse>(getEditDocumentUrl(tenantId,documentId),
  {
    ...options,
    method: 'PUT'
    ,
    body: formData
  }
);}




export const getEditDocumentMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editDocument>>, TError,{tenantId: string;documentId: number;data?: EditDocumentBody}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof editDocument>>, TError,{tenantId: string;documentId: number;data?: EditDocumentBody}, TContext> => {

const mutationKey = ['editDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editDocument>>, {tenantId: string;documentId: number;data?: EditDocumentBody}> = (props) => {
          const {tenantId,documentId,data} = props ?? {};

          return  editDocument(tenantId,documentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof editDocument>>>
    export type EditDocumentMutationBody = EditDocumentBody | undefined
    export type EditDocumentMutationError = Problem

    /**
 * @summary Atualiza um documento por ID
 */
export const useEditDocument = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editDocument>>, TError,{tenantId: string;documentId: number;data?: EditDocumentBody}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editDocument>>,
        TError,
        {tenantId: string;documentId: number;data?: EditDocumentBody},
        TContext
      > => {
      return useMutation(getEditDocumentMutationOptions(options), queryClient);
    }

export type deleteDocumentResponse204 = {
  data: void
  status: 204
}

export type deleteDocumentResponse404 = {
  data: Problem
  status: 404
}

export type deleteDocumentResponseSuccess = (deleteDocumentResponse204) & {
  headers: Headers;
};
export type deleteDocumentResponseError = (deleteDocumentResponse404) & {
  headers: Headers;
};

export type deleteDocumentResponse = (deleteDocumentResponseSuccess | deleteDocumentResponseError)

export const getDeleteDocumentUrl = (tenantId: string,
    documentId: number,) => {




  return `/${tenantId}/documents/${documentId}`
}

/**
 * @summary Exclui uma documento por ID
 */
export const deleteDocument = async (tenantId: string,
    documentId: number, options?: RequestInit): Promise<deleteDocumentResponse> => {

  return customInstanceDocumentos<deleteDocumentResponse>(getDeleteDocumentUrl(tenantId,documentId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteDocumentMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,{tenantId: string;documentId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,{tenantId: string;documentId: number}, TContext> => {

const mutationKey = ['deleteDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDocument>>, {tenantId: string;documentId: number}> = (props) => {
          const {tenantId,documentId} = props ?? {};

          return  deleteDocument(tenantId,documentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDocument>>>

    export type DeleteDocumentMutationError = Problem

    /**
 * @summary Exclui uma documento por ID
 */
export const useDeleteDocument = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,{tenantId: string;documentId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDocument>>,
        TError,
        {tenantId: string;documentId: number},
        TContext
      > => {
      return useMutation(getDeleteDocumentMutationOptions(options), queryClient);
    }

export type createSubDocumentTypeExternalLinkResponse201 = {
  data: SubDocumentTypeExternalLinkDto
  status: 201
}

export type createSubDocumentTypeExternalLinkResponseSuccess = (createSubDocumentTypeExternalLinkResponse201) & {
  headers: Headers;
};
;

export type createSubDocumentTypeExternalLinkResponse = (createSubDocumentTypeExternalLinkResponseSuccess)

export const getCreateSubDocumentTypeExternalLinkUrl = (tenant: string,
    subDocumentTypeId: number,) => {




  return `/${tenant}/sub-document-types/${subDocumentTypeId}/external-links`
}

/**
 * @summary Cria uma referência externa de sub tipo de documento
 */
export const createSubDocumentTypeExternalLink = async (tenant: string,
    subDocumentTypeId: number,
    subDocumentTypeExternalLinkInput: SubDocumentTypeExternalLinkInput, options?: RequestInit): Promise<createSubDocumentTypeExternalLinkResponse> => {

  return customInstanceDocumentos<createSubDocumentTypeExternalLinkResponse>(getCreateSubDocumentTypeExternalLinkUrl(tenant,subDocumentTypeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(subDocumentTypeExternalLinkInput)
  }
);}




export const getCreateSubDocumentTypeExternalLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubDocumentTypeExternalLink>>, TError,{tenant: string;subDocumentTypeId: number;data: SubDocumentTypeExternalLinkInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof createSubDocumentTypeExternalLink>>, TError,{tenant: string;subDocumentTypeId: number;data: SubDocumentTypeExternalLinkInput}, TContext> => {

const mutationKey = ['createSubDocumentTypeExternalLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSubDocumentTypeExternalLink>>, {tenant: string;subDocumentTypeId: number;data: SubDocumentTypeExternalLinkInput}> = (props) => {
          const {tenant,subDocumentTypeId,data} = props ?? {};

          return  createSubDocumentTypeExternalLink(tenant,subDocumentTypeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSubDocumentTypeExternalLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createSubDocumentTypeExternalLink>>>
    export type CreateSubDocumentTypeExternalLinkMutationBody = SubDocumentTypeExternalLinkInput
    export type CreateSubDocumentTypeExternalLinkMutationError = unknown

    /**
 * @summary Cria uma referência externa de sub tipo de documento
 */
export const useCreateSubDocumentTypeExternalLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubDocumentTypeExternalLink>>, TError,{tenant: string;subDocumentTypeId: number;data: SubDocumentTypeExternalLinkInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSubDocumentTypeExternalLink>>,
        TError,
        {tenant: string;subDocumentTypeId: number;data: SubDocumentTypeExternalLinkInput},
        TContext
      > => {
      return useMutation(getCreateSubDocumentTypeExternalLinkMutationOptions(options), queryClient);
    }

export type listSubDocumentTypeResponse200 = {
  data: PageSubDocumentTypeDto
  status: 200
}

export type listSubDocumentTypeResponseSuccess = (listSubDocumentTypeResponse200) & {
  headers: Headers;
};
;

export type listSubDocumentTypeResponse = (listSubDocumentTypeResponseSuccess)

export const getListSubDocumentTypeUrl = (tenant: string,
    params?: ListSubDocumentTypeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenant}/sub-document-types?${stringifiedParams}` : `/${tenant}/sub-document-types`
}

/**
 * @summary Lista os sub tipos de documentos
 */
export const listSubDocumentType = async (tenant: string,
    params?: ListSubDocumentTypeParams, options?: RequestInit): Promise<listSubDocumentTypeResponse> => {

  return customInstanceDocumentos<listSubDocumentTypeResponse>(getListSubDocumentTypeUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSubDocumentTypeQueryKey = (tenant: string,
    params?: ListSubDocumentTypeParams,) => {
    return [
    `/${tenant}/sub-document-types`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSubDocumentTypeQueryOptions = <TData = Awaited<ReturnType<typeof listSubDocumentType>>, TError = unknown>(tenant: string,
    params?: ListSubDocumentTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubDocumentType>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSubDocumentTypeQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSubDocumentType>>> = ({ signal }) => listSubDocumentType(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSubDocumentType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSubDocumentTypeQueryResult = NonNullable<Awaited<ReturnType<typeof listSubDocumentType>>>
export type ListSubDocumentTypeQueryError = unknown


export function useListSubDocumentType<TData = Awaited<ReturnType<typeof listSubDocumentType>>, TError = unknown>(
 tenant: string,
    params: undefined |  ListSubDocumentTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubDocumentType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSubDocumentType>>,
          TError,
          Awaited<ReturnType<typeof listSubDocumentType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSubDocumentType<TData = Awaited<ReturnType<typeof listSubDocumentType>>, TError = unknown>(
 tenant: string,
    params?: ListSubDocumentTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubDocumentType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSubDocumentType>>,
          TError,
          Awaited<ReturnType<typeof listSubDocumentType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSubDocumentType<TData = Awaited<ReturnType<typeof listSubDocumentType>>, TError = unknown>(
 tenant: string,
    params?: ListSubDocumentTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubDocumentType>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os sub tipos de documentos
 */

export function useListSubDocumentType<TData = Awaited<ReturnType<typeof listSubDocumentType>>, TError = unknown>(
 tenant: string,
    params?: ListSubDocumentTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubDocumentType>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSubDocumentTypeQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createSubDocumentTypeResponse201 = {
  data: SubDocumentTypeDto
  status: 201
}

export type createSubDocumentTypeResponseSuccess = (createSubDocumentTypeResponse201) & {
  headers: Headers;
};
;

export type createSubDocumentTypeResponse = (createSubDocumentTypeResponseSuccess)

export const getCreateSubDocumentTypeUrl = (tenant: string,) => {




  return `/${tenant}/sub-document-types`
}

/**
 * @summary Cria um sub tipo de documento
 */
export const createSubDocumentType = async (tenant: string,
    subDocumentTypeInput: SubDocumentTypeInput, options?: RequestInit): Promise<createSubDocumentTypeResponse> => {

  return customInstanceDocumentos<createSubDocumentTypeResponse>(getCreateSubDocumentTypeUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(subDocumentTypeInput)
  }
);}




export const getCreateSubDocumentTypeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubDocumentType>>, TError,{tenant: string;data: SubDocumentTypeInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof createSubDocumentType>>, TError,{tenant: string;data: SubDocumentTypeInput}, TContext> => {

const mutationKey = ['createSubDocumentType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSubDocumentType>>, {tenant: string;data: SubDocumentTypeInput}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createSubDocumentType(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSubDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof createSubDocumentType>>>
    export type CreateSubDocumentTypeMutationBody = SubDocumentTypeInput
    export type CreateSubDocumentTypeMutationError = unknown

    /**
 * @summary Cria um sub tipo de documento
 */
export const useCreateSubDocumentType = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubDocumentType>>, TError,{tenant: string;data: SubDocumentTypeInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSubDocumentType>>,
        TError,
        {tenant: string;data: SubDocumentTypeInput},
        TContext
      > => {
      return useMutation(getCreateSubDocumentTypeMutationOptions(options), queryClient);
    }

export type listArchivalClassificationPostResponse200 = {
  data: PageArchivalClassificationDto
  status: 200
}

export type listArchivalClassificationPostResponseSuccess = (listArchivalClassificationPostResponse200) & {
  headers: Headers;
};
;

export type listArchivalClassificationPostResponse = (listArchivalClassificationPostResponseSuccess)

export const getListArchivalClassificationPostUrl = (tenant: string,
    params?: ListArchivalClassificationPostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenant}/archival-classifications/search?${stringifiedParams}` : `/${tenant}/archival-classifications/search`
}

/**
 * @summary Lista as classificações arquivísticas
 */
export const listArchivalClassificationPost = async (tenant: string,
    archivalClassificationFilter: ArchivalClassificationFilter,
    params?: ListArchivalClassificationPostParams, options?: RequestInit): Promise<listArchivalClassificationPostResponse> => {

  return customInstanceDocumentos<listArchivalClassificationPostResponse>(getListArchivalClassificationPostUrl(tenant,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(archivalClassificationFilter)
  }
);}




export const getListArchivalClassificationPostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listArchivalClassificationPost>>, TError,{tenant: string;data: ArchivalClassificationFilter;params?: ListArchivalClassificationPostParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof listArchivalClassificationPost>>, TError,{tenant: string;data: ArchivalClassificationFilter;params?: ListArchivalClassificationPostParams}, TContext> => {

const mutationKey = ['listArchivalClassificationPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof listArchivalClassificationPost>>, {tenant: string;data: ArchivalClassificationFilter;params?: ListArchivalClassificationPostParams}> = (props) => {
          const {tenant,data,params} = props ?? {};

          return  listArchivalClassificationPost(tenant,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ListArchivalClassificationPostMutationResult = NonNullable<Awaited<ReturnType<typeof listArchivalClassificationPost>>>
    export type ListArchivalClassificationPostMutationBody = ArchivalClassificationFilter
    export type ListArchivalClassificationPostMutationError = unknown

    /**
 * @summary Lista as classificações arquivísticas
 */
export const useListArchivalClassificationPost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listArchivalClassificationPost>>, TError,{tenant: string;data: ArchivalClassificationFilter;params?: ListArchivalClassificationPostParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof listArchivalClassificationPost>>,
        TError,
        {tenant: string;data: ArchivalClassificationFilter;params?: ListArchivalClassificationPostParams},
        TContext
      > => {
      return useMutation(getListArchivalClassificationPostMutationOptions(options), queryClient);
    }

export type importArchivalClassificationResponse200 = {
  data: ArchivalClassificationImportResultDto[]
  status: 200
}

export type importArchivalClassificationResponseSuccess = (importArchivalClassificationResponse200) & {
  headers: Headers;
};
;

export type importArchivalClassificationResponse = (importArchivalClassificationResponseSuccess)

export const getImportArchivalClassificationUrl = (tenant: string,
    params: ImportArchivalClassificationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenant}/archival-classifications/import?${stringifiedParams}` : `/${tenant}/archival-classifications/import`
}

/**
 * @summary Importa uma ou vaŕias classificações arquivisticas
 */
export const importArchivalClassification = async (tenant: string,
    params: ImportArchivalClassificationParams,
    formArchivalClassificationImportInput?: FormArchivalClassificationImportInput, options?: RequestInit): Promise<importArchivalClassificationResponse> => {
    const formData = new FormData();

  return customInstanceDocumentos<importArchivalClassificationResponse>(getImportArchivalClassificationUrl(tenant,params),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getImportArchivalClassificationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importArchivalClassification>>, TError,{tenant: string;params: ImportArchivalClassificationParams;data?: FormArchivalClassificationImportInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof importArchivalClassification>>, TError,{tenant: string;params: ImportArchivalClassificationParams;data?: FormArchivalClassificationImportInput}, TContext> => {

const mutationKey = ['importArchivalClassification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importArchivalClassification>>, {tenant: string;params: ImportArchivalClassificationParams;data?: FormArchivalClassificationImportInput}> = (props) => {
          const {tenant,params,data} = props ?? {};

          return  importArchivalClassification(tenant,params,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportArchivalClassificationMutationResult = NonNullable<Awaited<ReturnType<typeof importArchivalClassification>>>
    export type ImportArchivalClassificationMutationBody = FormArchivalClassificationImportInput | undefined
    export type ImportArchivalClassificationMutationError = unknown

    /**
 * @summary Importa uma ou vaŕias classificações arquivisticas
 */
export const useImportArchivalClassification = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importArchivalClassification>>, TError,{tenant: string;params: ImportArchivalClassificationParams;data?: FormArchivalClassificationImportInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importArchivalClassification>>,
        TError,
        {tenant: string;params: ImportArchivalClassificationParams;data?: FormArchivalClassificationImportInput},
        TContext
      > => {
      return useMutation(getImportArchivalClassificationMutationOptions(options), queryClient);
    }

export type listArchivalClassificationResponse200 = {
  data: PageArchivalClassificationDto
  status: 200
}

export type listArchivalClassificationResponseSuccess = (listArchivalClassificationResponse200) & {
  headers: Headers;
};
;

export type listArchivalClassificationResponse = (listArchivalClassificationResponseSuccess)

export const getListArchivalClassificationUrl = (tenant: string,
    params?: ListArchivalClassificationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenant}/archival-classifications?${stringifiedParams}` : `/${tenant}/archival-classifications`
}

/**
 * @summary Lista as classificações arquivísticas
 */
export const listArchivalClassification = async (tenant: string,
    params?: ListArchivalClassificationParams, options?: RequestInit): Promise<listArchivalClassificationResponse> => {

  return customInstanceDocumentos<listArchivalClassificationResponse>(getListArchivalClassificationUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListArchivalClassificationQueryKey = (tenant: string,
    params?: ListArchivalClassificationParams,) => {
    return [
    `/${tenant}/archival-classifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListArchivalClassificationQueryOptions = <TData = Awaited<ReturnType<typeof listArchivalClassification>>, TError = unknown>(tenant: string,
    params?: ListArchivalClassificationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArchivalClassification>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListArchivalClassificationQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listArchivalClassification>>> = ({ signal }) => listArchivalClassification(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listArchivalClassification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListArchivalClassificationQueryResult = NonNullable<Awaited<ReturnType<typeof listArchivalClassification>>>
export type ListArchivalClassificationQueryError = unknown


export function useListArchivalClassification<TData = Awaited<ReturnType<typeof listArchivalClassification>>, TError = unknown>(
 tenant: string,
    params: undefined |  ListArchivalClassificationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArchivalClassification>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listArchivalClassification>>,
          TError,
          Awaited<ReturnType<typeof listArchivalClassification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListArchivalClassification<TData = Awaited<ReturnType<typeof listArchivalClassification>>, TError = unknown>(
 tenant: string,
    params?: ListArchivalClassificationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArchivalClassification>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listArchivalClassification>>,
          TError,
          Awaited<ReturnType<typeof listArchivalClassification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListArchivalClassification<TData = Awaited<ReturnType<typeof listArchivalClassification>>, TError = unknown>(
 tenant: string,
    params?: ListArchivalClassificationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArchivalClassification>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as classificações arquivísticas
 */

export function useListArchivalClassification<TData = Awaited<ReturnType<typeof listArchivalClassification>>, TError = unknown>(
 tenant: string,
    params?: ListArchivalClassificationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArchivalClassification>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListArchivalClassificationQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createArchivalClassificationResponse201 = {
  data: ArchivalClassificationDto
  status: 201
}

export type createArchivalClassificationResponse400 = {
  data: Problem
  status: 400
}

export type createArchivalClassificationResponseSuccess = (createArchivalClassificationResponse201) & {
  headers: Headers;
};
export type createArchivalClassificationResponseError = (createArchivalClassificationResponse400) & {
  headers: Headers;
};

export type createArchivalClassificationResponse = (createArchivalClassificationResponseSuccess | createArchivalClassificationResponseError)

export const getCreateArchivalClassificationUrl = (tenant: string,) => {




  return `/${tenant}/archival-classifications`
}

/**
 * @summary Cria uma classificação arquivística
 */
export const createArchivalClassification = async (tenant: string,
    archivalClassificationInput: ArchivalClassificationInput, options?: RequestInit): Promise<createArchivalClassificationResponse> => {

  return customInstanceDocumentos<createArchivalClassificationResponse>(getCreateArchivalClassificationUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(archivalClassificationInput)
  }
);}




export const getCreateArchivalClassificationMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createArchivalClassification>>, TError,{tenant: string;data: ArchivalClassificationInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof createArchivalClassification>>, TError,{tenant: string;data: ArchivalClassificationInput}, TContext> => {

const mutationKey = ['createArchivalClassification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createArchivalClassification>>, {tenant: string;data: ArchivalClassificationInput}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createArchivalClassification(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateArchivalClassificationMutationResult = NonNullable<Awaited<ReturnType<typeof createArchivalClassification>>>
    export type CreateArchivalClassificationMutationBody = ArchivalClassificationInput
    export type CreateArchivalClassificationMutationError = Problem

    /**
 * @summary Cria uma classificação arquivística
 */
export const useCreateArchivalClassification = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createArchivalClassification>>, TError,{tenant: string;data: ArchivalClassificationInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createArchivalClassification>>,
        TError,
        {tenant: string;data: ArchivalClassificationInput},
        TContext
      > => {
      return useMutation(getCreateArchivalClassificationMutationOptions(options), queryClient);
    }

export type findWorkspaceByNameResponse200 = {
  data: WorkspaceDto
  status: 200
}

export type findWorkspaceByNameResponseSuccess = (findWorkspaceByNameResponse200) & {
  headers: Headers;
};
;

export type findWorkspaceByNameResponse = (findWorkspaceByNameResponseSuccess)

export const getFindWorkspaceByNameUrl = (tenantId: string,
    params: FindWorkspaceByNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/workspaces?${stringifiedParams}` : `/${tenantId}/workspaces`
}

/**
 * @summary Busca workspace pelo nome
 */
export const findWorkspaceByName = async (tenantId: string,
    params: FindWorkspaceByNameParams, options?: RequestInit): Promise<findWorkspaceByNameResponse> => {

  return customInstanceDocumentos<findWorkspaceByNameResponse>(getFindWorkspaceByNameUrl(tenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindWorkspaceByNameQueryKey = (tenantId: string,
    params?: FindWorkspaceByNameParams,) => {
    return [
    `/${tenantId}/workspaces`, ...(params ? [params] : [])
    ] as const;
    }


export const getFindWorkspaceByNameQueryOptions = <TData = Awaited<ReturnType<typeof findWorkspaceByName>>, TError = unknown>(tenantId: string,
    params: FindWorkspaceByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findWorkspaceByName>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindWorkspaceByNameQueryKey(tenantId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findWorkspaceByName>>> = ({ signal }) => findWorkspaceByName(tenantId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findWorkspaceByName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindWorkspaceByNameQueryResult = NonNullable<Awaited<ReturnType<typeof findWorkspaceByName>>>
export type FindWorkspaceByNameQueryError = unknown


export function useFindWorkspaceByName<TData = Awaited<ReturnType<typeof findWorkspaceByName>>, TError = unknown>(
 tenantId: string,
    params: FindWorkspaceByNameParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findWorkspaceByName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findWorkspaceByName>>,
          TError,
          Awaited<ReturnType<typeof findWorkspaceByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindWorkspaceByName<TData = Awaited<ReturnType<typeof findWorkspaceByName>>, TError = unknown>(
 tenantId: string,
    params: FindWorkspaceByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findWorkspaceByName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findWorkspaceByName>>,
          TError,
          Awaited<ReturnType<typeof findWorkspaceByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindWorkspaceByName<TData = Awaited<ReturnType<typeof findWorkspaceByName>>, TError = unknown>(
 tenantId: string,
    params: FindWorkspaceByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findWorkspaceByName>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca workspace pelo nome
 */

export function useFindWorkspaceByName<TData = Awaited<ReturnType<typeof findWorkspaceByName>>, TError = unknown>(
 tenantId: string,
    params: FindWorkspaceByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findWorkspaceByName>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindWorkspaceByNameQueryOptions(tenantId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createWorkspaceResponse201 = {
  data: WorkspaceDto
  status: 201
}

export type createWorkspaceResponseSuccess = (createWorkspaceResponse201) & {
  headers: Headers;
};
;

export type createWorkspaceResponse = (createWorkspaceResponseSuccess)

export const getCreateWorkspaceUrl = (tenantId: string,) => {




  return `/${tenantId}/workspaces`
}

/**
 * @summary Cria um workspace
 */
export const createWorkspace = async (tenantId: string,
    workspaceInputDto: WorkspaceInputDto, options?: RequestInit): Promise<createWorkspaceResponse> => {

  return customInstanceDocumentos<createWorkspaceResponse>(getCreateWorkspaceUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(workspaceInputDto)
  }
);}




export const getCreateWorkspaceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkspace>>, TError,{tenantId: string;data: WorkspaceInputDto}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkspace>>, TError,{tenantId: string;data: WorkspaceInputDto}, TContext> => {

const mutationKey = ['createWorkspace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkspace>>, {tenantId: string;data: WorkspaceInputDto}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  createWorkspace(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkspaceMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkspace>>>
    export type CreateWorkspaceMutationBody = WorkspaceInputDto
    export type CreateWorkspaceMutationError = unknown

    /**
 * @summary Cria um workspace
 */
export const useCreateWorkspace = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkspace>>, TError,{tenantId: string;data: WorkspaceInputDto}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWorkspace>>,
        TError,
        {tenantId: string;data: WorkspaceInputDto},
        TContext
      > => {
      return useMutation(getCreateWorkspaceMutationOptions(options), queryClient);
    }

export type electronicSignatureXadesResponse201 = {
  data: DigitalSignatureWithAllPropertiesDto
  status: 201
}

export type electronicSignatureXadesResponseSuccess = (electronicSignatureXadesResponse201) & {
  headers: Headers;
};
;

export type electronicSignatureXadesResponse = (electronicSignatureXadesResponseSuccess)

export const getElectronicSignatureXadesUrl = (tenantId: string,
    params: ElectronicSignatureXadesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/signatures/xades-electronic?${stringifiedParams}` : `/${tenantId}/signatures/xades-electronic`
}

/**
 * @summary Realiza a assinatura eletrônica usando XADES
 */
export const electronicSignatureXades = async (tenantId: string,
    params: ElectronicSignatureXadesParams,
    signatureXadesElectronicForm?: SignatureXadesElectronicForm, options?: RequestInit): Promise<electronicSignatureXadesResponse> => {
    const formData = new FormData();
if(signatureXadesElectronicForm?.elementToSignId !== undefined) {
 formData.append(`elementToSignId`, signatureXadesElectronicForm.elementToSignId);
 }
if(signatureXadesElectronicForm?.hasCarimboTempo !== undefined) {
 formData.append(`hasCarimboTempo`, signatureXadesElectronicForm.hasCarimboTempo.toString())
 }
if(signatureXadesElectronicForm?.signature !== undefined) {
 formData.append(`signature`, signatureXadesElectronicForm.signature);
 }

  return customInstanceDocumentos<electronicSignatureXadesResponse>(getElectronicSignatureXadesUrl(tenantId,params),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getElectronicSignatureXadesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof electronicSignatureXades>>, TError,{tenantId: string;params: ElectronicSignatureXadesParams;data?: SignatureXadesElectronicForm}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof electronicSignatureXades>>, TError,{tenantId: string;params: ElectronicSignatureXadesParams;data?: SignatureXadesElectronicForm}, TContext> => {

const mutationKey = ['electronicSignatureXades'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof electronicSignatureXades>>, {tenantId: string;params: ElectronicSignatureXadesParams;data?: SignatureXadesElectronicForm}> = (props) => {
          const {tenantId,params,data} = props ?? {};

          return  electronicSignatureXades(tenantId,params,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ElectronicSignatureXadesMutationResult = NonNullable<Awaited<ReturnType<typeof electronicSignatureXades>>>
    export type ElectronicSignatureXadesMutationBody = SignatureXadesElectronicForm | undefined
    export type ElectronicSignatureXadesMutationError = unknown

    /**
 * @summary Realiza a assinatura eletrônica usando XADES
 */
export const useElectronicSignatureXades = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof electronicSignatureXades>>, TError,{tenantId: string;params: ElectronicSignatureXadesParams;data?: SignatureXadesElectronicForm}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof electronicSignatureXades>>,
        TError,
        {tenantId: string;params: ElectronicSignatureXadesParams;data?: SignatureXadesElectronicForm},
        TContext
      > => {
      return useMutation(getElectronicSignatureXadesMutationOptions(options), queryClient);
    }

export type startSignatureXadesResponse200 = {
  data: SignatureStarterResultDto
  status: 200
}

export type startSignatureXadesResponseSuccess = (startSignatureXadesResponse200) & {
  headers: Headers;
};
;

export type startSignatureXadesResponse = (startSignatureXadesResponseSuccess)

export const getStartSignatureXadesUrl = (tenantId: string,
    params: StartSignatureXadesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/signatures/xades-digital/start?${stringifiedParams}` : `/${tenantId}/signatures/xades-digital/start`
}

/**
 * @summary Inicia processo de assinatura XADES
 */
export const startSignatureXades = async (tenantId: string,
    params: StartSignatureXadesParams,
    signatureXadesDigitalWithWebPkiInput?: SignatureXadesDigitalWithWebPkiInput, options?: RequestInit): Promise<startSignatureXadesResponse> => {
    const formData = new FormData();
if(signatureXadesDigitalWithWebPkiInput?.certificateBase64 !== undefined) {
 formData.append(`certificateBase64`, signatureXadesDigitalWithWebPkiInput.certificateBase64);
 }
if(signatureXadesDigitalWithWebPkiInput?.elementToSignId !== undefined) {
 formData.append(`elementToSignId`, signatureXadesDigitalWithWebPkiInput.elementToSignId);
 }
if(signatureXadesDigitalWithWebPkiInput?.hasCarimboTempo !== undefined) {
 formData.append(`hasCarimboTempo`, signatureXadesDigitalWithWebPkiInput.hasCarimboTempo.toString())
 }

  return customInstanceDocumentos<startSignatureXadesResponse>(getStartSignatureXadesUrl(tenantId,params),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getStartSignatureXadesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSignatureXades>>, TError,{tenantId: string;params: StartSignatureXadesParams;data?: SignatureXadesDigitalWithWebPkiInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof startSignatureXades>>, TError,{tenantId: string;params: StartSignatureXadesParams;data?: SignatureXadesDigitalWithWebPkiInput}, TContext> => {

const mutationKey = ['startSignatureXades'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startSignatureXades>>, {tenantId: string;params: StartSignatureXadesParams;data?: SignatureXadesDigitalWithWebPkiInput}> = (props) => {
          const {tenantId,params,data} = props ?? {};

          return  startSignatureXades(tenantId,params,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartSignatureXadesMutationResult = NonNullable<Awaited<ReturnType<typeof startSignatureXades>>>
    export type StartSignatureXadesMutationBody = SignatureXadesDigitalWithWebPkiInput | undefined
    export type StartSignatureXadesMutationError = unknown

    /**
 * @summary Inicia processo de assinatura XADES
 */
export const useStartSignatureXades = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSignatureXades>>, TError,{tenantId: string;params: StartSignatureXadesParams;data?: SignatureXadesDigitalWithWebPkiInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startSignatureXades>>,
        TError,
        {tenantId: string;params: StartSignatureXadesParams;data?: SignatureXadesDigitalWithWebPkiInput},
        TContext
      > => {
      return useMutation(getStartSignatureXadesMutationOptions(options), queryClient);
    }

export type finishSignatureXadesResponse201 = {
  data: DigitalSignatureWithAllPropertiesDto
  status: 201
}

export type finishSignatureXadesResponseSuccess = (finishSignatureXadesResponse201) & {
  headers: Headers;
};
;

export type finishSignatureXadesResponse = (finishSignatureXadesResponseSuccess)

export const getFinishSignatureXadesUrl = (tenantId: string,
    transferFileId: string,) => {




  return `/${tenantId}/signatures/xades-digital/finish/${transferFileId}`
}

/**
 * @summary Finaliza processo de assinatura XADES
 */
export const finishSignatureXades = async (tenantId: string,
    transferFileId: string,
    signatureXadesDigitalInput: SignatureXadesDigitalInput, options?: RequestInit): Promise<finishSignatureXadesResponse> => {

  return customInstanceDocumentos<finishSignatureXadesResponse>(getFinishSignatureXadesUrl(tenantId,transferFileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(signatureXadesDigitalInput)
  }
);}




export const getFinishSignatureXadesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSignatureXades>>, TError,{tenantId: string;transferFileId: string;data: SignatureXadesDigitalInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof finishSignatureXades>>, TError,{tenantId: string;transferFileId: string;data: SignatureXadesDigitalInput}, TContext> => {

const mutationKey = ['finishSignatureXades'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishSignatureXades>>, {tenantId: string;transferFileId: string;data: SignatureXadesDigitalInput}> = (props) => {
          const {tenantId,transferFileId,data} = props ?? {};

          return  finishSignatureXades(tenantId,transferFileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinishSignatureXadesMutationResult = NonNullable<Awaited<ReturnType<typeof finishSignatureXades>>>
    export type FinishSignatureXadesMutationBody = SignatureXadesDigitalInput
    export type FinishSignatureXadesMutationError = unknown

    /**
 * @summary Finaliza processo de assinatura XADES
 */
export const useFinishSignatureXades = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSignatureXades>>, TError,{tenantId: string;transferFileId: string;data: SignatureXadesDigitalInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof finishSignatureXades>>,
        TError,
        {tenantId: string;transferFileId: string;data: SignatureXadesDigitalInput},
        TContext
      > => {
      return useMutation(getFinishSignatureXadesMutationOptions(options), queryClient);
    }

export type electronicSignaturePadesResponse201 = {
  data: DigitalSignatureWithAllPropertiesDto
  status: 201
}

export type electronicSignaturePadesResponseSuccess = (electronicSignaturePadesResponse201) & {
  headers: Headers;
};
;

export type electronicSignaturePadesResponse = (electronicSignaturePadesResponseSuccess)

export const getElectronicSignaturePadesUrl = (tenantId: string,
    params: ElectronicSignaturePadesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/signatures/pades-electronic?${stringifiedParams}` : `/${tenantId}/signatures/pades-electronic`
}

/**
 * @summary Realiza a assinatura eletrônica usando PADES
 */
export const electronicSignaturePades = async (tenantId: string,
    params: ElectronicSignaturePadesParams,
    signaturePadesElectronicForm?: SignaturePadesElectronicForm, options?: RequestInit): Promise<electronicSignaturePadesResponse> => {
    const formData = new FormData();
if(signaturePadesElectronicForm?.hasWaterMark !== undefined) {
 formData.append(`hasWaterMark`, signaturePadesElectronicForm.hasWaterMark.toString())
 }
if(signaturePadesElectronicForm?.hasCarimboTempo !== undefined) {
 formData.append(`hasCarimboTempo`, signaturePadesElectronicForm.hasCarimboTempo.toString())
 }
if(signaturePadesElectronicForm?.signature !== undefined) {
 formData.append(`signature`, signaturePadesElectronicForm.signature);
 }
if(signaturePadesElectronicForm?.extUserName !== undefined) {
 formData.append(`extUserName`, signaturePadesElectronicForm.extUserName);
 }
if(signaturePadesElectronicForm?.extUserDocument !== undefined) {
 formData.append(`extUserDocument`, signaturePadesElectronicForm.extUserDocument);
 }

  return customInstanceDocumentos<electronicSignaturePadesResponse>(getElectronicSignaturePadesUrl(tenantId,params),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getElectronicSignaturePadesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof electronicSignaturePades>>, TError,{tenantId: string;params: ElectronicSignaturePadesParams;data?: SignaturePadesElectronicForm}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof electronicSignaturePades>>, TError,{tenantId: string;params: ElectronicSignaturePadesParams;data?: SignaturePadesElectronicForm}, TContext> => {

const mutationKey = ['electronicSignaturePades'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof electronicSignaturePades>>, {tenantId: string;params: ElectronicSignaturePadesParams;data?: SignaturePadesElectronicForm}> = (props) => {
          const {tenantId,params,data} = props ?? {};

          return  electronicSignaturePades(tenantId,params,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ElectronicSignaturePadesMutationResult = NonNullable<Awaited<ReturnType<typeof electronicSignaturePades>>>
    export type ElectronicSignaturePadesMutationBody = SignaturePadesElectronicForm | undefined
    export type ElectronicSignaturePadesMutationError = unknown

    /**
 * @summary Realiza a assinatura eletrônica usando PADES
 */
export const useElectronicSignaturePades = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof electronicSignaturePades>>, TError,{tenantId: string;params: ElectronicSignaturePadesParams;data?: SignaturePadesElectronicForm}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof electronicSignaturePades>>,
        TError,
        {tenantId: string;params: ElectronicSignaturePadesParams;data?: SignaturePadesElectronicForm},
        TContext
      > => {
      return useMutation(getElectronicSignaturePadesMutationOptions(options), queryClient);
    }

export type startSignaturePadesResponse200 = {
  data: SignatureStarterResultDto
  status: 200
}

export type startSignaturePadesResponseSuccess = (startSignaturePadesResponse200) & {
  headers: Headers;
};
;

export type startSignaturePadesResponse = (startSignaturePadesResponseSuccess)

export const getStartSignaturePadesUrl = (tenantId: string,
    params: StartSignaturePadesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/signatures/pades-digital/start?${stringifiedParams}` : `/${tenantId}/signatures/pades-digital/start`
}

/**
 * @summary Inicia processo de assinatura PADES
 */
export const startSignaturePades = async (tenantId: string,
    params: StartSignaturePadesParams,
    signaturePadesDigitalWithWebPkiInput?: SignaturePadesDigitalWithWebPkiInput, options?: RequestInit): Promise<startSignaturePadesResponse> => {
    const formData = new FormData();
if(signaturePadesDigitalWithWebPkiInput?.hasWaterMark !== undefined) {
 formData.append(`hasWaterMark`, signaturePadesDigitalWithWebPkiInput.hasWaterMark.toString())
 }
if(signaturePadesDigitalWithWebPkiInput?.hasCarimboTempo !== undefined) {
 formData.append(`hasCarimboTempo`, signaturePadesDigitalWithWebPkiInput.hasCarimboTempo.toString())
 }
if(signaturePadesDigitalWithWebPkiInput?.certificateBase64 !== undefined) {
 formData.append(`certificateBase64`, signaturePadesDigitalWithWebPkiInput.certificateBase64);
 }

  return customInstanceDocumentos<startSignaturePadesResponse>(getStartSignaturePadesUrl(tenantId,params),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getStartSignaturePadesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSignaturePades>>, TError,{tenantId: string;params: StartSignaturePadesParams;data?: SignaturePadesDigitalWithWebPkiInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof startSignaturePades>>, TError,{tenantId: string;params: StartSignaturePadesParams;data?: SignaturePadesDigitalWithWebPkiInput}, TContext> => {

const mutationKey = ['startSignaturePades'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startSignaturePades>>, {tenantId: string;params: StartSignaturePadesParams;data?: SignaturePadesDigitalWithWebPkiInput}> = (props) => {
          const {tenantId,params,data} = props ?? {};

          return  startSignaturePades(tenantId,params,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartSignaturePadesMutationResult = NonNullable<Awaited<ReturnType<typeof startSignaturePades>>>
    export type StartSignaturePadesMutationBody = SignaturePadesDigitalWithWebPkiInput | undefined
    export type StartSignaturePadesMutationError = unknown

    /**
 * @summary Inicia processo de assinatura PADES
 */
export const useStartSignaturePades = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSignaturePades>>, TError,{tenantId: string;params: StartSignaturePadesParams;data?: SignaturePadesDigitalWithWebPkiInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startSignaturePades>>,
        TError,
        {tenantId: string;params: StartSignaturePadesParams;data?: SignaturePadesDigitalWithWebPkiInput},
        TContext
      > => {
      return useMutation(getStartSignaturePadesMutationOptions(options), queryClient);
    }

export type finishSignaturePadesResponse201 = {
  data: DigitalSignatureWithAllPropertiesDto
  status: 201
}

export type finishSignaturePadesResponseSuccess = (finishSignaturePadesResponse201) & {
  headers: Headers;
};
;

export type finishSignaturePadesResponse = (finishSignaturePadesResponseSuccess)

export const getFinishSignaturePadesUrl = (tenantId: string,
    transferFileId: string,) => {




  return `/${tenantId}/signatures/pades-digital/finish/${transferFileId}`
}

/**
 * @summary Finaliza processo de assinatura PADES
 */
export const finishSignaturePades = async (tenantId: string,
    transferFileId: string,
    signaturePadesDigitalInput: SignaturePadesDigitalInput, options?: RequestInit): Promise<finishSignaturePadesResponse> => {

  return customInstanceDocumentos<finishSignaturePadesResponse>(getFinishSignaturePadesUrl(tenantId,transferFileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(signaturePadesDigitalInput)
  }
);}




export const getFinishSignaturePadesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSignaturePades>>, TError,{tenantId: string;transferFileId: string;data: SignaturePadesDigitalInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof finishSignaturePades>>, TError,{tenantId: string;transferFileId: string;data: SignaturePadesDigitalInput}, TContext> => {

const mutationKey = ['finishSignaturePades'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishSignaturePades>>, {tenantId: string;transferFileId: string;data: SignaturePadesDigitalInput}> = (props) => {
          const {tenantId,transferFileId,data} = props ?? {};

          return  finishSignaturePades(tenantId,transferFileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinishSignaturePadesMutationResult = NonNullable<Awaited<ReturnType<typeof finishSignaturePades>>>
    export type FinishSignaturePadesMutationBody = SignaturePadesDigitalInput
    export type FinishSignaturePadesMutationError = unknown

    /**
 * @summary Finaliza processo de assinatura PADES
 */
export const useFinishSignaturePades = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSignaturePades>>, TError,{tenantId: string;transferFileId: string;data: SignaturePadesDigitalInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof finishSignaturePades>>,
        TError,
        {tenantId: string;transferFileId: string;data: SignaturePadesDigitalInput},
        TContext
      > => {
      return useMutation(getFinishSignaturePadesMutationOptions(options), queryClient);
    }

export type electronicSignatureCadesResponse201 = {
  data: DigitalSignatureWithAllPropertiesDto
  status: 201
}

export type electronicSignatureCadesResponseSuccess = (electronicSignatureCadesResponse201) & {
  headers: Headers;
};
;

export type electronicSignatureCadesResponse = (electronicSignatureCadesResponseSuccess)

export const getElectronicSignatureCadesUrl = (tenantId: string,
    params: ElectronicSignatureCadesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/signatures/cades-electronic?${stringifiedParams}` : `/${tenantId}/signatures/cades-electronic`
}

/**
 * @summary Realiza a assinatura eletrônica usando CADES
 */
export const electronicSignatureCades = async (tenantId: string,
    params: ElectronicSignatureCadesParams,
    signatureCadesElectronicForm?: SignatureCadesElectronicForm, options?: RequestInit): Promise<electronicSignatureCadesResponse> => {
    const formData = new FormData();
if(signatureCadesElectronicForm?.signature !== undefined) {
 formData.append(`signature`, signatureCadesElectronicForm.signature);
 }
if(signatureCadesElectronicForm?.hasCarimboTempo !== undefined) {
 formData.append(`hasCarimboTempo`, signatureCadesElectronicForm.hasCarimboTempo.toString())
 }

  return customInstanceDocumentos<electronicSignatureCadesResponse>(getElectronicSignatureCadesUrl(tenantId,params),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getElectronicSignatureCadesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof electronicSignatureCades>>, TError,{tenantId: string;params: ElectronicSignatureCadesParams;data?: SignatureCadesElectronicForm}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof electronicSignatureCades>>, TError,{tenantId: string;params: ElectronicSignatureCadesParams;data?: SignatureCadesElectronicForm}, TContext> => {

const mutationKey = ['electronicSignatureCades'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof electronicSignatureCades>>, {tenantId: string;params: ElectronicSignatureCadesParams;data?: SignatureCadesElectronicForm}> = (props) => {
          const {tenantId,params,data} = props ?? {};

          return  electronicSignatureCades(tenantId,params,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ElectronicSignatureCadesMutationResult = NonNullable<Awaited<ReturnType<typeof electronicSignatureCades>>>
    export type ElectronicSignatureCadesMutationBody = SignatureCadesElectronicForm | undefined
    export type ElectronicSignatureCadesMutationError = unknown

    /**
 * @summary Realiza a assinatura eletrônica usando CADES
 */
export const useElectronicSignatureCades = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof electronicSignatureCades>>, TError,{tenantId: string;params: ElectronicSignatureCadesParams;data?: SignatureCadesElectronicForm}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof electronicSignatureCades>>,
        TError,
        {tenantId: string;params: ElectronicSignatureCadesParams;data?: SignatureCadesElectronicForm},
        TContext
      > => {
      return useMutation(getElectronicSignatureCadesMutationOptions(options), queryClient);
    }

export type startSignatureCadesResponse200 = {
  data: SignatureStarterResultDto
  status: 200
}

export type startSignatureCadesResponseSuccess = (startSignatureCadesResponse200) & {
  headers: Headers;
};
;

export type startSignatureCadesResponse = (startSignatureCadesResponseSuccess)

export const getStartSignatureCadesUrl = (tenantId: string,
    params: StartSignatureCadesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/signatures/cades-digital/start?${stringifiedParams}` : `/${tenantId}/signatures/cades-digital/start`
}

/**
 * @summary Inicia processo de assinatura CADES
 */
export const startSignatureCades = async (tenantId: string,
    params: StartSignatureCadesParams,
    signatureCadesDigitalWithWebPkiInput?: SignatureCadesDigitalWithWebPkiInput, options?: RequestInit): Promise<startSignatureCadesResponse> => {
    const formData = new FormData();
if(signatureCadesDigitalWithWebPkiInput?.certificateBase64 !== undefined) {
 formData.append(`certificateBase64`, signatureCadesDigitalWithWebPkiInput.certificateBase64);
 }
if(signatureCadesDigitalWithWebPkiInput?.hasCarimboTempo !== undefined) {
 formData.append(`hasCarimboTempo`, signatureCadesDigitalWithWebPkiInput.hasCarimboTempo.toString())
 }

  return customInstanceDocumentos<startSignatureCadesResponse>(getStartSignatureCadesUrl(tenantId,params),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getStartSignatureCadesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSignatureCades>>, TError,{tenantId: string;params: StartSignatureCadesParams;data?: SignatureCadesDigitalWithWebPkiInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof startSignatureCades>>, TError,{tenantId: string;params: StartSignatureCadesParams;data?: SignatureCadesDigitalWithWebPkiInput}, TContext> => {

const mutationKey = ['startSignatureCades'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startSignatureCades>>, {tenantId: string;params: StartSignatureCadesParams;data?: SignatureCadesDigitalWithWebPkiInput}> = (props) => {
          const {tenantId,params,data} = props ?? {};

          return  startSignatureCades(tenantId,params,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartSignatureCadesMutationResult = NonNullable<Awaited<ReturnType<typeof startSignatureCades>>>
    export type StartSignatureCadesMutationBody = SignatureCadesDigitalWithWebPkiInput | undefined
    export type StartSignatureCadesMutationError = unknown

    /**
 * @summary Inicia processo de assinatura CADES
 */
export const useStartSignatureCades = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSignatureCades>>, TError,{tenantId: string;params: StartSignatureCadesParams;data?: SignatureCadesDigitalWithWebPkiInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startSignatureCades>>,
        TError,
        {tenantId: string;params: StartSignatureCadesParams;data?: SignatureCadesDigitalWithWebPkiInput},
        TContext
      > => {
      return useMutation(getStartSignatureCadesMutationOptions(options), queryClient);
    }

export type finishSignatureCadesResponse201 = {
  data: DigitalSignatureWithAllPropertiesDto
  status: 201
}

export type finishSignatureCadesResponseSuccess = (finishSignatureCadesResponse201) & {
  headers: Headers;
};
;

export type finishSignatureCadesResponse = (finishSignatureCadesResponseSuccess)

export const getFinishSignatureCadesUrl = (tenantId: string,
    transferFileId: string,) => {




  return `/${tenantId}/signatures/cades-digital/finish/${transferFileId}`
}

/**
 * @summary Finaliza processo de assinatura CADES
 */
export const finishSignatureCades = async (tenantId: string,
    transferFileId: string,
    signatureCadesDigitalInput: SignatureCadesDigitalInput, options?: RequestInit): Promise<finishSignatureCadesResponse> => {

  return customInstanceDocumentos<finishSignatureCadesResponse>(getFinishSignatureCadesUrl(tenantId,transferFileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(signatureCadesDigitalInput)
  }
);}




export const getFinishSignatureCadesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSignatureCades>>, TError,{tenantId: string;transferFileId: string;data: SignatureCadesDigitalInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof finishSignatureCades>>, TError,{tenantId: string;transferFileId: string;data: SignatureCadesDigitalInput}, TContext> => {

const mutationKey = ['finishSignatureCades'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishSignatureCades>>, {tenantId: string;transferFileId: string;data: SignatureCadesDigitalInput}> = (props) => {
          const {tenantId,transferFileId,data} = props ?? {};

          return  finishSignatureCades(tenantId,transferFileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinishSignatureCadesMutationResult = NonNullable<Awaited<ReturnType<typeof finishSignatureCades>>>
    export type FinishSignatureCadesMutationBody = SignatureCadesDigitalInput
    export type FinishSignatureCadesMutationError = unknown

    /**
 * @summary Finaliza processo de assinatura CADES
 */
export const useFinishSignatureCades = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSignatureCades>>, TError,{tenantId: string;transferFileId: string;data: SignatureCadesDigitalInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof finishSignatureCades>>,
        TError,
        {tenantId: string;transferFileId: string;data: SignatureCadesDigitalInput},
        TContext
      > => {
      return useMutation(getFinishSignatureCadesMutationOptions(options), queryClient);
    }

export type findFolderByNameResponse200 = {
  data: DocumentDto[]
  status: 200
}

export type findFolderByNameResponseSuccess = (findFolderByNameResponse200) & {
  headers: Headers;
};
;

export type findFolderByNameResponse = (findFolderByNameResponseSuccess)

export const getFindFolderByNameUrl = (tenantId: string,
    params: FindFolderByNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/folders?${stringifiedParams}` : `/${tenantId}/folders`
}

/**
 * @summary Busca uma pasta pelo nome
 */
export const findFolderByName = async (tenantId: string,
    params: FindFolderByNameParams, options?: RequestInit): Promise<findFolderByNameResponse> => {

  return customInstanceDocumentos<findFolderByNameResponse>(getFindFolderByNameUrl(tenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindFolderByNameQueryKey = (tenantId: string,
    params?: FindFolderByNameParams,) => {
    return [
    `/${tenantId}/folders`, ...(params ? [params] : [])
    ] as const;
    }


export const getFindFolderByNameQueryOptions = <TData = Awaited<ReturnType<typeof findFolderByName>>, TError = unknown>(tenantId: string,
    params: FindFolderByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFolderByName>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindFolderByNameQueryKey(tenantId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findFolderByName>>> = ({ signal }) => findFolderByName(tenantId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findFolderByName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindFolderByNameQueryResult = NonNullable<Awaited<ReturnType<typeof findFolderByName>>>
export type FindFolderByNameQueryError = unknown


export function useFindFolderByName<TData = Awaited<ReturnType<typeof findFolderByName>>, TError = unknown>(
 tenantId: string,
    params: FindFolderByNameParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFolderByName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findFolderByName>>,
          TError,
          Awaited<ReturnType<typeof findFolderByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindFolderByName<TData = Awaited<ReturnType<typeof findFolderByName>>, TError = unknown>(
 tenantId: string,
    params: FindFolderByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFolderByName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findFolderByName>>,
          TError,
          Awaited<ReturnType<typeof findFolderByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindFolderByName<TData = Awaited<ReturnType<typeof findFolderByName>>, TError = unknown>(
 tenantId: string,
    params: FindFolderByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFolderByName>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca uma pasta pelo nome
 */

export function useFindFolderByName<TData = Awaited<ReturnType<typeof findFolderByName>>, TError = unknown>(
 tenantId: string,
    params: FindFolderByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFolderByName>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindFolderByNameQueryOptions(tenantId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createFolderResponse201 = {
  data: DocumentDto
  status: 201
}

export type createFolderResponseSuccess = (createFolderResponse201) & {
  headers: Headers;
};
;

export type createFolderResponse = (createFolderResponseSuccess)

export const getCreateFolderUrl = (tenantId: string,) => {




  return `/${tenantId}/folders`
}

/**
 * @summary Cria uma pasta
 */
export const createFolder = async (tenantId: string,
    folderWithParentAndWorkspaceInputDto: FolderWithParentAndWorkspaceInputDto, options?: RequestInit): Promise<createFolderResponse> => {

  return customInstanceDocumentos<createFolderResponse>(getCreateFolderUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(folderWithParentAndWorkspaceInputDto)
  }
);}




export const getCreateFolderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,{tenantId: string;data: FolderWithParentAndWorkspaceInputDto}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,{tenantId: string;data: FolderWithParentAndWorkspaceInputDto}, TContext> => {

const mutationKey = ['createFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFolder>>, {tenantId: string;data: FolderWithParentAndWorkspaceInputDto}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  createFolder(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFolderMutationResult = NonNullable<Awaited<ReturnType<typeof createFolder>>>
    export type CreateFolderMutationBody = FolderWithParentAndWorkspaceInputDto
    export type CreateFolderMutationError = unknown

    /**
 * @summary Cria uma pasta
 */
export const useCreateFolder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,{tenantId: string;data: FolderWithParentAndWorkspaceInputDto}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFolder>>,
        TError,
        {tenantId: string;data: FolderWithParentAndWorkspaceInputDto},
        TContext
      > => {
      return useMutation(getCreateFolderMutationOptions(options), queryClient);
    }

export type resendSignatureBatchEmailResponse204 = {
  data: void
  status: 204
}

export type resendSignatureBatchEmailResponse404 = {
  data: Problem
  status: 404
}

export type resendSignatureBatchEmailResponseSuccess = (resendSignatureBatchEmailResponse204) & {
  headers: Headers;
};
export type resendSignatureBatchEmailResponseError = (resendSignatureBatchEmailResponse404) & {
  headers: Headers;
};

export type resendSignatureBatchEmailResponse = (resendSignatureBatchEmailResponseSuccess | resendSignatureBatchEmailResponseError)

export const getResendSignatureBatchEmailUrl = (tenantId: string,
    signatureBatchId: string,) => {




  return `/${tenantId}/documents/${signatureBatchId}/resend-signature-email`
}

/**
 * @summary Reenvia o e-mail de assinatura para os assinantes pendentes
 */
export const resendSignatureBatchEmail = async (tenantId: string,
    signatureBatchId: string, options?: RequestInit): Promise<resendSignatureBatchEmailResponse> => {

  return customInstanceDocumentos<resendSignatureBatchEmailResponse>(getResendSignatureBatchEmailUrl(tenantId,signatureBatchId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResendSignatureBatchEmailMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendSignatureBatchEmail>>, TError,{tenantId: string;signatureBatchId: string}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof resendSignatureBatchEmail>>, TError,{tenantId: string;signatureBatchId: string}, TContext> => {

const mutationKey = ['resendSignatureBatchEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendSignatureBatchEmail>>, {tenantId: string;signatureBatchId: string}> = (props) => {
          const {tenantId,signatureBatchId} = props ?? {};

          return  resendSignatureBatchEmail(tenantId,signatureBatchId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendSignatureBatchEmailMutationResult = NonNullable<Awaited<ReturnType<typeof resendSignatureBatchEmail>>>

    export type ResendSignatureBatchEmailMutationError = Problem

    /**
 * @summary Reenvia o e-mail de assinatura para os assinantes pendentes
 */
export const useResendSignatureBatchEmail = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendSignatureBatchEmail>>, TError,{tenantId: string;signatureBatchId: string}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendSignatureBatchEmail>>,
        TError,
        {tenantId: string;signatureBatchId: string},
        TContext
      > => {
      return useMutation(getResendSignatureBatchEmailMutationOptions(options), queryClient);
    }

export type startProcessByDocumentResponse200 = {
  data: ProcessInstanceDto
  status: 200
}

export type startProcessByDocumentResponseSuccess = (startProcessByDocumentResponse200) & {
  headers: Headers;
};
;

export type startProcessByDocumentResponse = (startProcessByDocumentResponseSuccess)

export const getStartProcessByDocumentUrl = (tenantId: string,
    documentId: number,) => {




  return `/${tenantId}/documents/${documentId}/start-process`
}

/**
 * @summary Inicia um processo pelo documento
 */
export const startProcessByDocument = async (tenantId: string,
    documentId: number,
    documentProcessStartInput: DocumentProcessStartInput, options?: RequestInit): Promise<startProcessByDocumentResponse> => {

  return customInstanceDocumentos<startProcessByDocumentResponse>(getStartProcessByDocumentUrl(tenantId,documentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(documentProcessStartInput)
  }
);}




export const getStartProcessByDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startProcessByDocument>>, TError,{tenantId: string;documentId: number;data: DocumentProcessStartInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof startProcessByDocument>>, TError,{tenantId: string;documentId: number;data: DocumentProcessStartInput}, TContext> => {

const mutationKey = ['startProcessByDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startProcessByDocument>>, {tenantId: string;documentId: number;data: DocumentProcessStartInput}> = (props) => {
          const {tenantId,documentId,data} = props ?? {};

          return  startProcessByDocument(tenantId,documentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartProcessByDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof startProcessByDocument>>>
    export type StartProcessByDocumentMutationBody = DocumentProcessStartInput
    export type StartProcessByDocumentMutationError = unknown

    /**
 * @summary Inicia um processo pelo documento
 */
export const useStartProcessByDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startProcessByDocument>>, TError,{tenantId: string;documentId: number;data: DocumentProcessStartInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startProcessByDocument>>,
        TError,
        {tenantId: string;documentId: number;data: DocumentProcessStartInput},
        TContext
      > => {
      return useMutation(getStartProcessByDocumentMutationOptions(options), queryClient);
    }

export type electronicSignatureXadesDigitalFileResponse201 = {
  data: DigitalFileWithSignatureTokenDto
  status: 201
}

export type electronicSignatureXadesDigitalFileResponseSuccess = (electronicSignatureXadesDigitalFileResponse201) & {
  headers: Headers;
};
;

export type electronicSignatureXadesDigitalFileResponse = (electronicSignatureXadesDigitalFileResponseSuccess)

export const getElectronicSignatureXadesDigitalFileUrl = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: ElectronicSignatureXadesDigitalFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/xades-electronic?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/xades-electronic`
}

/**
 * @summary Realiza a assinatura eletrônica usando XADES
 */
export const electronicSignatureXadesDigitalFile = async (tenantId: string,
    documentId: number,
    digitalFileId: string,
    digitalFileSignatureXadesElectronicInput: DigitalFileSignatureXadesElectronicInput,
    params?: ElectronicSignatureXadesDigitalFileParams, options?: RequestInit): Promise<electronicSignatureXadesDigitalFileResponse> => {

  return customInstanceDocumentos<electronicSignatureXadesDigitalFileResponse>(getElectronicSignatureXadesDigitalFileUrl(tenantId,documentId,digitalFileId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(digitalFileSignatureXadesElectronicInput)
  }
);}




export const getElectronicSignatureXadesDigitalFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof electronicSignatureXadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureXadesElectronicInput;params?: ElectronicSignatureXadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof electronicSignatureXadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureXadesElectronicInput;params?: ElectronicSignatureXadesDigitalFileParams}, TContext> => {

const mutationKey = ['electronicSignatureXadesDigitalFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof electronicSignatureXadesDigitalFile>>, {tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureXadesElectronicInput;params?: ElectronicSignatureXadesDigitalFileParams}> = (props) => {
          const {tenantId,documentId,digitalFileId,data,params} = props ?? {};

          return  electronicSignatureXadesDigitalFile(tenantId,documentId,digitalFileId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ElectronicSignatureXadesDigitalFileMutationResult = NonNullable<Awaited<ReturnType<typeof electronicSignatureXadesDigitalFile>>>
    export type ElectronicSignatureXadesDigitalFileMutationBody = DigitalFileSignatureXadesElectronicInput
    export type ElectronicSignatureXadesDigitalFileMutationError = unknown

    /**
 * @summary Realiza a assinatura eletrônica usando XADES
 */
export const useElectronicSignatureXadesDigitalFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof electronicSignatureXadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureXadesElectronicInput;params?: ElectronicSignatureXadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof electronicSignatureXadesDigitalFile>>,
        TError,
        {tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureXadesElectronicInput;params?: ElectronicSignatureXadesDigitalFileParams},
        TContext
      > => {
      return useMutation(getElectronicSignatureXadesDigitalFileMutationOptions(options), queryClient);
    }

export type startSignatureXadesDigitalFileResponse200 = {
  data: SignatureStarterResultDto
  status: 200
}

export type startSignatureXadesDigitalFileResponseSuccess = (startSignatureXadesDigitalFileResponse200) & {
  headers: Headers;
};
;

export type startSignatureXadesDigitalFileResponse = (startSignatureXadesDigitalFileResponseSuccess)

export const getStartSignatureXadesDigitalFileUrl = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: StartSignatureXadesDigitalFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/xades-digital/start?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/xades-digital/start`
}

/**
 * @summary Inicia processo de assinatura XADES
 */
export const startSignatureXadesDigitalFile = async (tenantId: string,
    documentId: number,
    digitalFileId: string,
    digitalFileSignatureXadesDigitalWithWebPkiInput: DigitalFileSignatureXadesDigitalWithWebPkiInput,
    params?: StartSignatureXadesDigitalFileParams, options?: RequestInit): Promise<startSignatureXadesDigitalFileResponse> => {

  return customInstanceDocumentos<startSignatureXadesDigitalFileResponse>(getStartSignatureXadesDigitalFileUrl(tenantId,documentId,digitalFileId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(digitalFileSignatureXadesDigitalWithWebPkiInput)
  }
);}




export const getStartSignatureXadesDigitalFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSignatureXadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureXadesDigitalWithWebPkiInput;params?: StartSignatureXadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof startSignatureXadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureXadesDigitalWithWebPkiInput;params?: StartSignatureXadesDigitalFileParams}, TContext> => {

const mutationKey = ['startSignatureXadesDigitalFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startSignatureXadesDigitalFile>>, {tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureXadesDigitalWithWebPkiInput;params?: StartSignatureXadesDigitalFileParams}> = (props) => {
          const {tenantId,documentId,digitalFileId,data,params} = props ?? {};

          return  startSignatureXadesDigitalFile(tenantId,documentId,digitalFileId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartSignatureXadesDigitalFileMutationResult = NonNullable<Awaited<ReturnType<typeof startSignatureXadesDigitalFile>>>
    export type StartSignatureXadesDigitalFileMutationBody = DigitalFileSignatureXadesDigitalWithWebPkiInput
    export type StartSignatureXadesDigitalFileMutationError = unknown

    /**
 * @summary Inicia processo de assinatura XADES
 */
export const useStartSignatureXadesDigitalFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSignatureXadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureXadesDigitalWithWebPkiInput;params?: StartSignatureXadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startSignatureXadesDigitalFile>>,
        TError,
        {tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureXadesDigitalWithWebPkiInput;params?: StartSignatureXadesDigitalFileParams},
        TContext
      > => {
      return useMutation(getStartSignatureXadesDigitalFileMutationOptions(options), queryClient);
    }

export type finishSignatureXadesDigitalFileResponse201 = {
  data: DigitalFileWithSignatureTokenDto
  status: 201
}

export type finishSignatureXadesDigitalFileResponseSuccess = (finishSignatureXadesDigitalFileResponse201) & {
  headers: Headers;
};
;

export type finishSignatureXadesDigitalFileResponse = (finishSignatureXadesDigitalFileResponseSuccess)

export const getFinishSignatureXadesDigitalFileUrl = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    transferFileId: string,
    params?: FinishSignatureXadesDigitalFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/xades-digital/finish/${transferFileId}?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/xades-digital/finish/${transferFileId}`
}

/**
 * @summary Finaliza processo de assinatura XADES
 */
export const finishSignatureXadesDigitalFile = async (tenantId: string,
    documentId: number,
    digitalFileId: string,
    transferFileId: string,
    digitalFileSignatureXadesDigitalInput: DigitalFileSignatureXadesDigitalInput,
    params?: FinishSignatureXadesDigitalFileParams, options?: RequestInit): Promise<finishSignatureXadesDigitalFileResponse> => {

  return customInstanceDocumentos<finishSignatureXadesDigitalFileResponse>(getFinishSignatureXadesDigitalFileUrl(tenantId,documentId,digitalFileId,transferFileId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(digitalFileSignatureXadesDigitalInput)
  }
);}




export const getFinishSignatureXadesDigitalFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSignatureXadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignatureXadesDigitalInput;params?: FinishSignatureXadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof finishSignatureXadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignatureXadesDigitalInput;params?: FinishSignatureXadesDigitalFileParams}, TContext> => {

const mutationKey = ['finishSignatureXadesDigitalFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishSignatureXadesDigitalFile>>, {tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignatureXadesDigitalInput;params?: FinishSignatureXadesDigitalFileParams}> = (props) => {
          const {tenantId,documentId,digitalFileId,transferFileId,data,params} = props ?? {};

          return  finishSignatureXadesDigitalFile(tenantId,documentId,digitalFileId,transferFileId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinishSignatureXadesDigitalFileMutationResult = NonNullable<Awaited<ReturnType<typeof finishSignatureXadesDigitalFile>>>
    export type FinishSignatureXadesDigitalFileMutationBody = DigitalFileSignatureXadesDigitalInput
    export type FinishSignatureXadesDigitalFileMutationError = unknown

    /**
 * @summary Finaliza processo de assinatura XADES
 */
export const useFinishSignatureXadesDigitalFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSignatureXadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignatureXadesDigitalInput;params?: FinishSignatureXadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof finishSignatureXadesDigitalFile>>,
        TError,
        {tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignatureXadesDigitalInput;params?: FinishSignatureXadesDigitalFileParams},
        TContext
      > => {
      return useMutation(getFinishSignatureXadesDigitalFileMutationOptions(options), queryClient);
    }

export type electronicSignaturePadesDigitalFileResponse201 = {
  data: DigitalFileWithSignatureTokenDto
  status: 201
}

export type electronicSignaturePadesDigitalFileResponseSuccess = (electronicSignaturePadesDigitalFileResponse201) & {
  headers: Headers;
};
;

export type electronicSignaturePadesDigitalFileResponse = (electronicSignaturePadesDigitalFileResponseSuccess)

export const getElectronicSignaturePadesDigitalFileUrl = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: ElectronicSignaturePadesDigitalFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/pades-electronic?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/pades-electronic`
}

/**
 * @summary Realiza a assinatura eletrônica usando PADES
 */
export const electronicSignaturePadesDigitalFile = async (tenantId: string,
    documentId: number,
    digitalFileId: string,
    digitalFileSignaturePadesElectronicInput: DigitalFileSignaturePadesElectronicInput,
    params?: ElectronicSignaturePadesDigitalFileParams, options?: RequestInit): Promise<electronicSignaturePadesDigitalFileResponse> => {

  return customInstanceDocumentos<electronicSignaturePadesDigitalFileResponse>(getElectronicSignaturePadesDigitalFileUrl(tenantId,documentId,digitalFileId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(digitalFileSignaturePadesElectronicInput)
  }
);}




export const getElectronicSignaturePadesDigitalFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof electronicSignaturePadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignaturePadesElectronicInput;params?: ElectronicSignaturePadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof electronicSignaturePadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignaturePadesElectronicInput;params?: ElectronicSignaturePadesDigitalFileParams}, TContext> => {

const mutationKey = ['electronicSignaturePadesDigitalFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof electronicSignaturePadesDigitalFile>>, {tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignaturePadesElectronicInput;params?: ElectronicSignaturePadesDigitalFileParams}> = (props) => {
          const {tenantId,documentId,digitalFileId,data,params} = props ?? {};

          return  electronicSignaturePadesDigitalFile(tenantId,documentId,digitalFileId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ElectronicSignaturePadesDigitalFileMutationResult = NonNullable<Awaited<ReturnType<typeof electronicSignaturePadesDigitalFile>>>
    export type ElectronicSignaturePadesDigitalFileMutationBody = DigitalFileSignaturePadesElectronicInput
    export type ElectronicSignaturePadesDigitalFileMutationError = unknown

    /**
 * @summary Realiza a assinatura eletrônica usando PADES
 */
export const useElectronicSignaturePadesDigitalFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof electronicSignaturePadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignaturePadesElectronicInput;params?: ElectronicSignaturePadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof electronicSignaturePadesDigitalFile>>,
        TError,
        {tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignaturePadesElectronicInput;params?: ElectronicSignaturePadesDigitalFileParams},
        TContext
      > => {
      return useMutation(getElectronicSignaturePadesDigitalFileMutationOptions(options), queryClient);
    }

export type startSignaturePadesDigitalFileResponse200 = {
  data: SignatureStarterResultDto
  status: 200
}

export type startSignaturePadesDigitalFileResponseSuccess = (startSignaturePadesDigitalFileResponse200) & {
  headers: Headers;
};
;

export type startSignaturePadesDigitalFileResponse = (startSignaturePadesDigitalFileResponseSuccess)

export const getStartSignaturePadesDigitalFileUrl = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: StartSignaturePadesDigitalFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/pades-digital/start?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/pades-digital/start`
}

/**
 * @summary Inicia processo de assinatura PADES
 */
export const startSignaturePadesDigitalFile = async (tenantId: string,
    documentId: number,
    digitalFileId: string,
    digitalFileSignaturePadesDigitalWithWebPkiInput: DigitalFileSignaturePadesDigitalWithWebPkiInput,
    params?: StartSignaturePadesDigitalFileParams, options?: RequestInit): Promise<startSignaturePadesDigitalFileResponse> => {

  return customInstanceDocumentos<startSignaturePadesDigitalFileResponse>(getStartSignaturePadesDigitalFileUrl(tenantId,documentId,digitalFileId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(digitalFileSignaturePadesDigitalWithWebPkiInput)
  }
);}




export const getStartSignaturePadesDigitalFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSignaturePadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignaturePadesDigitalWithWebPkiInput;params?: StartSignaturePadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof startSignaturePadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignaturePadesDigitalWithWebPkiInput;params?: StartSignaturePadesDigitalFileParams}, TContext> => {

const mutationKey = ['startSignaturePadesDigitalFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startSignaturePadesDigitalFile>>, {tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignaturePadesDigitalWithWebPkiInput;params?: StartSignaturePadesDigitalFileParams}> = (props) => {
          const {tenantId,documentId,digitalFileId,data,params} = props ?? {};

          return  startSignaturePadesDigitalFile(tenantId,documentId,digitalFileId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartSignaturePadesDigitalFileMutationResult = NonNullable<Awaited<ReturnType<typeof startSignaturePadesDigitalFile>>>
    export type StartSignaturePadesDigitalFileMutationBody = DigitalFileSignaturePadesDigitalWithWebPkiInput
    export type StartSignaturePadesDigitalFileMutationError = unknown

    /**
 * @summary Inicia processo de assinatura PADES
 */
export const useStartSignaturePadesDigitalFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSignaturePadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignaturePadesDigitalWithWebPkiInput;params?: StartSignaturePadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startSignaturePadesDigitalFile>>,
        TError,
        {tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignaturePadesDigitalWithWebPkiInput;params?: StartSignaturePadesDigitalFileParams},
        TContext
      > => {
      return useMutation(getStartSignaturePadesDigitalFileMutationOptions(options), queryClient);
    }

export type finishSignaturePadesDigitalFileResponse201 = {
  data: DigitalFileWithSignatureTokenDto
  status: 201
}

export type finishSignaturePadesDigitalFileResponseSuccess = (finishSignaturePadesDigitalFileResponse201) & {
  headers: Headers;
};
;

export type finishSignaturePadesDigitalFileResponse = (finishSignaturePadesDigitalFileResponseSuccess)

export const getFinishSignaturePadesDigitalFileUrl = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    transferFileId: string,
    params?: FinishSignaturePadesDigitalFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/pades-digital/finish/${transferFileId}?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/pades-digital/finish/${transferFileId}`
}

/**
 * @summary Finaliza processo de assinatura PADES
 */
export const finishSignaturePadesDigitalFile = async (tenantId: string,
    documentId: number,
    digitalFileId: string,
    transferFileId: string,
    digitalFileSignaturePadesDigitalInput: DigitalFileSignaturePadesDigitalInput,
    params?: FinishSignaturePadesDigitalFileParams, options?: RequestInit): Promise<finishSignaturePadesDigitalFileResponse> => {

  return customInstanceDocumentos<finishSignaturePadesDigitalFileResponse>(getFinishSignaturePadesDigitalFileUrl(tenantId,documentId,digitalFileId,transferFileId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(digitalFileSignaturePadesDigitalInput)
  }
);}




export const getFinishSignaturePadesDigitalFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSignaturePadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignaturePadesDigitalInput;params?: FinishSignaturePadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof finishSignaturePadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignaturePadesDigitalInput;params?: FinishSignaturePadesDigitalFileParams}, TContext> => {

const mutationKey = ['finishSignaturePadesDigitalFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishSignaturePadesDigitalFile>>, {tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignaturePadesDigitalInput;params?: FinishSignaturePadesDigitalFileParams}> = (props) => {
          const {tenantId,documentId,digitalFileId,transferFileId,data,params} = props ?? {};

          return  finishSignaturePadesDigitalFile(tenantId,documentId,digitalFileId,transferFileId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinishSignaturePadesDigitalFileMutationResult = NonNullable<Awaited<ReturnType<typeof finishSignaturePadesDigitalFile>>>
    export type FinishSignaturePadesDigitalFileMutationBody = DigitalFileSignaturePadesDigitalInput
    export type FinishSignaturePadesDigitalFileMutationError = unknown

    /**
 * @summary Finaliza processo de assinatura PADES
 */
export const useFinishSignaturePadesDigitalFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSignaturePadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignaturePadesDigitalInput;params?: FinishSignaturePadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof finishSignaturePadesDigitalFile>>,
        TError,
        {tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignaturePadesDigitalInput;params?: FinishSignaturePadesDigitalFileParams},
        TContext
      > => {
      return useMutation(getFinishSignaturePadesDigitalFileMutationOptions(options), queryClient);
    }

export type electronicSignatureCadesDigitalFileResponse201 = {
  data: DigitalFileWithSignatureTokenDto
  status: 201
}

export type electronicSignatureCadesDigitalFileResponseSuccess = (electronicSignatureCadesDigitalFileResponse201) & {
  headers: Headers;
};
;

export type electronicSignatureCadesDigitalFileResponse = (electronicSignatureCadesDigitalFileResponseSuccess)

export const getElectronicSignatureCadesDigitalFileUrl = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: ElectronicSignatureCadesDigitalFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/cades-electronic?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/cades-electronic`
}

/**
 * @summary Realiza a assinatura eletrônica usando CADES
 */
export const electronicSignatureCadesDigitalFile = async (tenantId: string,
    documentId: number,
    digitalFileId: string,
    digitalFileSignatureCadesElectronicInput: DigitalFileSignatureCadesElectronicInput,
    params?: ElectronicSignatureCadesDigitalFileParams, options?: RequestInit): Promise<electronicSignatureCadesDigitalFileResponse> => {

  return customInstanceDocumentos<electronicSignatureCadesDigitalFileResponse>(getElectronicSignatureCadesDigitalFileUrl(tenantId,documentId,digitalFileId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(digitalFileSignatureCadesElectronicInput)
  }
);}




export const getElectronicSignatureCadesDigitalFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof electronicSignatureCadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureCadesElectronicInput;params?: ElectronicSignatureCadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof electronicSignatureCadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureCadesElectronicInput;params?: ElectronicSignatureCadesDigitalFileParams}, TContext> => {

const mutationKey = ['electronicSignatureCadesDigitalFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof electronicSignatureCadesDigitalFile>>, {tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureCadesElectronicInput;params?: ElectronicSignatureCadesDigitalFileParams}> = (props) => {
          const {tenantId,documentId,digitalFileId,data,params} = props ?? {};

          return  electronicSignatureCadesDigitalFile(tenantId,documentId,digitalFileId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ElectronicSignatureCadesDigitalFileMutationResult = NonNullable<Awaited<ReturnType<typeof electronicSignatureCadesDigitalFile>>>
    export type ElectronicSignatureCadesDigitalFileMutationBody = DigitalFileSignatureCadesElectronicInput
    export type ElectronicSignatureCadesDigitalFileMutationError = unknown

    /**
 * @summary Realiza a assinatura eletrônica usando CADES
 */
export const useElectronicSignatureCadesDigitalFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof electronicSignatureCadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureCadesElectronicInput;params?: ElectronicSignatureCadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof electronicSignatureCadesDigitalFile>>,
        TError,
        {tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureCadesElectronicInput;params?: ElectronicSignatureCadesDigitalFileParams},
        TContext
      > => {
      return useMutation(getElectronicSignatureCadesDigitalFileMutationOptions(options), queryClient);
    }

export type startSignatureCadesDigitalFileResponse200 = {
  data: SignatureStarterResultDto
  status: 200
}

export type startSignatureCadesDigitalFileResponseSuccess = (startSignatureCadesDigitalFileResponse200) & {
  headers: Headers;
};
;

export type startSignatureCadesDigitalFileResponse = (startSignatureCadesDigitalFileResponseSuccess)

export const getStartSignatureCadesDigitalFileUrl = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: StartSignatureCadesDigitalFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/cades-digital/start?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/cades-digital/start`
}

/**
 * @summary Inicia processo de assinatura CADES
 */
export const startSignatureCadesDigitalFile = async (tenantId: string,
    documentId: number,
    digitalFileId: string,
    digitalFileSignatureCadesDigitalWithWebPkiInput: DigitalFileSignatureCadesDigitalWithWebPkiInput,
    params?: StartSignatureCadesDigitalFileParams, options?: RequestInit): Promise<startSignatureCadesDigitalFileResponse> => {

  return customInstanceDocumentos<startSignatureCadesDigitalFileResponse>(getStartSignatureCadesDigitalFileUrl(tenantId,documentId,digitalFileId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(digitalFileSignatureCadesDigitalWithWebPkiInput)
  }
);}




export const getStartSignatureCadesDigitalFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSignatureCadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureCadesDigitalWithWebPkiInput;params?: StartSignatureCadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof startSignatureCadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureCadesDigitalWithWebPkiInput;params?: StartSignatureCadesDigitalFileParams}, TContext> => {

const mutationKey = ['startSignatureCadesDigitalFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startSignatureCadesDigitalFile>>, {tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureCadesDigitalWithWebPkiInput;params?: StartSignatureCadesDigitalFileParams}> = (props) => {
          const {tenantId,documentId,digitalFileId,data,params} = props ?? {};

          return  startSignatureCadesDigitalFile(tenantId,documentId,digitalFileId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartSignatureCadesDigitalFileMutationResult = NonNullable<Awaited<ReturnType<typeof startSignatureCadesDigitalFile>>>
    export type StartSignatureCadesDigitalFileMutationBody = DigitalFileSignatureCadesDigitalWithWebPkiInput
    export type StartSignatureCadesDigitalFileMutationError = unknown

    /**
 * @summary Inicia processo de assinatura CADES
 */
export const useStartSignatureCadesDigitalFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSignatureCadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureCadesDigitalWithWebPkiInput;params?: StartSignatureCadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startSignatureCadesDigitalFile>>,
        TError,
        {tenantId: string;documentId: number;digitalFileId: string;data: DigitalFileSignatureCadesDigitalWithWebPkiInput;params?: StartSignatureCadesDigitalFileParams},
        TContext
      > => {
      return useMutation(getStartSignatureCadesDigitalFileMutationOptions(options), queryClient);
    }

export type finishSignatureCadesDigitalFileResponse201 = {
  data: DigitalFileWithSignatureTokenDto
  status: 201
}

export type finishSignatureCadesDigitalFileResponseSuccess = (finishSignatureCadesDigitalFileResponse201) & {
  headers: Headers;
};
;

export type finishSignatureCadesDigitalFileResponse = (finishSignatureCadesDigitalFileResponseSuccess)

export const getFinishSignatureCadesDigitalFileUrl = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    transferFileId: string,
    params?: FinishSignatureCadesDigitalFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/cades-digital/finish/${transferFileId}?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files/${digitalFileId}/signatures/cades-digital/finish/${transferFileId}`
}

/**
 * @summary Finaliza processo de assinatura CADES
 */
export const finishSignatureCadesDigitalFile = async (tenantId: string,
    documentId: number,
    digitalFileId: string,
    transferFileId: string,
    digitalFileSignatureCadesDigitalInput: DigitalFileSignatureCadesDigitalInput,
    params?: FinishSignatureCadesDigitalFileParams, options?: RequestInit): Promise<finishSignatureCadesDigitalFileResponse> => {

  return customInstanceDocumentos<finishSignatureCadesDigitalFileResponse>(getFinishSignatureCadesDigitalFileUrl(tenantId,documentId,digitalFileId,transferFileId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(digitalFileSignatureCadesDigitalInput)
  }
);}




export const getFinishSignatureCadesDigitalFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSignatureCadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignatureCadesDigitalInput;params?: FinishSignatureCadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof finishSignatureCadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignatureCadesDigitalInput;params?: FinishSignatureCadesDigitalFileParams}, TContext> => {

const mutationKey = ['finishSignatureCadesDigitalFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishSignatureCadesDigitalFile>>, {tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignatureCadesDigitalInput;params?: FinishSignatureCadesDigitalFileParams}> = (props) => {
          const {tenantId,documentId,digitalFileId,transferFileId,data,params} = props ?? {};

          return  finishSignatureCadesDigitalFile(tenantId,documentId,digitalFileId,transferFileId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinishSignatureCadesDigitalFileMutationResult = NonNullable<Awaited<ReturnType<typeof finishSignatureCadesDigitalFile>>>
    export type FinishSignatureCadesDigitalFileMutationBody = DigitalFileSignatureCadesDigitalInput
    export type FinishSignatureCadesDigitalFileMutationError = unknown

    /**
 * @summary Finaliza processo de assinatura CADES
 */
export const useFinishSignatureCadesDigitalFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSignatureCadesDigitalFile>>, TError,{tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignatureCadesDigitalInput;params?: FinishSignatureCadesDigitalFileParams}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof finishSignatureCadesDigitalFile>>,
        TError,
        {tenantId: string;documentId: number;digitalFileId: string;transferFileId: string;data: DigitalFileSignatureCadesDigitalInput;params?: FinishSignatureCadesDigitalFileParams},
        TContext
      > => {
      return useMutation(getFinishSignatureCadesDigitalFileMutationOptions(options), queryClient);
    }

export type copyDocumentResponse201 = {
  data: DocumentWithAllPropertiesDto
  status: 201
}

export type copyDocumentResponse404 = {
  data: Problem
  status: 404
}

export type copyDocumentResponseSuccess = (copyDocumentResponse201) & {
  headers: Headers;
};
export type copyDocumentResponseError = (copyDocumentResponse404) & {
  headers: Headers;
};

export type copyDocumentResponse = (copyDocumentResponseSuccess | copyDocumentResponseError)

export const getCopyDocumentUrl = (tenantId: string,
    documentId: number,
    destinationFolderId: number,) => {




  return `/${tenantId}/documents/${documentId}/copy/${destinationFolderId}`
}

/**
 * @summary Copia um documento por ID
 */
export const copyDocument = async (tenantId: string,
    documentId: number,
    destinationFolderId: number, options?: RequestInit): Promise<copyDocumentResponse> => {

  return customInstanceDocumentos<copyDocumentResponse>(getCopyDocumentUrl(tenantId,documentId,destinationFolderId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCopyDocumentMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyDocument>>, TError,{tenantId: string;documentId: number;destinationFolderId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof copyDocument>>, TError,{tenantId: string;documentId: number;destinationFolderId: number}, TContext> => {

const mutationKey = ['copyDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyDocument>>, {tenantId: string;documentId: number;destinationFolderId: number}> = (props) => {
          const {tenantId,documentId,destinationFolderId} = props ?? {};

          return  copyDocument(tenantId,documentId,destinationFolderId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CopyDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof copyDocument>>>

    export type CopyDocumentMutationError = Problem

    /**
 * @summary Copia um documento por ID
 */
export const useCopyDocument = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyDocument>>, TError,{tenantId: string;documentId: number;destinationFolderId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof copyDocument>>,
        TError,
        {tenantId: string;documentId: number;destinationFolderId: number},
        TContext
      > => {
      return useMutation(getCopyDocumentMutationOptions(options), queryClient);
    }

export type createDocumentWithExistentReferenceResponse201 = {
  data: DocumentWithAllPropertiesDto
  status: 201
}

export type createDocumentWithExistentReferenceResponseSuccess = (createDocumentWithExistentReferenceResponse201) & {
  headers: Headers;
};
;

export type createDocumentWithExistentReferenceResponse = (createDocumentWithExistentReferenceResponseSuccess)

export const getCreateDocumentWithExistentReferenceUrl = (tenantId: string,) => {




  return `/${tenantId}/documents/create-with-existent-reference`
}

/**
 * @summary Cria um documento com uma referência externa ja existente
 */
export const createDocumentWithExistentReference = async (tenantId: string,
    documentInputCreateWithExternalReferenceDto: DocumentInputCreateWithExternalReferenceDto, options?: RequestInit): Promise<createDocumentWithExistentReferenceResponse> => {

  return customInstanceDocumentos<createDocumentWithExistentReferenceResponse>(getCreateDocumentWithExistentReferenceUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(documentInputCreateWithExternalReferenceDto)
  }
);}




export const getCreateDocumentWithExistentReferenceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentWithExistentReference>>, TError,{tenantId: string;data: DocumentInputCreateWithExternalReferenceDto}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof createDocumentWithExistentReference>>, TError,{tenantId: string;data: DocumentInputCreateWithExternalReferenceDto}, TContext> => {

const mutationKey = ['createDocumentWithExistentReference'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDocumentWithExistentReference>>, {tenantId: string;data: DocumentInputCreateWithExternalReferenceDto}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  createDocumentWithExistentReference(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDocumentWithExistentReferenceMutationResult = NonNullable<Awaited<ReturnType<typeof createDocumentWithExistentReference>>>
    export type CreateDocumentWithExistentReferenceMutationBody = DocumentInputCreateWithExternalReferenceDto
    export type CreateDocumentWithExistentReferenceMutationError = unknown

    /**
 * @summary Cria um documento com uma referência externa ja existente
 */
export const useCreateDocumentWithExistentReference = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentWithExistentReference>>, TError,{tenantId: string;data: DocumentInputCreateWithExternalReferenceDto}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDocumentWithExistentReference>>,
        TError,
        {tenantId: string;data: DocumentInputCreateWithExternalReferenceDto},
        TContext
      > => {
      return useMutation(getCreateDocumentWithExistentReferenceMutationOptions(options), queryClient);
    }

export type listCoversResponse200 = {
  data: PageCoverDto
  status: 200
}

export type listCoversResponseSuccess = (listCoversResponse200) & {
  headers: Headers;
};
;

export type listCoversResponse = (listCoversResponseSuccess)

export const getListCoversUrl = (tenantId: string,
    params?: ListCoversParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/covers?${stringifiedParams}` : `/${tenantId}/documents/covers`
}

/**
 * @summary Lista os envelopes de assinatura
 */
export const listCovers = async (tenantId: string,
    params?: ListCoversParams, options?: RequestInit): Promise<listCoversResponse> => {

  return customInstanceDocumentos<listCoversResponse>(getListCoversUrl(tenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCoversQueryKey = (tenantId: string,
    params?: ListCoversParams,) => {
    return [
    `/${tenantId}/documents/covers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCoversQueryOptions = <TData = Awaited<ReturnType<typeof listCovers>>, TError = unknown>(tenantId: string,
    params?: ListCoversParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCovers>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCoversQueryKey(tenantId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCovers>>> = ({ signal }) => listCovers(tenantId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCovers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCoversQueryResult = NonNullable<Awaited<ReturnType<typeof listCovers>>>
export type ListCoversQueryError = unknown


export function useListCovers<TData = Awaited<ReturnType<typeof listCovers>>, TError = unknown>(
 tenantId: string,
    params: undefined |  ListCoversParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCovers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCovers>>,
          TError,
          Awaited<ReturnType<typeof listCovers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCovers<TData = Awaited<ReturnType<typeof listCovers>>, TError = unknown>(
 tenantId: string,
    params?: ListCoversParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCovers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCovers>>,
          TError,
          Awaited<ReturnType<typeof listCovers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCovers<TData = Awaited<ReturnType<typeof listCovers>>, TError = unknown>(
 tenantId: string,
    params?: ListCoversParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCovers>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os envelopes de assinatura
 */

export function useListCovers<TData = Awaited<ReturnType<typeof listCovers>>, TError = unknown>(
 tenantId: string,
    params?: ListCoversParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCovers>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCoversQueryOptions(tenantId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createSignatureBatchResponse201 = {
  data: SignatureBatchResponse
  status: 201
}

export type createSignatureBatchResponseSuccess = (createSignatureBatchResponse201) & {
  headers: Headers;
};
;

export type createSignatureBatchResponse = (createSignatureBatchResponseSuccess)

export const getCreateSignatureBatchUrl = (tenantId: string,) => {




  return `/${tenantId}/documents/covers`
}

/**
 * @summary Criar uma envelope de assinatura em lote
 */
export const createSignatureBatch = async (tenantId: string,
    batchSignatureInput: BatchSignatureInput, options?: RequestInit): Promise<createSignatureBatchResponse> => {

  return customInstanceDocumentos<createSignatureBatchResponse>(getCreateSignatureBatchUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(batchSignatureInput)
  }
);}




export const getCreateSignatureBatchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSignatureBatch>>, TError,{tenantId: string;data: BatchSignatureInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof createSignatureBatch>>, TError,{tenantId: string;data: BatchSignatureInput}, TContext> => {

const mutationKey = ['createSignatureBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSignatureBatch>>, {tenantId: string;data: BatchSignatureInput}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  createSignatureBatch(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSignatureBatchMutationResult = NonNullable<Awaited<ReturnType<typeof createSignatureBatch>>>
    export type CreateSignatureBatchMutationBody = BatchSignatureInput
    export type CreateSignatureBatchMutationError = unknown

    /**
 * @summary Criar uma envelope de assinatura em lote
 */
export const useCreateSignatureBatch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSignatureBatch>>, TError,{tenantId: string;data: BatchSignatureInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSignatureBatch>>,
        TError,
        {tenantId: string;data: BatchSignatureInput},
        TContext
      > => {
      return useMutation(getCreateSignatureBatchMutationOptions(options), queryClient);
    }

export type attachDocumentExternalApiResponse204 = {
  data: void
  status: 204
}

export type attachDocumentExternalApiResponseSuccess = (attachDocumentExternalApiResponse204) & {
  headers: Headers;
};
;

export type attachDocumentExternalApiResponse = (attachDocumentExternalApiResponseSuccess)

export const getAttachDocumentExternalApiUrl = (tenantId: string,) => {




  return `/${tenantId}/documents/attach-external-link`
}

/**
 * @summary Vincula documentos à APIs externas
 */
export const attachDocumentExternalApi = async (tenantId: string,
    validListDocumentExternalLinkInput: ValidListDocumentExternalLinkInput, options?: RequestInit): Promise<attachDocumentExternalApiResponse> => {

  return customInstanceDocumentos<attachDocumentExternalApiResponse>(getAttachDocumentExternalApiUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(validListDocumentExternalLinkInput)
  }
);}




export const getAttachDocumentExternalApiMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachDocumentExternalApi>>, TError,{tenantId: string;data: ValidListDocumentExternalLinkInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof attachDocumentExternalApi>>, TError,{tenantId: string;data: ValidListDocumentExternalLinkInput}, TContext> => {

const mutationKey = ['attachDocumentExternalApi'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof attachDocumentExternalApi>>, {tenantId: string;data: ValidListDocumentExternalLinkInput}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  attachDocumentExternalApi(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AttachDocumentExternalApiMutationResult = NonNullable<Awaited<ReturnType<typeof attachDocumentExternalApi>>>
    export type AttachDocumentExternalApiMutationBody = ValidListDocumentExternalLinkInput
    export type AttachDocumentExternalApiMutationError = unknown

    /**
 * @summary Vincula documentos à APIs externas
 */
export const useAttachDocumentExternalApi = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachDocumentExternalApi>>, TError,{tenantId: string;data: ValidListDocumentExternalLinkInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof attachDocumentExternalApi>>,
        TError,
        {tenantId: string;data: ValidListDocumentExternalLinkInput},
        TContext
      > => {
      return useMutation(getAttachDocumentExternalApiMutationOptions(options), queryClient);
    }

export type listDocumentResponse200 = {
  data: PageDocumentDto
  status: 200
}

export type listDocumentResponseSuccess = (listDocumentResponse200) & {
  headers: Headers;
};
;

export type listDocumentResponse = (listDocumentResponseSuccess)

export const getListDocumentUrl = (tenantId: string,
    params?: ListDocumentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents?${stringifiedParams}` : `/${tenantId}/documents`
}

/**
 * @summary Lista os workspaces/pasta/documentos
 */
export const listDocument = async (tenantId: string,
    params?: ListDocumentParams, options?: RequestInit): Promise<listDocumentResponse> => {

  return customInstanceDocumentos<listDocumentResponse>(getListDocumentUrl(tenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDocumentQueryKey = (tenantId: string,
    params?: ListDocumentParams,) => {
    return [
    `/${tenantId}/documents`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDocumentQueryOptions = <TData = Awaited<ReturnType<typeof listDocument>>, TError = unknown>(tenantId: string,
    params?: ListDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDocumentQueryKey(tenantId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocument>>> = ({ signal }) => listDocument(tenantId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof listDocument>>>
export type ListDocumentQueryError = unknown


export function useListDocument<TData = Awaited<ReturnType<typeof listDocument>>, TError = unknown>(
 tenantId: string,
    params: undefined |  ListDocumentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocument>>,
          TError,
          Awaited<ReturnType<typeof listDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocument<TData = Awaited<ReturnType<typeof listDocument>>, TError = unknown>(
 tenantId: string,
    params?: ListDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocument>>,
          TError,
          Awaited<ReturnType<typeof listDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocument<TData = Awaited<ReturnType<typeof listDocument>>, TError = unknown>(
 tenantId: string,
    params?: ListDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os workspaces/pasta/documentos
 */

export function useListDocument<TData = Awaited<ReturnType<typeof listDocument>>, TError = unknown>(
 tenantId: string,
    params?: ListDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDocumentQueryOptions(tenantId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createDocumentResponse201 = {
  data: DocumentWithAllPropertiesDto
  status: 201
}

export type createDocumentResponseSuccess = (createDocumentResponse201) & {
  headers: Headers;
};
;

export type createDocumentResponse = (createDocumentResponseSuccess)

export const getCreateDocumentUrl = (tenantId: string,) => {




  return `/${tenantId}/documents`
}

/**
 * @summary Cria um documento
 */
export const createDocument = async (tenantId: string,
    createDocumentBody?: CreateDocumentBody, options?: RequestInit): Promise<createDocumentResponse> => {
    const formData = new FormData();
if(createDocumentBody?.documentInput !== undefined) {
 formData.append(`documentInput`, JSON.stringify(createDocumentBody.documentInput));
 }
if(createDocumentBody?.files !== undefined) {
 formData.append(`files`, createDocumentBody.files);
 }

  return customInstanceDocumentos<createDocumentResponse>(getCreateDocumentUrl(tenantId),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getCreateDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocument>>, TError,{tenantId: string;data?: CreateDocumentBody}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof createDocument>>, TError,{tenantId: string;data?: CreateDocumentBody}, TContext> => {

const mutationKey = ['createDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDocument>>, {tenantId: string;data?: CreateDocumentBody}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  createDocument(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof createDocument>>>
    export type CreateDocumentMutationBody = CreateDocumentBody | undefined
    export type CreateDocumentMutationError = unknown

    /**
 * @summary Cria um documento
 */
export const useCreateDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocument>>, TError,{tenantId: string;data?: CreateDocumentBody}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDocument>>,
        TError,
        {tenantId: string;data?: CreateDocumentBody},
        TContext
      > => {
      return useMutation(getCreateDocumentMutationOptions(options), queryClient);
    }

export type searchGetResponse200 = {
  data: SearchResponse
  status: 200
}

export type searchGetResponseSuccess = (searchGetResponse200) & {
  headers: Headers;
};
;

export type searchGetResponse = (searchGetResponseSuccess)

export const getSearchGetUrl = (tenant: string,
    params?: SearchGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/search?${stringifiedParams}` : `/v1/${tenant}/search`
}

export const searchGet = async (tenant: string,
    params?: SearchGetParams, options?: RequestInit): Promise<searchGetResponse> => {

  return customInstanceDocumentos<searchGetResponse>(getSearchGetUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchGetQueryKey = (tenant: string,
    params?: SearchGetParams,) => {
    return [
    `/v1/${tenant}/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchGetQueryOptions = <TData = Awaited<ReturnType<typeof searchGet>>, TError = unknown>(tenant: string,
    params?: SearchGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGet>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchGetQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchGet>>> = ({ signal }) => searchGet(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchGetQueryResult = NonNullable<Awaited<ReturnType<typeof searchGet>>>
export type SearchGetQueryError = unknown


export function useSearchGet<TData = Awaited<ReturnType<typeof searchGet>>, TError = unknown>(
 tenant: string,
    params: undefined |  SearchGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchGet>>,
          TError,
          Awaited<ReturnType<typeof searchGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchGet<TData = Awaited<ReturnType<typeof searchGet>>, TError = unknown>(
 tenant: string,
    params?: SearchGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchGet>>,
          TError,
          Awaited<ReturnType<typeof searchGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchGet<TData = Awaited<ReturnType<typeof searchGet>>, TError = unknown>(
 tenant: string,
    params?: SearchGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGet>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSearchGet<TData = Awaited<ReturnType<typeof searchGet>>, TError = unknown>(
 tenant: string,
    params?: SearchGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGet>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchGetQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type searchResponse200 = {
  data: SearchResponse
  status: 200
}

export type searchResponseSuccess = (searchResponse200) & {
  headers: Headers;
};
;

export type searchResponse = (searchResponseSuccess)

export const getSearchUrl = (tenant: string,) => {




  return `/v1/${tenant}/search`
}

export const search = async (tenant: string,
    searchRequest: SearchRequest, options?: RequestInit): Promise<searchResponse> => {

  return customInstanceDocumentos<searchResponse>(getSearchUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(searchRequest)
  }
);}




export const getSearchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof search>>, TError,{tenant: string;data: SearchRequest}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof search>>, TError,{tenant: string;data: SearchRequest}, TContext> => {

const mutationKey = ['search'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof search>>, {tenant: string;data: SearchRequest}> = (props) => {
          const {tenant,data} = props ?? {};

          return  search(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SearchMutationResult = NonNullable<Awaited<ReturnType<typeof search>>>
    export type SearchMutationBody = SearchRequest
    export type SearchMutationError = unknown

    export const useSearch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof search>>, TError,{tenant: string;data: SearchRequest}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof search>>,
        TError,
        {tenant: string;data: SearchRequest},
        TContext
      > => {
      return useMutation(getSearchMutationOptions(options), queryClient);
    }

export type reindexResponse200 = {
  data: Reindex200
  status: 200
}

export type reindexResponseSuccess = (reindexResponse200) & {
  headers: Headers;
};
;

export type reindexResponse = (reindexResponseSuccess)

export const getReindexUrl = (tenant: string,) => {




  return `/v1/${tenant}/search/reindex`
}

export const reindex = async (tenant: string, options?: RequestInit): Promise<reindexResponse> => {

  return customInstanceDocumentos<reindexResponse>(getReindexUrl(tenant),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReindexMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reindex>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof reindex>>, TError,{tenant: string}, TContext> => {

const mutationKey = ['reindex'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reindex>>, {tenant: string}> = (props) => {
          const {tenant} = props ?? {};

          return  reindex(tenant,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReindexMutationResult = NonNullable<Awaited<ReturnType<typeof reindex>>>

    export type ReindexMutationError = unknown

    export const useReindex = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reindex>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reindex>>,
        TError,
        {tenant: string},
        TContext
      > => {
      return useMutation(getReindexMutationOptions(options), queryClient);
    }

export type generateDocumentTokenWithPublicLinkResponse200 = {
  data: DocumentTokenDto
  status: 200
}

export type generateDocumentTokenWithPublicLinkResponseSuccess = (generateDocumentTokenWithPublicLinkResponse200) & {
  headers: Headers;
};
;

export type generateDocumentTokenWithPublicLinkResponse = (generateDocumentTokenWithPublicLinkResponseSuccess)

export const getGenerateDocumentTokenWithPublicLinkUrl = (fileUid: string,
    linkCode: string,) => {




  return `/public/files/${fileUid}/link/${linkCode}/generate-temporary-link`
}

/**
 * @summary Gera url publica temporária do arquivo através do link publico do processo
 */
export const generateDocumentTokenWithPublicLink = async (fileUid: string,
    linkCode: string, options?: RequestInit): Promise<generateDocumentTokenWithPublicLinkResponse> => {

  return customInstanceDocumentos<generateDocumentTokenWithPublicLinkResponse>(getGenerateDocumentTokenWithPublicLinkUrl(fileUid,linkCode),
  {
    ...options,
    method: 'POST'


  }
);}




export const getGenerateDocumentTokenWithPublicLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDocumentTokenWithPublicLink>>, TError,{fileUid: string;linkCode: string}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof generateDocumentTokenWithPublicLink>>, TError,{fileUid: string;linkCode: string}, TContext> => {

const mutationKey = ['generateDocumentTokenWithPublicLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateDocumentTokenWithPublicLink>>, {fileUid: string;linkCode: string}> = (props) => {
          const {fileUid,linkCode} = props ?? {};

          return  generateDocumentTokenWithPublicLink(fileUid,linkCode,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateDocumentTokenWithPublicLinkMutationResult = NonNullable<Awaited<ReturnType<typeof generateDocumentTokenWithPublicLink>>>

    export type GenerateDocumentTokenWithPublicLinkMutationError = unknown

    /**
 * @summary Gera url publica temporária do arquivo através do link publico do processo
 */
export const useGenerateDocumentTokenWithPublicLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDocumentTokenWithPublicLink>>, TError,{fileUid: string;linkCode: string}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateDocumentTokenWithPublicLink>>,
        TError,
        {fileUid: string;linkCode: string},
        TContext
      > => {
      return useMutation(getGenerateDocumentTokenWithPublicLinkMutationOptions(options), queryClient);
    }

export type generateDocumentTokenResponse200 = {
  data: DocumentTokenDto
  status: 200
}

export type generateDocumentTokenResponseSuccess = (generateDocumentTokenResponse200) & {
  headers: Headers;
};
;

export type generateDocumentTokenResponse = (generateDocumentTokenResponseSuccess)

export const getGenerateDocumentTokenUrl = (fileUid: string,) => {




  return `/files/${fileUid}/generate-temporary-link`
}

/**
 * @summary Gera url publica temporária do arquivo
 */
export const generateDocumentToken = async (fileUid: string, options?: RequestInit): Promise<generateDocumentTokenResponse> => {

  return customInstanceDocumentos<generateDocumentTokenResponse>(getGenerateDocumentTokenUrl(fileUid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getGenerateDocumentTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDocumentToken>>, TError,{fileUid: string}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof generateDocumentToken>>, TError,{fileUid: string}, TContext> => {

const mutationKey = ['generateDocumentToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateDocumentToken>>, {fileUid: string}> = (props) => {
          const {fileUid} = props ?? {};

          return  generateDocumentToken(fileUid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateDocumentTokenMutationResult = NonNullable<Awaited<ReturnType<typeof generateDocumentToken>>>

    export type GenerateDocumentTokenMutationError = unknown

    /**
 * @summary Gera url publica temporária do arquivo
 */
export const useGenerateDocumentToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDocumentToken>>, TError,{fileUid: string}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateDocumentToken>>,
        TError,
        {fileUid: string},
        TContext
      > => {
      return useMutation(getGenerateDocumentTokenMutationOptions(options), queryClient);
    }

export type findSubDocumentTypeExternalLinkResponse404 = {
  data: Problem
  status: 404
}

;
export type findSubDocumentTypeExternalLinkResponseError = (findSubDocumentTypeExternalLinkResponse404) & {
  headers: Headers;
};

export type findSubDocumentTypeExternalLinkResponse = (findSubDocumentTypeExternalLinkResponseError)

export const getFindSubDocumentTypeExternalLinkUrl = (tenant: string,
    subDocumentTypeId: number,
    subDocumentTypeExternalLinkId: number,) => {




  return `/${tenant}/sub-document-types/${subDocumentTypeId}/external-links/${subDocumentTypeExternalLinkId}`
}

/**
 * @summary Busca uma referência externa de sub tipo de documento por ID
 */
export const findSubDocumentTypeExternalLink = async (tenant: string,
    subDocumentTypeId: number,
    subDocumentTypeExternalLinkId: number, options?: RequestInit): Promise<findSubDocumentTypeExternalLinkResponse> => {

  return customInstanceDocumentos<findSubDocumentTypeExternalLinkResponse>(getFindSubDocumentTypeExternalLinkUrl(tenant,subDocumentTypeId,subDocumentTypeExternalLinkId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindSubDocumentTypeExternalLinkQueryKey = (tenant: string,
    subDocumentTypeId: number,
    subDocumentTypeExternalLinkId: number,) => {
    return [
    `/${tenant}/sub-document-types/${subDocumentTypeId}/external-links/${subDocumentTypeExternalLinkId}`
    ] as const;
    }


export const getFindSubDocumentTypeExternalLinkQueryOptions = <TData = Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>, TError = Problem>(tenant: string,
    subDocumentTypeId: number,
    subDocumentTypeExternalLinkId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindSubDocumentTypeExternalLinkQueryKey(tenant,subDocumentTypeId,subDocumentTypeExternalLinkId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>> = ({ signal }) => findSubDocumentTypeExternalLink(tenant,subDocumentTypeId,subDocumentTypeExternalLinkId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && subDocumentTypeId !== null && subDocumentTypeId !== undefined && subDocumentTypeExternalLinkId !== null && subDocumentTypeExternalLinkId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindSubDocumentTypeExternalLinkQueryResult = NonNullable<Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>>
export type FindSubDocumentTypeExternalLinkQueryError = Problem


export function useFindSubDocumentTypeExternalLink<TData = Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>, TError = Problem>(
 tenant: string,
    subDocumentTypeId: number,
    subDocumentTypeExternalLinkId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>,
          TError,
          Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindSubDocumentTypeExternalLink<TData = Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>, TError = Problem>(
 tenant: string,
    subDocumentTypeId: number,
    subDocumentTypeExternalLinkId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>,
          TError,
          Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindSubDocumentTypeExternalLink<TData = Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>, TError = Problem>(
 tenant: string,
    subDocumentTypeId: number,
    subDocumentTypeExternalLinkId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca uma referência externa de sub tipo de documento por ID
 */

export function useFindSubDocumentTypeExternalLink<TData = Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>, TError = Problem>(
 tenant: string,
    subDocumentTypeId: number,
    subDocumentTypeExternalLinkId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSubDocumentTypeExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindSubDocumentTypeExternalLinkQueryOptions(tenant,subDocumentTypeId,subDocumentTypeExternalLinkId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type deleteSubDocumentTypeExternalLinkResponse204 = {
  data: void
  status: 204
}

export type deleteSubDocumentTypeExternalLinkResponse404 = {
  data: Problem
  status: 404
}

export type deleteSubDocumentTypeExternalLinkResponseSuccess = (deleteSubDocumentTypeExternalLinkResponse204) & {
  headers: Headers;
};
export type deleteSubDocumentTypeExternalLinkResponseError = (deleteSubDocumentTypeExternalLinkResponse404) & {
  headers: Headers;
};

export type deleteSubDocumentTypeExternalLinkResponse = (deleteSubDocumentTypeExternalLinkResponseSuccess | deleteSubDocumentTypeExternalLinkResponseError)

export const getDeleteSubDocumentTypeExternalLinkUrl = (tenant: string,
    subDocumentTypeId: number,
    subDocumentTypeExternalLinkId: number,) => {




  return `/${tenant}/sub-document-types/${subDocumentTypeId}/external-links/${subDocumentTypeExternalLinkId}`
}

/**
 * @summary Exclui uma nova referência externa de sub tipo de documento por ID
 */
export const deleteSubDocumentTypeExternalLink = async (tenant: string,
    subDocumentTypeId: number,
    subDocumentTypeExternalLinkId: number, options?: RequestInit): Promise<deleteSubDocumentTypeExternalLinkResponse> => {

  return customInstanceDocumentos<deleteSubDocumentTypeExternalLinkResponse>(getDeleteSubDocumentTypeExternalLinkUrl(tenant,subDocumentTypeId,subDocumentTypeExternalLinkId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSubDocumentTypeExternalLinkMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSubDocumentTypeExternalLink>>, TError,{tenant: string;subDocumentTypeId: number;subDocumentTypeExternalLinkId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSubDocumentTypeExternalLink>>, TError,{tenant: string;subDocumentTypeId: number;subDocumentTypeExternalLinkId: number}, TContext> => {

const mutationKey = ['deleteSubDocumentTypeExternalLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSubDocumentTypeExternalLink>>, {tenant: string;subDocumentTypeId: number;subDocumentTypeExternalLinkId: number}> = (props) => {
          const {tenant,subDocumentTypeId,subDocumentTypeExternalLinkId} = props ?? {};

          return  deleteSubDocumentTypeExternalLink(tenant,subDocumentTypeId,subDocumentTypeExternalLinkId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSubDocumentTypeExternalLinkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSubDocumentTypeExternalLink>>>

    export type DeleteSubDocumentTypeExternalLinkMutationError = Problem

    /**
 * @summary Exclui uma nova referência externa de sub tipo de documento por ID
 */
export const useDeleteSubDocumentTypeExternalLink = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSubDocumentTypeExternalLink>>, TError,{tenant: string;subDocumentTypeId: number;subDocumentTypeExternalLinkId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSubDocumentTypeExternalLink>>,
        TError,
        {tenant: string;subDocumentTypeId: number;subDocumentTypeExternalLinkId: number},
        TContext
      > => {
      return useMutation(getDeleteSubDocumentTypeExternalLinkMutationOptions(options), queryClient);
    }

export type listSigiloResponse200 = {
  data: SigiloDto[]
  status: 200
}

export type listSigiloResponseSuccess = (listSigiloResponse200) & {
  headers: Headers;
};
;

export type listSigiloResponse = (listSigiloResponseSuccess)

export const getListSigiloUrl = (tenant: string,) => {




  return `/${tenant}/sigilos`
}

/**
 * @summary Lista os sigilos
 */
export const listSigilo = async (tenant: string, options?: RequestInit): Promise<listSigiloResponse> => {

  return customInstanceDocumentos<listSigiloResponse>(getListSigiloUrl(tenant),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSigiloQueryKey = (tenant: string,) => {
    return [
    `/${tenant}/sigilos`
    ] as const;
    }


export const getListSigiloQueryOptions = <TData = Awaited<ReturnType<typeof listSigilo>>, TError = unknown>(tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSigilo>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSigiloQueryKey(tenant);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSigilo>>> = ({ signal }) => listSigilo(tenant, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSigilo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSigiloQueryResult = NonNullable<Awaited<ReturnType<typeof listSigilo>>>
export type ListSigiloQueryError = unknown


export function useListSigilo<TData = Awaited<ReturnType<typeof listSigilo>>, TError = unknown>(
 tenant: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSigilo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSigilo>>,
          TError,
          Awaited<ReturnType<typeof listSigilo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSigilo<TData = Awaited<ReturnType<typeof listSigilo>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSigilo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSigilo>>,
          TError,
          Awaited<ReturnType<typeof listSigilo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSigilo<TData = Awaited<ReturnType<typeof listSigilo>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSigilo>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os sigilos
 */

export function useListSigilo<TData = Awaited<ReturnType<typeof listSigilo>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSigilo>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSigiloQueryOptions(tenant,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getArchivalClassificationFiltrosResponse200 = {
  data: ArchivalClassificationFiltroDto
  status: 200
}

export type getArchivalClassificationFiltrosResponseSuccess = (getArchivalClassificationFiltrosResponse200) & {
  headers: Headers;
};
;

export type getArchivalClassificationFiltrosResponse = (getArchivalClassificationFiltrosResponseSuccess)

export const getGetArchivalClassificationFiltrosUrl = (tenant: string,) => {




  return `/${tenant}/archival-classifications/filtros`
}

/**
 * @summary Retorna total de classe, sub-classe, etc das classificações para serem utilizadas nos filtros do Smartdocs
 */
export const getArchivalClassificationFiltros = async (tenant: string, options?: RequestInit): Promise<getArchivalClassificationFiltrosResponse> => {

  return customInstanceDocumentos<getArchivalClassificationFiltrosResponse>(getGetArchivalClassificationFiltrosUrl(tenant),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetArchivalClassificationFiltrosQueryKey = (tenant: string,) => {
    return [
    `/${tenant}/archival-classifications/filtros`
    ] as const;
    }


export const getGetArchivalClassificationFiltrosQueryOptions = <TData = Awaited<ReturnType<typeof getArchivalClassificationFiltros>>, TError = unknown>(tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchivalClassificationFiltros>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArchivalClassificationFiltrosQueryKey(tenant);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArchivalClassificationFiltros>>> = ({ signal }) => getArchivalClassificationFiltros(tenant, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArchivalClassificationFiltros>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArchivalClassificationFiltrosQueryResult = NonNullable<Awaited<ReturnType<typeof getArchivalClassificationFiltros>>>
export type GetArchivalClassificationFiltrosQueryError = unknown


export function useGetArchivalClassificationFiltros<TData = Awaited<ReturnType<typeof getArchivalClassificationFiltros>>, TError = unknown>(
 tenant: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchivalClassificationFiltros>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArchivalClassificationFiltros>>,
          TError,
          Awaited<ReturnType<typeof getArchivalClassificationFiltros>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArchivalClassificationFiltros<TData = Awaited<ReturnType<typeof getArchivalClassificationFiltros>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchivalClassificationFiltros>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArchivalClassificationFiltros>>,
          TError,
          Awaited<ReturnType<typeof getArchivalClassificationFiltros>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArchivalClassificationFiltros<TData = Awaited<ReturnType<typeof getArchivalClassificationFiltros>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchivalClassificationFiltros>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna total de classe, sub-classe, etc das classificações para serem utilizadas nos filtros do Smartdocs
 */

export function useGetArchivalClassificationFiltros<TData = Awaited<ReturnType<typeof getArchivalClassificationFiltros>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchivalClassificationFiltros>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArchivalClassificationFiltrosQueryOptions(tenant,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type findSignatureByIdResponse404 = {
  data: Problem
  status: 404
}

;
export type findSignatureByIdResponseError = (findSignatureByIdResponse404) & {
  headers: Headers;
};

export type findSignatureByIdResponse = (findSignatureByIdResponseError)

export const getFindSignatureByIdUrl = (tenantId: string,
    signatureId: number,) => {




  return `/${tenantId}/signatures/${signatureId}`
}

/**
 * @summary Busca uma assinatura por ID
 */
export const findSignatureById = async (tenantId: string,
    signatureId: number, options?: RequestInit): Promise<findSignatureByIdResponse> => {

  return customInstanceDocumentos<findSignatureByIdResponse>(getFindSignatureByIdUrl(tenantId,signatureId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindSignatureByIdQueryKey = (tenantId: string,
    signatureId: number,) => {
    return [
    `/${tenantId}/signatures/${signatureId}`
    ] as const;
    }


export const getFindSignatureByIdQueryOptions = <TData = Awaited<ReturnType<typeof findSignatureById>>, TError = Problem>(tenantId: string,
    signatureId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSignatureById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindSignatureByIdQueryKey(tenantId,signatureId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findSignatureById>>> = ({ signal }) => findSignatureById(tenantId,signatureId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && signatureId !== null && signatureId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findSignatureById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindSignatureByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findSignatureById>>>
export type FindSignatureByIdQueryError = Problem


export function useFindSignatureById<TData = Awaited<ReturnType<typeof findSignatureById>>, TError = Problem>(
 tenantId: string,
    signatureId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSignatureById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSignatureById>>,
          TError,
          Awaited<ReturnType<typeof findSignatureById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindSignatureById<TData = Awaited<ReturnType<typeof findSignatureById>>, TError = Problem>(
 tenantId: string,
    signatureId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSignatureById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSignatureById>>,
          TError,
          Awaited<ReturnType<typeof findSignatureById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindSignatureById<TData = Awaited<ReturnType<typeof findSignatureById>>, TError = Problem>(
 tenantId: string,
    signatureId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSignatureById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca uma assinatura por ID
 */

export function useFindSignatureById<TData = Awaited<ReturnType<typeof findSignatureById>>, TError = Problem>(
 tenantId: string,
    signatureId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSignatureById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindSignatureByIdQueryOptions(tenantId,signatureId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadFileByHashResponse200 = {
  data: DownloadFileByHash200
  status: 200
}

export type downloadFileByHashResponseSuccess = (downloadFileByHashResponse200) & {
  headers: Headers;
};
;

export type downloadFileByHashResponse = (downloadFileByHashResponseSuccess)

export const getDownloadFileByHashUrl = (tenantId: string,
    hash: string,
    params?: DownloadFileByHashParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/signatures/hash/${hash}?${stringifiedParams}` : `/${tenantId}/signatures/hash/${hash}`
}

/**
 * @summary Busca o arquivo do assinado pelo hash
 */
export const downloadFileByHash = async (tenantId: string,
    hash: string,
    params?: DownloadFileByHashParams, options?: RequestInit): Promise<downloadFileByHashResponse> => {

  return customInstanceDocumentos<downloadFileByHashResponse>(getDownloadFileByHashUrl(tenantId,hash,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadFileByHashQueryKey = (tenantId: string,
    hash: string,
    params?: DownloadFileByHashParams,) => {
    return [
    `/${tenantId}/signatures/hash/${hash}`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadFileByHashQueryOptions = <TData = Awaited<ReturnType<typeof downloadFileByHash>>, TError = unknown>(tenantId: string,
    hash: string,
    params?: DownloadFileByHashParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFileByHash>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadFileByHashQueryKey(tenantId,hash,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadFileByHash>>> = ({ signal }) => downloadFileByHash(tenantId,hash,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && hash !== null && hash !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadFileByHash>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadFileByHashQueryResult = NonNullable<Awaited<ReturnType<typeof downloadFileByHash>>>
export type DownloadFileByHashQueryError = unknown


export function useDownloadFileByHash<TData = Awaited<ReturnType<typeof downloadFileByHash>>, TError = unknown>(
 tenantId: string,
    hash: string,
    params: undefined |  DownloadFileByHashParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFileByHash>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadFileByHash>>,
          TError,
          Awaited<ReturnType<typeof downloadFileByHash>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadFileByHash<TData = Awaited<ReturnType<typeof downloadFileByHash>>, TError = unknown>(
 tenantId: string,
    hash: string,
    params?: DownloadFileByHashParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFileByHash>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadFileByHash>>,
          TError,
          Awaited<ReturnType<typeof downloadFileByHash>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadFileByHash<TData = Awaited<ReturnType<typeof downloadFileByHash>>, TError = unknown>(
 tenantId: string,
    hash: string,
    params?: DownloadFileByHashParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFileByHash>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca o arquivo do assinado pelo hash
 */

export function useDownloadFileByHash<TData = Awaited<ReturnType<typeof downloadFileByHash>>, TError = unknown>(
 tenantId: string,
    hash: string,
    params?: DownloadFileByHashParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFileByHash>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadFileByHashQueryOptions(tenantId,hash,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSignatureResponse200 = {
  data: PageDigitalSignatureDto
  status: 200
}

export type listSignatureResponseSuccess = (listSignatureResponse200) & {
  headers: Headers;
};
;

export type listSignatureResponse = (listSignatureResponseSuccess)

export const getListSignatureUrl = (tenantId: string,
    params?: ListSignatureParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/signatures?${stringifiedParams}` : `/${tenantId}/signatures`
}

/**
 * @summary Lista as assinaturas
 */
export const listSignature = async (tenantId: string,
    params?: ListSignatureParams, options?: RequestInit): Promise<listSignatureResponse> => {

  return customInstanceDocumentos<listSignatureResponse>(getListSignatureUrl(tenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSignatureQueryKey = (tenantId: string,
    params?: ListSignatureParams,) => {
    return [
    `/${tenantId}/signatures`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSignatureQueryOptions = <TData = Awaited<ReturnType<typeof listSignature>>, TError = unknown>(tenantId: string,
    params?: ListSignatureParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSignature>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSignatureQueryKey(tenantId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSignature>>> = ({ signal }) => listSignature(tenantId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSignature>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSignatureQueryResult = NonNullable<Awaited<ReturnType<typeof listSignature>>>
export type ListSignatureQueryError = unknown


export function useListSignature<TData = Awaited<ReturnType<typeof listSignature>>, TError = unknown>(
 tenantId: string,
    params: undefined |  ListSignatureParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSignature>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSignature>>,
          TError,
          Awaited<ReturnType<typeof listSignature>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSignature<TData = Awaited<ReturnType<typeof listSignature>>, TError = unknown>(
 tenantId: string,
    params?: ListSignatureParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSignature>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSignature>>,
          TError,
          Awaited<ReturnType<typeof listSignature>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSignature<TData = Awaited<ReturnType<typeof listSignature>>, TError = unknown>(
 tenantId: string,
    params?: ListSignatureParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSignature>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as assinaturas
 */

export function useListSignature<TData = Awaited<ReturnType<typeof listSignature>>, TError = unknown>(
 tenantId: string,
    params?: ListSignatureParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSignature>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSignatureQueryOptions(tenantId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type findPendingDocumentResponse404 = {
  data: Problem
  status: 404
}

;
export type findPendingDocumentResponseError = (findPendingDocumentResponse404) & {
  headers: Headers;
};

export type findPendingDocumentResponse = (findPendingDocumentResponseError)

export const getFindPendingDocumentUrl = (tenantId: string,
    pendingDocumentId: number,) => {




  return `/${tenantId}/pending-documents/${pendingDocumentId}`
}

/**
 * @summary Busca uma pendencia documental por ID
 */
export const findPendingDocument = async (tenantId: string,
    pendingDocumentId: number, options?: RequestInit): Promise<findPendingDocumentResponse> => {

  return customInstanceDocumentos<findPendingDocumentResponse>(getFindPendingDocumentUrl(tenantId,pendingDocumentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindPendingDocumentQueryKey = (tenantId: string,
    pendingDocumentId: number,) => {
    return [
    `/${tenantId}/pending-documents/${pendingDocumentId}`
    ] as const;
    }


export const getFindPendingDocumentQueryOptions = <TData = Awaited<ReturnType<typeof findPendingDocument>>, TError = Problem>(tenantId: string,
    pendingDocumentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPendingDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPendingDocumentQueryKey(tenantId,pendingDocumentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPendingDocument>>> = ({ signal }) => findPendingDocument(tenantId,pendingDocumentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && pendingDocumentId !== null && pendingDocumentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findPendingDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPendingDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof findPendingDocument>>>
export type FindPendingDocumentQueryError = Problem


export function useFindPendingDocument<TData = Awaited<ReturnType<typeof findPendingDocument>>, TError = Problem>(
 tenantId: string,
    pendingDocumentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPendingDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPendingDocument>>,
          TError,
          Awaited<ReturnType<typeof findPendingDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPendingDocument<TData = Awaited<ReturnType<typeof findPendingDocument>>, TError = Problem>(
 tenantId: string,
    pendingDocumentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPendingDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPendingDocument>>,
          TError,
          Awaited<ReturnType<typeof findPendingDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPendingDocument<TData = Awaited<ReturnType<typeof findPendingDocument>>, TError = Problem>(
 tenantId: string,
    pendingDocumentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPendingDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca uma pendencia documental por ID
 */

export function useFindPendingDocument<TData = Awaited<ReturnType<typeof findPendingDocument>>, TError = Problem>(
 tenantId: string,
    pendingDocumentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPendingDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPendingDocumentQueryOptions(tenantId,pendingDocumentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type countPendingDocumentsResponse200 = {
  data: PendingDocumentStatisticDto[]
  status: 200
}

export type countPendingDocumentsResponseSuccess = (countPendingDocumentsResponse200) & {
  headers: Headers;
};
;

export type countPendingDocumentsResponse = (countPendingDocumentsResponseSuccess)

export const getCountPendingDocumentsUrl = (tenantId: string,
    params?: CountPendingDocumentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/pending-documents/statistic?${stringifiedParams}` : `/${tenantId}/pending-documents/statistic`
}

/**
 * @summary Retorna estatísticas das pendencias documentais
 */
export const countPendingDocuments = async (tenantId: string,
    params?: CountPendingDocumentsParams, options?: RequestInit): Promise<countPendingDocumentsResponse> => {

  return customInstanceDocumentos<countPendingDocumentsResponse>(getCountPendingDocumentsUrl(tenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCountPendingDocumentsQueryKey = (tenantId: string,
    params?: CountPendingDocumentsParams,) => {
    return [
    `/${tenantId}/pending-documents/statistic`, ...(params ? [params] : [])
    ] as const;
    }


export const getCountPendingDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof countPendingDocuments>>, TError = unknown>(tenantId: string,
    params?: CountPendingDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countPendingDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountPendingDocumentsQueryKey(tenantId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countPendingDocuments>>> = ({ signal }) => countPendingDocuments(tenantId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countPendingDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountPendingDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof countPendingDocuments>>>
export type CountPendingDocumentsQueryError = unknown


export function useCountPendingDocuments<TData = Awaited<ReturnType<typeof countPendingDocuments>>, TError = unknown>(
 tenantId: string,
    params: undefined |  CountPendingDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countPendingDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countPendingDocuments>>,
          TError,
          Awaited<ReturnType<typeof countPendingDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountPendingDocuments<TData = Awaited<ReturnType<typeof countPendingDocuments>>, TError = unknown>(
 tenantId: string,
    params?: CountPendingDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countPendingDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countPendingDocuments>>,
          TError,
          Awaited<ReturnType<typeof countPendingDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountPendingDocuments<TData = Awaited<ReturnType<typeof countPendingDocuments>>, TError = unknown>(
 tenantId: string,
    params?: CountPendingDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countPendingDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna estatísticas das pendencias documentais
 */

export function useCountPendingDocuments<TData = Awaited<ReturnType<typeof countPendingDocuments>>, TError = unknown>(
 tenantId: string,
    params?: CountPendingDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countPendingDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountPendingDocumentsQueryOptions(tenantId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listPendingDocumentResponse200 = {
  data: PagePendingDocumentDto
  status: 200
}

export type listPendingDocumentResponseSuccess = (listPendingDocumentResponse200) & {
  headers: Headers;
};
;

export type listPendingDocumentResponse = (listPendingDocumentResponseSuccess)

export const getListPendingDocumentUrl = (tenantId: string,
    params?: ListPendingDocumentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/pending-documents?${stringifiedParams}` : `/${tenantId}/pending-documents`
}

/**
 * @summary Lista as pendencias documentais
 */
export const listPendingDocument = async (tenantId: string,
    params?: ListPendingDocumentParams, options?: RequestInit): Promise<listPendingDocumentResponse> => {

  return customInstanceDocumentos<listPendingDocumentResponse>(getListPendingDocumentUrl(tenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPendingDocumentQueryKey = (tenantId: string,
    params?: ListPendingDocumentParams,) => {
    return [
    `/${tenantId}/pending-documents`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPendingDocumentQueryOptions = <TData = Awaited<ReturnType<typeof listPendingDocument>>, TError = unknown>(tenantId: string,
    params?: ListPendingDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPendingDocumentQueryKey(tenantId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPendingDocument>>> = ({ signal }) => listPendingDocument(tenantId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPendingDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPendingDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof listPendingDocument>>>
export type ListPendingDocumentQueryError = unknown


export function useListPendingDocument<TData = Awaited<ReturnType<typeof listPendingDocument>>, TError = unknown>(
 tenantId: string,
    params: undefined |  ListPendingDocumentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPendingDocument>>,
          TError,
          Awaited<ReturnType<typeof listPendingDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingDocument<TData = Awaited<ReturnType<typeof listPendingDocument>>, TError = unknown>(
 tenantId: string,
    params?: ListPendingDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPendingDocument>>,
          TError,
          Awaited<ReturnType<typeof listPendingDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingDocument<TData = Awaited<ReturnType<typeof listPendingDocument>>, TError = unknown>(
 tenantId: string,
    params?: ListPendingDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as pendencias documentais
 */

export function useListPendingDocument<TData = Awaited<ReturnType<typeof listPendingDocument>>, TError = unknown>(
 tenantId: string,
    params?: ListPendingDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPendingDocumentQueryOptions(tenantId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listPendingSituationResponse200 = {
  data: PendingSituationDto[]
  status: 200
}

export type listPendingSituationResponseSuccess = (listPendingSituationResponse200) & {
  headers: Headers;
};
;

export type listPendingSituationResponse = (listPendingSituationResponseSuccess)

export const getListPendingSituationUrl = (tenantId: string,) => {




  return `/${tenantId}/pending-document-situations`
}

/**
 * @summary Lista os tipos de situações das pendencias documentais
 */
export const listPendingSituation = async (tenantId: string, options?: RequestInit): Promise<listPendingSituationResponse> => {

  return customInstanceDocumentos<listPendingSituationResponse>(getListPendingSituationUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPendingSituationQueryKey = (tenantId: string,) => {
    return [
    `/${tenantId}/pending-document-situations`
    ] as const;
    }


export const getListPendingSituationQueryOptions = <TData = Awaited<ReturnType<typeof listPendingSituation>>, TError = unknown>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingSituation>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPendingSituationQueryKey(tenantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPendingSituation>>> = ({ signal }) => listPendingSituation(tenantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPendingSituation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPendingSituationQueryResult = NonNullable<Awaited<ReturnType<typeof listPendingSituation>>>
export type ListPendingSituationQueryError = unknown


export function useListPendingSituation<TData = Awaited<ReturnType<typeof listPendingSituation>>, TError = unknown>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingSituation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPendingSituation>>,
          TError,
          Awaited<ReturnType<typeof listPendingSituation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingSituation<TData = Awaited<ReturnType<typeof listPendingSituation>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingSituation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPendingSituation>>,
          TError,
          Awaited<ReturnType<typeof listPendingSituation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingSituation<TData = Awaited<ReturnType<typeof listPendingSituation>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingSituation>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os tipos de situações das pendencias documentais
 */

export function useListPendingSituation<TData = Awaited<ReturnType<typeof listPendingSituation>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingSituation>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPendingSituationQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listProcessExecutionHistoryResponse200 = {
  data: PageDocumentProcessStartExecutionLogDto
  status: 200
}

export type listProcessExecutionHistoryResponseSuccess = (listProcessExecutionHistoryResponse200) & {
  headers: Headers;
};
;

export type listProcessExecutionHistoryResponse = (listProcessExecutionHistoryResponseSuccess)

export const getListProcessExecutionHistoryUrl = (tenantId: string,
    pastaId: number,
    params?: ListProcessExecutionHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/folders/${pastaId}/process-execution-history?${stringifiedParams}` : `/${tenantId}/folders/${pastaId}/process-execution-history`
}

/**
 * @summary Lista histórico dos processos que foram iniciados atraves da pasta
 */
export const listProcessExecutionHistory = async (tenantId: string,
    pastaId: number,
    params?: ListProcessExecutionHistoryParams, options?: RequestInit): Promise<listProcessExecutionHistoryResponse> => {

  return customInstanceDocumentos<listProcessExecutionHistoryResponse>(getListProcessExecutionHistoryUrl(tenantId,pastaId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProcessExecutionHistoryQueryKey = (tenantId: string,
    pastaId: number,
    params?: ListProcessExecutionHistoryParams,) => {
    return [
    `/${tenantId}/folders/${pastaId}/process-execution-history`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProcessExecutionHistoryQueryOptions = <TData = Awaited<ReturnType<typeof listProcessExecutionHistory>>, TError = unknown>(tenantId: string,
    pastaId: number,
    params?: ListProcessExecutionHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessExecutionHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProcessExecutionHistoryQueryKey(tenantId,pastaId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProcessExecutionHistory>>> = ({ signal }) => listProcessExecutionHistory(tenantId,pastaId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && pastaId !== null && pastaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProcessExecutionHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProcessExecutionHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof listProcessExecutionHistory>>>
export type ListProcessExecutionHistoryQueryError = unknown


export function useListProcessExecutionHistory<TData = Awaited<ReturnType<typeof listProcessExecutionHistory>>, TError = unknown>(
 tenantId: string,
    pastaId: number,
    params: undefined |  ListProcessExecutionHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessExecutionHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessExecutionHistory>>,
          TError,
          Awaited<ReturnType<typeof listProcessExecutionHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessExecutionHistory<TData = Awaited<ReturnType<typeof listProcessExecutionHistory>>, TError = unknown>(
 tenantId: string,
    pastaId: number,
    params?: ListProcessExecutionHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessExecutionHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessExecutionHistory>>,
          TError,
          Awaited<ReturnType<typeof listProcessExecutionHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessExecutionHistory<TData = Awaited<ReturnType<typeof listProcessExecutionHistory>>, TError = unknown>(
 tenantId: string,
    pastaId: number,
    params?: ListProcessExecutionHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessExecutionHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista histórico dos processos que foram iniciados atraves da pasta
 */

export function useListProcessExecutionHistory<TData = Awaited<ReturnType<typeof listProcessExecutionHistory>>, TError = unknown>(
 tenantId: string,
    pastaId: number,
    params?: ListProcessExecutionHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessExecutionHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProcessExecutionHistoryQueryOptions(tenantId,pastaId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listExtensionResponse200 = {
  data: ExtensionDto[]
  status: 200
}

export type listExtensionResponseSuccess = (listExtensionResponse200) & {
  headers: Headers;
};
;

export type listExtensionResponse = (listExtensionResponseSuccess)

export const getListExtensionUrl = (tenantId: string,) => {




  return `/${tenantId}/extensions`
}

/**
 * @summary Lista as extensões dos documentos
 */
export const listExtension = async (tenantId: string, options?: RequestInit): Promise<listExtensionResponse> => {

  return customInstanceDocumentos<listExtensionResponse>(getListExtensionUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExtensionQueryKey = (tenantId: string,) => {
    return [
    `/${tenantId}/extensions`
    ] as const;
    }


export const getListExtensionQueryOptions = <TData = Awaited<ReturnType<typeof listExtension>>, TError = unknown>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExtension>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExtensionQueryKey(tenantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExtension>>> = ({ signal }) => listExtension(tenantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExtension>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExtensionQueryResult = NonNullable<Awaited<ReturnType<typeof listExtension>>>
export type ListExtensionQueryError = unknown


export function useListExtension<TData = Awaited<ReturnType<typeof listExtension>>, TError = unknown>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExtension>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExtension>>,
          TError,
          Awaited<ReturnType<typeof listExtension>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExtension<TData = Awaited<ReturnType<typeof listExtension>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExtension>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExtension>>,
          TError,
          Awaited<ReturnType<typeof listExtension>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExtension<TData = Awaited<ReturnType<typeof listExtension>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExtension>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as extensões dos documentos
 */

export function useListExtension<TData = Awaited<ReturnType<typeof listExtension>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExtension>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExtensionQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listPendingDocumentsByDocumentResponse200 = {
  data: PendingDocumentDto[]
  status: 200
}

export type listPendingDocumentsByDocumentResponseSuccess = (listPendingDocumentsByDocumentResponse200) & {
  headers: Headers;
};
;

export type listPendingDocumentsByDocumentResponse = (listPendingDocumentsByDocumentResponseSuccess)

export const getListPendingDocumentsByDocumentUrl = (tenantId: string,
    documentId: number,) => {




  return `/${tenantId}/documents/${documentId}/pending-documents`
}

/**
 * @summary Lista as pendências documentais do documento
 */
export const listPendingDocumentsByDocument = async (tenantId: string,
    documentId: number, options?: RequestInit): Promise<listPendingDocumentsByDocumentResponse> => {

  return customInstanceDocumentos<listPendingDocumentsByDocumentResponse>(getListPendingDocumentsByDocumentUrl(tenantId,documentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPendingDocumentsByDocumentQueryKey = (tenantId: string,
    documentId: number,) => {
    return [
    `/${tenantId}/documents/${documentId}/pending-documents`
    ] as const;
    }


export const getListPendingDocumentsByDocumentQueryOptions = <TData = Awaited<ReturnType<typeof listPendingDocumentsByDocument>>, TError = unknown>(tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingDocumentsByDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPendingDocumentsByDocumentQueryKey(tenantId,documentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPendingDocumentsByDocument>>> = ({ signal }) => listPendingDocumentsByDocument(tenantId,documentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPendingDocumentsByDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPendingDocumentsByDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof listPendingDocumentsByDocument>>>
export type ListPendingDocumentsByDocumentQueryError = unknown


export function useListPendingDocumentsByDocument<TData = Awaited<ReturnType<typeof listPendingDocumentsByDocument>>, TError = unknown>(
 tenantId: string,
    documentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingDocumentsByDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPendingDocumentsByDocument>>,
          TError,
          Awaited<ReturnType<typeof listPendingDocumentsByDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingDocumentsByDocument<TData = Awaited<ReturnType<typeof listPendingDocumentsByDocument>>, TError = unknown>(
 tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingDocumentsByDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPendingDocumentsByDocument>>,
          TError,
          Awaited<ReturnType<typeof listPendingDocumentsByDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingDocumentsByDocument<TData = Awaited<ReturnType<typeof listPendingDocumentsByDocument>>, TError = unknown>(
 tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingDocumentsByDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as pendências documentais do documento
 */

export function useListPendingDocumentsByDocument<TData = Awaited<ReturnType<typeof listPendingDocumentsByDocument>>, TError = unknown>(
 tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingDocumentsByDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPendingDocumentsByDocumentQueryOptions(tenantId,documentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listDocumentParentsResponse404 = {
  data: Problem
  status: 404
}

;
export type listDocumentParentsResponseError = (listDocumentParentsResponse404) & {
  headers: Headers;
};

export type listDocumentParentsResponse = (listDocumentParentsResponseError)

export const getListDocumentParentsUrl = (tenantId: string,
    documentId: number,) => {




  return `/${tenantId}/documents/${documentId}/parents`
}

/**
 * @summary Lista os documentos pai de um documento
 */
export const listDocumentParents = async (tenantId: string,
    documentId: number, options?: RequestInit): Promise<listDocumentParentsResponse> => {

  return customInstanceDocumentos<listDocumentParentsResponse>(getListDocumentParentsUrl(tenantId,documentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDocumentParentsQueryKey = (tenantId: string,
    documentId: number,) => {
    return [
    `/${tenantId}/documents/${documentId}/parents`
    ] as const;
    }


export const getListDocumentParentsQueryOptions = <TData = Awaited<ReturnType<typeof listDocumentParents>>, TError = Problem>(tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentParents>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDocumentParentsQueryKey(tenantId,documentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocumentParents>>> = ({ signal }) => listDocumentParents(tenantId,documentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDocumentParents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDocumentParentsQueryResult = NonNullable<Awaited<ReturnType<typeof listDocumentParents>>>
export type ListDocumentParentsQueryError = Problem


export function useListDocumentParents<TData = Awaited<ReturnType<typeof listDocumentParents>>, TError = Problem>(
 tenantId: string,
    documentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentParents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentParents>>,
          TError,
          Awaited<ReturnType<typeof listDocumentParents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentParents<TData = Awaited<ReturnType<typeof listDocumentParents>>, TError = Problem>(
 tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentParents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentParents>>,
          TError,
          Awaited<ReturnType<typeof listDocumentParents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentParents<TData = Awaited<ReturnType<typeof listDocumentParents>>, TError = Problem>(
 tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentParents>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os documentos pai de um documento
 */

export function useListDocumentParents<TData = Awaited<ReturnType<typeof listDocumentParents>>, TError = Problem>(
 tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentParents>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDocumentParentsQueryOptions(tenantId,documentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listDocumentLogResponse200 = {
  data: PageDocumentLogDto
  status: 200
}

export type listDocumentLogResponseSuccess = (listDocumentLogResponse200) & {
  headers: Headers;
};
;

export type listDocumentLogResponse = (listDocumentLogResponseSuccess)

export const getListDocumentLogUrl = (tenantId: string,
    documentId: number,
    params?: ListDocumentLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/history?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/history`
}

/**
 * @summary Lista o historico do documento
 */
export const listDocumentLog = async (tenantId: string,
    documentId: number,
    params?: ListDocumentLogParams, options?: RequestInit): Promise<listDocumentLogResponse> => {

  return customInstanceDocumentos<listDocumentLogResponse>(getListDocumentLogUrl(tenantId,documentId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDocumentLogQueryKey = (tenantId: string,
    documentId: number,
    params?: ListDocumentLogParams,) => {
    return [
    `/${tenantId}/documents/${documentId}/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDocumentLogQueryOptions = <TData = Awaited<ReturnType<typeof listDocumentLog>>, TError = unknown>(tenantId: string,
    documentId: number,
    params?: ListDocumentLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentLog>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDocumentLogQueryKey(tenantId,documentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocumentLog>>> = ({ signal }) => listDocumentLog(tenantId,documentId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDocumentLog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDocumentLogQueryResult = NonNullable<Awaited<ReturnType<typeof listDocumentLog>>>
export type ListDocumentLogQueryError = unknown


export function useListDocumentLog<TData = Awaited<ReturnType<typeof listDocumentLog>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params: undefined |  ListDocumentLogParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentLog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentLog>>,
          TError,
          Awaited<ReturnType<typeof listDocumentLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentLog<TData = Awaited<ReturnType<typeof listDocumentLog>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: ListDocumentLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentLog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentLog>>,
          TError,
          Awaited<ReturnType<typeof listDocumentLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentLog<TData = Awaited<ReturnType<typeof listDocumentLog>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: ListDocumentLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentLog>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista o historico do documento
 */

export function useListDocumentLog<TData = Awaited<ReturnType<typeof listDocumentLog>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: ListDocumentLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentLog>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDocumentLogQueryOptions(tenantId,documentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type visualizeFileResponse200 = {
  data: VisualizeFile200
  status: 200
}

export type visualizeFileResponseSuccess = (visualizeFileResponse200) & {
  headers: Headers;
};
;

export type visualizeFileResponse = (visualizeFileResponseSuccess)

export const getVisualizeFileUrl = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: VisualizeFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files/${digitalFileId}/visualize?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files/${digitalFileId}/visualize`
}

/**
 * @summary Visualize o arquivo do documento pelo Id
 */
export const visualizeFile = async (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: VisualizeFileParams, options?: RequestInit): Promise<visualizeFileResponse> => {

  return customInstanceDocumentos<visualizeFileResponse>(getVisualizeFileUrl(tenantId,documentId,digitalFileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVisualizeFileQueryKey = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: VisualizeFileParams,) => {
    return [
    `/${tenantId}/documents/${documentId}/files/${digitalFileId}/visualize`, ...(params ? [params] : [])
    ] as const;
    }


export const getVisualizeFileQueryOptions = <TData = Awaited<ReturnType<typeof visualizeFile>>, TError = unknown>(tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: VisualizeFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof visualizeFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVisualizeFileQueryKey(tenantId,documentId,digitalFileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof visualizeFile>>> = ({ signal }) => visualizeFile(tenantId,documentId,digitalFileId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && documentId !== null && documentId !== undefined && digitalFileId !== null && digitalFileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof visualizeFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VisualizeFileQueryResult = NonNullable<Awaited<ReturnType<typeof visualizeFile>>>
export type VisualizeFileQueryError = unknown


export function useVisualizeFile<TData = Awaited<ReturnType<typeof visualizeFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    digitalFileId: string,
    params: undefined |  VisualizeFileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof visualizeFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof visualizeFile>>,
          TError,
          Awaited<ReturnType<typeof visualizeFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVisualizeFile<TData = Awaited<ReturnType<typeof visualizeFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: VisualizeFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof visualizeFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof visualizeFile>>,
          TError,
          Awaited<ReturnType<typeof visualizeFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVisualizeFile<TData = Awaited<ReturnType<typeof visualizeFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: VisualizeFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof visualizeFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Visualize o arquivo do documento pelo Id
 */

export function useVisualizeFile<TData = Awaited<ReturnType<typeof visualizeFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: VisualizeFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof visualizeFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVisualizeFileQueryOptions(tenantId,documentId,digitalFileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadThumbnailResponse200 = {
  data: DownloadThumbnail200
  status: 200
}

export type downloadThumbnailResponseSuccess = (downloadThumbnailResponse200) & {
  headers: Headers;
};
;

export type downloadThumbnailResponse = (downloadThumbnailResponseSuccess)

export const getDownloadThumbnailUrl = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: DownloadThumbnailParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files/${digitalFileId}/thumbnail?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files/${digitalFileId}/thumbnail`
}

/**
 * @summary Busca o thumbnail do arquivo do documento pelo Id
 */
export const downloadThumbnail = async (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: DownloadThumbnailParams, options?: RequestInit): Promise<downloadThumbnailResponse> => {

  return customInstanceDocumentos<downloadThumbnailResponse>(getDownloadThumbnailUrl(tenantId,documentId,digitalFileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadThumbnailQueryKey = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: DownloadThumbnailParams,) => {
    return [
    `/${tenantId}/documents/${documentId}/files/${digitalFileId}/thumbnail`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadThumbnailQueryOptions = <TData = Awaited<ReturnType<typeof downloadThumbnail>>, TError = unknown>(tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: DownloadThumbnailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadThumbnail>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadThumbnailQueryKey(tenantId,documentId,digitalFileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadThumbnail>>> = ({ signal }) => downloadThumbnail(tenantId,documentId,digitalFileId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && documentId !== null && documentId !== undefined && digitalFileId !== null && digitalFileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadThumbnail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadThumbnailQueryResult = NonNullable<Awaited<ReturnType<typeof downloadThumbnail>>>
export type DownloadThumbnailQueryError = unknown


export function useDownloadThumbnail<TData = Awaited<ReturnType<typeof downloadThumbnail>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    digitalFileId: string,
    params: undefined |  DownloadThumbnailParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadThumbnail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadThumbnail>>,
          TError,
          Awaited<ReturnType<typeof downloadThumbnail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadThumbnail<TData = Awaited<ReturnType<typeof downloadThumbnail>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: DownloadThumbnailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadThumbnail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadThumbnail>>,
          TError,
          Awaited<ReturnType<typeof downloadThumbnail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadThumbnail<TData = Awaited<ReturnType<typeof downloadThumbnail>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: DownloadThumbnailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadThumbnail>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca o thumbnail do arquivo do documento pelo Id
 */

export function useDownloadThumbnail<TData = Awaited<ReturnType<typeof downloadThumbnail>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: DownloadThumbnailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadThumbnail>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadThumbnailQueryOptions(tenantId,documentId,digitalFileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadFileResponse200 = {
  data: DownloadFile200
  status: 200
}

export type downloadFileResponseSuccess = (downloadFileResponse200) & {
  headers: Headers;
};
;

export type downloadFileResponse = (downloadFileResponseSuccess)

export const getDownloadFileUrl = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: DownloadFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files/${digitalFileId}/download?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files/${digitalFileId}/download`
}

/**
 * @summary Busca o arquivo do documento pelo Id
 */
export const downloadFile = async (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: DownloadFileParams, options?: RequestInit): Promise<downloadFileResponse> => {

  return customInstanceDocumentos<downloadFileResponse>(getDownloadFileUrl(tenantId,documentId,digitalFileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadFileQueryKey = (tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: DownloadFileParams,) => {
    return [
    `/${tenantId}/documents/${documentId}/files/${digitalFileId}/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadFileQueryOptions = <TData = Awaited<ReturnType<typeof downloadFile>>, TError = unknown>(tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: DownloadFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadFileQueryKey(tenantId,documentId,digitalFileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadFile>>> = ({ signal }) => downloadFile(tenantId,documentId,digitalFileId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && documentId !== null && documentId !== undefined && digitalFileId !== null && digitalFileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadFileQueryResult = NonNullable<Awaited<ReturnType<typeof downloadFile>>>
export type DownloadFileQueryError = unknown


export function useDownloadFile<TData = Awaited<ReturnType<typeof downloadFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    digitalFileId: string,
    params: undefined |  DownloadFileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadFile>>,
          TError,
          Awaited<ReturnType<typeof downloadFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadFile<TData = Awaited<ReturnType<typeof downloadFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: DownloadFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadFile>>,
          TError,
          Awaited<ReturnType<typeof downloadFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadFile<TData = Awaited<ReturnType<typeof downloadFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: DownloadFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca o arquivo do documento pelo Id
 */

export function useDownloadFile<TData = Awaited<ReturnType<typeof downloadFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    digitalFileId: string,
    params?: DownloadFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadFileQueryOptions(tenantId,documentId,digitalFileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type visualizeMainFileResponse200 = {
  data: VisualizeMainFile200
  status: 200
}

export type visualizeMainFileResponseSuccess = (visualizeMainFileResponse200) & {
  headers: Headers;
};
;

export type visualizeMainFileResponse = (visualizeMainFileResponseSuccess)

export const getVisualizeMainFileUrl = (tenantId: string,
    documentId: number,
    params?: VisualizeMainFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files/visualize?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files/visualize`
}

/**
 * @summary Visualize o arquivo principal do documento
 */
export const visualizeMainFile = async (tenantId: string,
    documentId: number,
    params?: VisualizeMainFileParams, options?: RequestInit): Promise<visualizeMainFileResponse> => {

  return customInstanceDocumentos<visualizeMainFileResponse>(getVisualizeMainFileUrl(tenantId,documentId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVisualizeMainFileQueryKey = (tenantId: string,
    documentId: number,
    params?: VisualizeMainFileParams,) => {
    return [
    `/${tenantId}/documents/${documentId}/files/visualize`, ...(params ? [params] : [])
    ] as const;
    }


export const getVisualizeMainFileQueryOptions = <TData = Awaited<ReturnType<typeof visualizeMainFile>>, TError = unknown>(tenantId: string,
    documentId: number,
    params?: VisualizeMainFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof visualizeMainFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVisualizeMainFileQueryKey(tenantId,documentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof visualizeMainFile>>> = ({ signal }) => visualizeMainFile(tenantId,documentId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof visualizeMainFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VisualizeMainFileQueryResult = NonNullable<Awaited<ReturnType<typeof visualizeMainFile>>>
export type VisualizeMainFileQueryError = unknown


export function useVisualizeMainFile<TData = Awaited<ReturnType<typeof visualizeMainFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params: undefined |  VisualizeMainFileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof visualizeMainFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof visualizeMainFile>>,
          TError,
          Awaited<ReturnType<typeof visualizeMainFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVisualizeMainFile<TData = Awaited<ReturnType<typeof visualizeMainFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: VisualizeMainFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof visualizeMainFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof visualizeMainFile>>,
          TError,
          Awaited<ReturnType<typeof visualizeMainFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVisualizeMainFile<TData = Awaited<ReturnType<typeof visualizeMainFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: VisualizeMainFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof visualizeMainFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Visualize o arquivo principal do documento
 */

export function useVisualizeMainFile<TData = Awaited<ReturnType<typeof visualizeMainFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: VisualizeMainFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof visualizeMainFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVisualizeMainFileQueryOptions(tenantId,documentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadMainThumbnailResponse200 = {
  data: DownloadMainThumbnail200
  status: 200
}

export type downloadMainThumbnailResponseSuccess = (downloadMainThumbnailResponse200) & {
  headers: Headers;
};
;

export type downloadMainThumbnailResponse = (downloadMainThumbnailResponseSuccess)

export const getDownloadMainThumbnailUrl = (tenantId: string,
    documentId: number,) => {




  return `/${tenantId}/documents/${documentId}/files/thumbnail`
}

/**
 * @summary Busca o thumbnail do arquivo principal do documento
 */
export const downloadMainThumbnail = async (tenantId: string,
    documentId: number, options?: RequestInit): Promise<downloadMainThumbnailResponse> => {

  return customInstanceDocumentos<downloadMainThumbnailResponse>(getDownloadMainThumbnailUrl(tenantId,documentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadMainThumbnailQueryKey = (tenantId: string,
    documentId: number,) => {
    return [
    `/${tenantId}/documents/${documentId}/files/thumbnail`
    ] as const;
    }


export const getDownloadMainThumbnailQueryOptions = <TData = Awaited<ReturnType<typeof downloadMainThumbnail>>, TError = unknown>(tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadMainThumbnail>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadMainThumbnailQueryKey(tenantId,documentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadMainThumbnail>>> = ({ signal }) => downloadMainThumbnail(tenantId,documentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadMainThumbnail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadMainThumbnailQueryResult = NonNullable<Awaited<ReturnType<typeof downloadMainThumbnail>>>
export type DownloadMainThumbnailQueryError = unknown


export function useDownloadMainThumbnail<TData = Awaited<ReturnType<typeof downloadMainThumbnail>>, TError = unknown>(
 tenantId: string,
    documentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadMainThumbnail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadMainThumbnail>>,
          TError,
          Awaited<ReturnType<typeof downloadMainThumbnail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadMainThumbnail<TData = Awaited<ReturnType<typeof downloadMainThumbnail>>, TError = unknown>(
 tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadMainThumbnail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadMainThumbnail>>,
          TError,
          Awaited<ReturnType<typeof downloadMainThumbnail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadMainThumbnail<TData = Awaited<ReturnType<typeof downloadMainThumbnail>>, TError = unknown>(
 tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadMainThumbnail>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca o thumbnail do arquivo principal do documento
 */

export function useDownloadMainThumbnail<TData = Awaited<ReturnType<typeof downloadMainThumbnail>>, TError = unknown>(
 tenantId: string,
    documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadMainThumbnail>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadMainThumbnailQueryOptions(tenantId,documentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadMainFileResponse200 = {
  data: DownloadMainFile200
  status: 200
}

export type downloadMainFileResponseSuccess = (downloadMainFileResponse200) & {
  headers: Headers;
};
;

export type downloadMainFileResponse = (downloadMainFileResponseSuccess)

export const getDownloadMainFileUrl = (tenantId: string,
    documentId: number,
    params?: DownloadMainFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files/download?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files/download`
}

/**
 * @summary Busca o arquivo principal do documento
 */
export const downloadMainFile = async (tenantId: string,
    documentId: number,
    params?: DownloadMainFileParams, options?: RequestInit): Promise<downloadMainFileResponse> => {

  return customInstanceDocumentos<downloadMainFileResponse>(getDownloadMainFileUrl(tenantId,documentId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadMainFileQueryKey = (tenantId: string,
    documentId: number,
    params?: DownloadMainFileParams,) => {
    return [
    `/${tenantId}/documents/${documentId}/files/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadMainFileQueryOptions = <TData = Awaited<ReturnType<typeof downloadMainFile>>, TError = unknown>(tenantId: string,
    documentId: number,
    params?: DownloadMainFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadMainFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadMainFileQueryKey(tenantId,documentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadMainFile>>> = ({ signal }) => downloadMainFile(tenantId,documentId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadMainFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadMainFileQueryResult = NonNullable<Awaited<ReturnType<typeof downloadMainFile>>>
export type DownloadMainFileQueryError = unknown


export function useDownloadMainFile<TData = Awaited<ReturnType<typeof downloadMainFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params: undefined |  DownloadMainFileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadMainFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadMainFile>>,
          TError,
          Awaited<ReturnType<typeof downloadMainFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadMainFile<TData = Awaited<ReturnType<typeof downloadMainFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: DownloadMainFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadMainFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadMainFile>>,
          TError,
          Awaited<ReturnType<typeof downloadMainFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadMainFile<TData = Awaited<ReturnType<typeof downloadMainFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: DownloadMainFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadMainFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca o arquivo principal do documento
 */

export function useDownloadMainFile<TData = Awaited<ReturnType<typeof downloadMainFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: DownloadMainFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadMainFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadMainFileQueryOptions(tenantId,documentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listDigitalFileResponse200 = {
  data: DigitalFileDto[]
  status: 200
}

export type listDigitalFileResponseSuccess = (listDigitalFileResponse200) & {
  headers: Headers;
};
;

export type listDigitalFileResponse = (listDigitalFileResponseSuccess)

export const getListDigitalFileUrl = (tenantId: string,
    documentId: number,
    params?: ListDigitalFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/files?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/files`
}

/**
 * @summary Lista os arquivos do documento
 */
export const listDigitalFile = async (tenantId: string,
    documentId: number,
    params?: ListDigitalFileParams, options?: RequestInit): Promise<listDigitalFileResponse> => {

  return customInstanceDocumentos<listDigitalFileResponse>(getListDigitalFileUrl(tenantId,documentId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDigitalFileQueryKey = (tenantId: string,
    documentId: number,
    params?: ListDigitalFileParams,) => {
    return [
    `/${tenantId}/documents/${documentId}/files`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDigitalFileQueryOptions = <TData = Awaited<ReturnType<typeof listDigitalFile>>, TError = unknown>(tenantId: string,
    documentId: number,
    params?: ListDigitalFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDigitalFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDigitalFileQueryKey(tenantId,documentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDigitalFile>>> = ({ signal }) => listDigitalFile(tenantId,documentId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDigitalFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDigitalFileQueryResult = NonNullable<Awaited<ReturnType<typeof listDigitalFile>>>
export type ListDigitalFileQueryError = unknown


export function useListDigitalFile<TData = Awaited<ReturnType<typeof listDigitalFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params: undefined |  ListDigitalFileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDigitalFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDigitalFile>>,
          TError,
          Awaited<ReturnType<typeof listDigitalFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDigitalFile<TData = Awaited<ReturnType<typeof listDigitalFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: ListDigitalFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDigitalFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDigitalFile>>,
          TError,
          Awaited<ReturnType<typeof listDigitalFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDigitalFile<TData = Awaited<ReturnType<typeof listDigitalFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: ListDigitalFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDigitalFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os arquivos do documento
 */

export function useListDigitalFile<TData = Awaited<ReturnType<typeof listDigitalFile>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: ListDigitalFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDigitalFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDigitalFileQueryOptions(tenantId,documentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type findDocumentExternalLinkResponse204 = {
  data: DocumentExternalLinkDto
  status: 204
}

export type findDocumentExternalLinkResponse404 = {
  data: Problem
  status: 404
}

export type findDocumentExternalLinkResponseSuccess = (findDocumentExternalLinkResponse204) & {
  headers: Headers;
};
export type findDocumentExternalLinkResponseError = (findDocumentExternalLinkResponse404) & {
  headers: Headers;
};

export type findDocumentExternalLinkResponse = (findDocumentExternalLinkResponseSuccess | findDocumentExternalLinkResponseError)

export const getFindDocumentExternalLinkUrl = (tenantId: string,
    documentId: number,
    externalLinkId: number,) => {




  return `/${tenantId}/documents/${documentId}/external-links/${externalLinkId}`
}

/**
 * @summary Busca uma referência externa do documento por ID
 */
export const findDocumentExternalLink = async (tenantId: string,
    documentId: number,
    externalLinkId: number, options?: RequestInit): Promise<findDocumentExternalLinkResponse> => {

  return customInstanceDocumentos<findDocumentExternalLinkResponse>(getFindDocumentExternalLinkUrl(tenantId,documentId,externalLinkId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindDocumentExternalLinkQueryKey = (tenantId: string,
    documentId: number,
    externalLinkId: number,) => {
    return [
    `/${tenantId}/documents/${documentId}/external-links/${externalLinkId}`
    ] as const;
    }


export const getFindDocumentExternalLinkQueryOptions = <TData = Awaited<ReturnType<typeof findDocumentExternalLink>>, TError = Problem>(tenantId: string,
    documentId: number,
    externalLinkId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDocumentExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindDocumentExternalLinkQueryKey(tenantId,documentId,externalLinkId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findDocumentExternalLink>>> = ({ signal }) => findDocumentExternalLink(tenantId,documentId,externalLinkId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && documentId !== null && documentId !== undefined && externalLinkId !== null && externalLinkId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findDocumentExternalLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindDocumentExternalLinkQueryResult = NonNullable<Awaited<ReturnType<typeof findDocumentExternalLink>>>
export type FindDocumentExternalLinkQueryError = Problem


export function useFindDocumentExternalLink<TData = Awaited<ReturnType<typeof findDocumentExternalLink>>, TError = Problem>(
 tenantId: string,
    documentId: number,
    externalLinkId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDocumentExternalLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findDocumentExternalLink>>,
          TError,
          Awaited<ReturnType<typeof findDocumentExternalLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindDocumentExternalLink<TData = Awaited<ReturnType<typeof findDocumentExternalLink>>, TError = Problem>(
 tenantId: string,
    documentId: number,
    externalLinkId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDocumentExternalLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findDocumentExternalLink>>,
          TError,
          Awaited<ReturnType<typeof findDocumentExternalLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindDocumentExternalLink<TData = Awaited<ReturnType<typeof findDocumentExternalLink>>, TError = Problem>(
 tenantId: string,
    documentId: number,
    externalLinkId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDocumentExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca uma referência externa do documento por ID
 */

export function useFindDocumentExternalLink<TData = Awaited<ReturnType<typeof findDocumentExternalLink>>, TError = Problem>(
 tenantId: string,
    documentId: number,
    externalLinkId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDocumentExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindDocumentExternalLinkQueryOptions(tenantId,documentId,externalLinkId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type deleteDocumentExternalLinkResponse204 = {
  data: void
  status: 204
}

export type deleteDocumentExternalLinkResponse404 = {
  data: Problem
  status: 404
}

export type deleteDocumentExternalLinkResponseSuccess = (deleteDocumentExternalLinkResponse204) & {
  headers: Headers;
};
export type deleteDocumentExternalLinkResponseError = (deleteDocumentExternalLinkResponse404) & {
  headers: Headers;
};

export type deleteDocumentExternalLinkResponse = (deleteDocumentExternalLinkResponseSuccess | deleteDocumentExternalLinkResponseError)

export const getDeleteDocumentExternalLinkUrl = (tenantId: string,
    documentId: number,
    externalLinkId: number,) => {




  return `/${tenantId}/documents/${documentId}/external-links/${externalLinkId}`
}

/**
 * @summary Exclui uma referência externa do documento por ID
 */
export const deleteDocumentExternalLink = async (tenantId: string,
    documentId: number,
    externalLinkId: number, options?: RequestInit): Promise<deleteDocumentExternalLinkResponse> => {

  return customInstanceDocumentos<deleteDocumentExternalLinkResponse>(getDeleteDocumentExternalLinkUrl(tenantId,documentId,externalLinkId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteDocumentExternalLinkMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentExternalLink>>, TError,{tenantId: string;documentId: number;externalLinkId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentExternalLink>>, TError,{tenantId: string;documentId: number;externalLinkId: number}, TContext> => {

const mutationKey = ['deleteDocumentExternalLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDocumentExternalLink>>, {tenantId: string;documentId: number;externalLinkId: number}> = (props) => {
          const {tenantId,documentId,externalLinkId} = props ?? {};

          return  deleteDocumentExternalLink(tenantId,documentId,externalLinkId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocumentExternalLinkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDocumentExternalLink>>>

    export type DeleteDocumentExternalLinkMutationError = Problem

    /**
 * @summary Exclui uma referência externa do documento por ID
 */
export const useDeleteDocumentExternalLink = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentExternalLink>>, TError,{tenantId: string;documentId: number;externalLinkId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDocumentExternalLink>>,
        TError,
        {tenantId: string;documentId: number;externalLinkId: number},
        TContext
      > => {
      return useMutation(getDeleteDocumentExternalLinkMutationOptions(options), queryClient);
    }

export type listDocumentExternalLinkResponse200 = {
  data: PageDocumentExternalLinkDto
  status: 200
}

export type listDocumentExternalLinkResponseSuccess = (listDocumentExternalLinkResponse200) & {
  headers: Headers;
};
;

export type listDocumentExternalLinkResponse = (listDocumentExternalLinkResponseSuccess)

export const getListDocumentExternalLinkUrl = (tenantId: string,
    documentId: number,
    params?: ListDocumentExternalLinkParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/${documentId}/external-links?${stringifiedParams}` : `/${tenantId}/documents/${documentId}/external-links`
}

/**
 * @summary Lista as referências externas do documento
 */
export const listDocumentExternalLink = async (tenantId: string,
    documentId: number,
    params?: ListDocumentExternalLinkParams, options?: RequestInit): Promise<listDocumentExternalLinkResponse> => {

  return customInstanceDocumentos<listDocumentExternalLinkResponse>(getListDocumentExternalLinkUrl(tenantId,documentId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDocumentExternalLinkQueryKey = (tenantId: string,
    documentId: number,
    params?: ListDocumentExternalLinkParams,) => {
    return [
    `/${tenantId}/documents/${documentId}/external-links`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDocumentExternalLinkQueryOptions = <TData = Awaited<ReturnType<typeof listDocumentExternalLink>>, TError = unknown>(tenantId: string,
    documentId: number,
    params?: ListDocumentExternalLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDocumentExternalLinkQueryKey(tenantId,documentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocumentExternalLink>>> = ({ signal }) => listDocumentExternalLink(tenantId,documentId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDocumentExternalLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDocumentExternalLinkQueryResult = NonNullable<Awaited<ReturnType<typeof listDocumentExternalLink>>>
export type ListDocumentExternalLinkQueryError = unknown


export function useListDocumentExternalLink<TData = Awaited<ReturnType<typeof listDocumentExternalLink>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params: undefined |  ListDocumentExternalLinkParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentExternalLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentExternalLink>>,
          TError,
          Awaited<ReturnType<typeof listDocumentExternalLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentExternalLink<TData = Awaited<ReturnType<typeof listDocumentExternalLink>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: ListDocumentExternalLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentExternalLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentExternalLink>>,
          TError,
          Awaited<ReturnType<typeof listDocumentExternalLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentExternalLink<TData = Awaited<ReturnType<typeof listDocumentExternalLink>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: ListDocumentExternalLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as referências externas do documento
 */

export function useListDocumentExternalLink<TData = Awaited<ReturnType<typeof listDocumentExternalLink>>, TError = unknown>(
 tenantId: string,
    documentId: number,
    params?: ListDocumentExternalLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDocumentExternalLinkQueryOptions(tenantId,documentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listExcludedDocumentResponse200 = {
  data: PageDocumentDto
  status: 200
}

export type listExcludedDocumentResponseSuccess = (listExcludedDocumentResponse200) & {
  headers: Headers;
};
;

export type listExcludedDocumentResponse = (listExcludedDocumentResponseSuccess)

export const getListExcludedDocumentUrl = (tenantId: string,
    params?: ListExcludedDocumentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/excluded?${stringifiedParams}` : `/${tenantId}/documents/excluded`
}

/**
 * @summary Lista os documentos excluídos
 */
export const listExcludedDocument = async (tenantId: string,
    params?: ListExcludedDocumentParams, options?: RequestInit): Promise<listExcludedDocumentResponse> => {

  return customInstanceDocumentos<listExcludedDocumentResponse>(getListExcludedDocumentUrl(tenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExcludedDocumentQueryKey = (tenantId: string,
    params?: ListExcludedDocumentParams,) => {
    return [
    `/${tenantId}/documents/excluded`, ...(params ? [params] : [])
    ] as const;
    }


export const getListExcludedDocumentQueryOptions = <TData = Awaited<ReturnType<typeof listExcludedDocument>>, TError = unknown>(tenantId: string,
    params?: ListExcludedDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExcludedDocumentQueryKey(tenantId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExcludedDocument>>> = ({ signal }) => listExcludedDocument(tenantId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExcludedDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExcludedDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof listExcludedDocument>>>
export type ListExcludedDocumentQueryError = unknown


export function useListExcludedDocument<TData = Awaited<ReturnType<typeof listExcludedDocument>>, TError = unknown>(
 tenantId: string,
    params: undefined |  ListExcludedDocumentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExcludedDocument>>,
          TError,
          Awaited<ReturnType<typeof listExcludedDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExcludedDocument<TData = Awaited<ReturnType<typeof listExcludedDocument>>, TError = unknown>(
 tenantId: string,
    params?: ListExcludedDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExcludedDocument>>,
          TError,
          Awaited<ReturnType<typeof listExcludedDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExcludedDocument<TData = Awaited<ReturnType<typeof listExcludedDocument>>, TError = unknown>(
 tenantId: string,
    params?: ListExcludedDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os documentos excluídos
 */

export function useListExcludedDocument<TData = Awaited<ReturnType<typeof listExcludedDocument>>, TError = unknown>(
 tenantId: string,
    params?: ListExcludedDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExcludedDocumentQueryOptions(tenantId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type findSignatureBatchByIdResponse200 = {
  data: CoverDto
  status: 200
}

export type findSignatureBatchByIdResponse404 = {
  data: Problem
  status: 404
}

export type findSignatureBatchByIdResponseSuccess = (findSignatureBatchByIdResponse200) & {
  headers: Headers;
};
export type findSignatureBatchByIdResponseError = (findSignatureBatchByIdResponse404) & {
  headers: Headers;
};

export type findSignatureBatchByIdResponse = (findSignatureBatchByIdResponseSuccess | findSignatureBatchByIdResponseError)

export const getFindSignatureBatchByIdUrl = (tenantId: string,
    coverId: string,) => {




  return `/${tenantId}/documents/covers/${coverId}`
}

/**
 * @summary Busca um envelope de assinatura por ID
 */
export const findSignatureBatchById = async (tenantId: string,
    coverId: string, options?: RequestInit): Promise<findSignatureBatchByIdResponse> => {

  return customInstanceDocumentos<findSignatureBatchByIdResponse>(getFindSignatureBatchByIdUrl(tenantId,coverId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindSignatureBatchByIdQueryKey = (tenantId: string,
    coverId: string,) => {
    return [
    `/${tenantId}/documents/covers/${coverId}`
    ] as const;
    }


export const getFindSignatureBatchByIdQueryOptions = <TData = Awaited<ReturnType<typeof findSignatureBatchById>>, TError = Problem>(tenantId: string,
    coverId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSignatureBatchById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindSignatureBatchByIdQueryKey(tenantId,coverId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findSignatureBatchById>>> = ({ signal }) => findSignatureBatchById(tenantId,coverId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && coverId !== null && coverId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findSignatureBatchById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindSignatureBatchByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findSignatureBatchById>>>
export type FindSignatureBatchByIdQueryError = Problem


export function useFindSignatureBatchById<TData = Awaited<ReturnType<typeof findSignatureBatchById>>, TError = Problem>(
 tenantId: string,
    coverId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSignatureBatchById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSignatureBatchById>>,
          TError,
          Awaited<ReturnType<typeof findSignatureBatchById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindSignatureBatchById<TData = Awaited<ReturnType<typeof findSignatureBatchById>>, TError = Problem>(
 tenantId: string,
    coverId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSignatureBatchById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSignatureBatchById>>,
          TError,
          Awaited<ReturnType<typeof findSignatureBatchById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindSignatureBatchById<TData = Awaited<ReturnType<typeof findSignatureBatchById>>, TError = Problem>(
 tenantId: string,
    coverId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSignatureBatchById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca um envelope de assinatura por ID
 */

export function useFindSignatureBatchById<TData = Awaited<ReturnType<typeof findSignatureBatchById>>, TError = Problem>(
 tenantId: string,
    coverId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSignatureBatchById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindSignatureBatchByIdQueryOptions(tenantId,coverId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listCoversToSignResponse200 = {
  data: PageCoverDto
  status: 200
}

export type listCoversToSignResponseSuccess = (listCoversToSignResponse200) & {
  headers: Headers;
};
;

export type listCoversToSignResponse = (listCoversToSignResponseSuccess)

export const getListCoversToSignUrl = (tenantId: string,
    params?: ListCoversToSignParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/${tenantId}/documents/covers/to-sign?${stringifiedParams}` : `/${tenantId}/documents/covers/to-sign`
}

/**
 * @summary Lista os envelopes pendentes de assinatura para o usuário logado
 */
export const listCoversToSign = async (tenantId: string,
    params?: ListCoversToSignParams, options?: RequestInit): Promise<listCoversToSignResponse> => {

  return customInstanceDocumentos<listCoversToSignResponse>(getListCoversToSignUrl(tenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCoversToSignQueryKey = (tenantId: string,
    params?: ListCoversToSignParams,) => {
    return [
    `/${tenantId}/documents/covers/to-sign`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCoversToSignQueryOptions = <TData = Awaited<ReturnType<typeof listCoversToSign>>, TError = unknown>(tenantId: string,
    params?: ListCoversToSignParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoversToSign>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCoversToSignQueryKey(tenantId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCoversToSign>>> = ({ signal }) => listCoversToSign(tenantId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCoversToSign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCoversToSignQueryResult = NonNullable<Awaited<ReturnType<typeof listCoversToSign>>>
export type ListCoversToSignQueryError = unknown


export function useListCoversToSign<TData = Awaited<ReturnType<typeof listCoversToSign>>, TError = unknown>(
 tenantId: string,
    params: undefined |  ListCoversToSignParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoversToSign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoversToSign>>,
          TError,
          Awaited<ReturnType<typeof listCoversToSign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoversToSign<TData = Awaited<ReturnType<typeof listCoversToSign>>, TError = unknown>(
 tenantId: string,
    params?: ListCoversToSignParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoversToSign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoversToSign>>,
          TError,
          Awaited<ReturnType<typeof listCoversToSign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoversToSign<TData = Awaited<ReturnType<typeof listCoversToSign>>, TError = unknown>(
 tenantId: string,
    params?: ListCoversToSignParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoversToSign>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os envelopes pendentes de assinatura para o usuário logado
 */

export function useListCoversToSign<TData = Awaited<ReturnType<typeof listCoversToSign>>, TError = unknown>(
 tenantId: string,
    params?: ListCoversToSignParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoversToSign>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCoversToSignQueryOptions(tenantId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type healthResponse200 = {
  data: Health200
  status: 200
}

export type healthResponseSuccess = (healthResponse200) & {
  headers: Headers;
};
;

export type healthResponse = (healthResponseSuccess)

export const getHealthUrl = (tenant: string,) => {




  return `/v1/${tenant}/search/health`
}

export const health = async (tenant: string, options?: RequestInit): Promise<healthResponse> => {

  return customInstanceDocumentos<healthResponse>(getHealthUrl(tenant),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthQueryKey = (tenant: string,) => {
    return [
    `/v1/${tenant}/search/health`
    ] as const;
    }


export const getHealthQueryOptions = <TData = Awaited<ReturnType<typeof health>>, TError = unknown>(tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthQueryKey(tenant);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof health>>> = ({ signal }) => health(tenant, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthQueryResult = NonNullable<Awaited<ReturnType<typeof health>>>
export type HealthQueryError = unknown


export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = unknown>(
 tenant: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof health>>,
          TError,
          Awaited<ReturnType<typeof health>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof health>>,
          TError,
          Awaited<ReturnType<typeof health>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthQueryOptions(tenant,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadDocumentByTokenResponse200 = {
  data: DownloadDocumentByToken200
  status: 200
}

export type downloadDocumentByTokenResponseSuccess = (downloadDocumentByTokenResponse200) & {
  headers: Headers;
};
;

export type downloadDocumentByTokenResponse = (downloadDocumentByTokenResponseSuccess)

export const getDownloadDocumentByTokenUrl = (token: string,) => {




  return `/files/download/${token}`
}

/**
 * @summary Faz download do arquivo utilizand a url publica temporária
 */
export const downloadDocumentByToken = async (token: string, options?: RequestInit): Promise<downloadDocumentByTokenResponse> => {

  return customInstanceDocumentos<downloadDocumentByTokenResponse>(getDownloadDocumentByTokenUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadDocumentByTokenQueryKey = (token: string,) => {
    return [
    `/files/download/${token}`
    ] as const;
    }


export const getDownloadDocumentByTokenQueryOptions = <TData = Awaited<ReturnType<typeof downloadDocumentByToken>>, TError = unknown>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocumentByToken>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadDocumentByTokenQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadDocumentByToken>>> = ({ signal }) => downloadDocumentByToken(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadDocumentByToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadDocumentByTokenQueryResult = NonNullable<Awaited<ReturnType<typeof downloadDocumentByToken>>>
export type DownloadDocumentByTokenQueryError = unknown


export function useDownloadDocumentByToken<TData = Awaited<ReturnType<typeof downloadDocumentByToken>>, TError = unknown>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocumentByToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDocumentByToken>>,
          TError,
          Awaited<ReturnType<typeof downloadDocumentByToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDocumentByToken<TData = Awaited<ReturnType<typeof downloadDocumentByToken>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocumentByToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDocumentByToken>>,
          TError,
          Awaited<ReturnType<typeof downloadDocumentByToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDocumentByToken<TData = Awaited<ReturnType<typeof downloadDocumentByToken>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocumentByToken>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Faz download do arquivo utilizand a url publica temporária
 */

export function useDownloadDocumentByToken<TData = Awaited<ReturnType<typeof downloadDocumentByToken>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocumentByToken>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadDocumentByTokenQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getFileDetailsResponse200 = {
  data: GetFileDetails200
  status: 200
}

export type getFileDetailsResponseSuccess = (getFileDetailsResponse200) & {
  headers: Headers;
};
;

export type getFileDetailsResponse = (getFileDetailsResponseSuccess)

export const getGetFileDetailsUrl = (digitalFileId: string,) => {




  return `/external/${digitalFileId}`
}

/**
 * @summary Retorna detalhes do arquivo armazenado no uploader
 */
export const getFileDetails = async (digitalFileId: string, options?: RequestInit): Promise<getFileDetailsResponse> => {

  return customInstanceDocumentos<getFileDetailsResponse>(getGetFileDetailsUrl(digitalFileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFileDetailsQueryKey = (digitalFileId: string,) => {
    return [
    `/external/${digitalFileId}`
    ] as const;
    }


export const getGetFileDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getFileDetails>>, TError = unknown>(digitalFileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFileDetailsQueryKey(digitalFileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFileDetails>>> = ({ signal }) => getFileDetails(digitalFileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: digitalFileId !== null && digitalFileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFileDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFileDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getFileDetails>>>
export type GetFileDetailsQueryError = unknown


export function useGetFileDetails<TData = Awaited<ReturnType<typeof getFileDetails>>, TError = unknown>(
 digitalFileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFileDetails>>,
          TError,
          Awaited<ReturnType<typeof getFileDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFileDetails<TData = Awaited<ReturnType<typeof getFileDetails>>, TError = unknown>(
 digitalFileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFileDetails>>,
          TError,
          Awaited<ReturnType<typeof getFileDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFileDetails<TData = Awaited<ReturnType<typeof getFileDetails>>, TError = unknown>(
 digitalFileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna detalhes do arquivo armazenado no uploader
 */

export function useGetFileDetails<TData = Awaited<ReturnType<typeof getFileDetails>>, TError = unknown>(
 digitalFileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFileDetailsQueryOptions(digitalFileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadStoredFileResponse200 = {
  data: DownloadStoredFile200
  status: 200
}

export type downloadStoredFileResponseSuccess = (downloadStoredFileResponse200) & {
  headers: Headers;
};
;

export type downloadStoredFileResponse = (downloadStoredFileResponseSuccess)

export const getDownloadStoredFileUrl = (digitalFileId: string,) => {




  return `/external/${digitalFileId}/download`
}

/**
 * @summary Faz download do arquivo armazenado no uploader
 */
export const downloadStoredFile = async (digitalFileId: string, options?: RequestInit): Promise<downloadStoredFileResponse> => {

  return customInstanceDocumentos<downloadStoredFileResponse>(getDownloadStoredFileUrl(digitalFileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadStoredFileQueryKey = (digitalFileId: string,) => {
    return [
    `/external/${digitalFileId}/download`
    ] as const;
    }


export const getDownloadStoredFileQueryOptions = <TData = Awaited<ReturnType<typeof downloadStoredFile>>, TError = unknown>(digitalFileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadStoredFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadStoredFileQueryKey(digitalFileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadStoredFile>>> = ({ signal }) => downloadStoredFile(digitalFileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: digitalFileId !== null && digitalFileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadStoredFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadStoredFileQueryResult = NonNullable<Awaited<ReturnType<typeof downloadStoredFile>>>
export type DownloadStoredFileQueryError = unknown


export function useDownloadStoredFile<TData = Awaited<ReturnType<typeof downloadStoredFile>>, TError = unknown>(
 digitalFileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadStoredFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadStoredFile>>,
          TError,
          Awaited<ReturnType<typeof downloadStoredFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadStoredFile<TData = Awaited<ReturnType<typeof downloadStoredFile>>, TError = unknown>(
 digitalFileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadStoredFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadStoredFile>>,
          TError,
          Awaited<ReturnType<typeof downloadStoredFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadStoredFile<TData = Awaited<ReturnType<typeof downloadStoredFile>>, TError = unknown>(
 digitalFileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadStoredFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Faz download do arquivo armazenado no uploader
 */

export function useDownloadStoredFile<TData = Awaited<ReturnType<typeof downloadStoredFile>>, TError = unknown>(
 digitalFileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadStoredFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadStoredFileQueryOptions(digitalFileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listCachesResponse200 = {
  data: CacheDto[]
  status: 200
}

export type listCachesResponseSuccess = (listCachesResponse200) & {
  headers: Headers;
};
;

export type listCachesResponse = (listCachesResponseSuccess)

export const getListCachesUrl = () => {




  return `/cache`
}

/**
 * @summary Lista as chaves do cache
 */
export const listCaches = async ( options?: RequestInit): Promise<listCachesResponse> => {

  return customInstanceDocumentos<listCachesResponse>(getListCachesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCachesQueryKey = () => {
    return [
    `/cache`
    ] as const;
    }


export const getListCachesQueryOptions = <TData = Awaited<ReturnType<typeof listCaches>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaches>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCachesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCaches>>> = ({ signal }) => listCaches({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCaches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCachesQueryResult = NonNullable<Awaited<ReturnType<typeof listCaches>>>
export type ListCachesQueryError = unknown


export function useListCaches<TData = Awaited<ReturnType<typeof listCaches>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCaches>>,
          TError,
          Awaited<ReturnType<typeof listCaches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCaches<TData = Awaited<ReturnType<typeof listCaches>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCaches>>,
          TError,
          Awaited<ReturnType<typeof listCaches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCaches<TData = Awaited<ReturnType<typeof listCaches>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaches>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as chaves do cache
 */

export function useListCaches<TData = Awaited<ReturnType<typeof listCaches>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaches>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCachesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type overviewResponse200 = {
  data: DoczBffOverviewDto
  status: 200
}

export type overviewResponseSuccess = (overviewResponse200) & {
  headers: Headers;
};
;

export type overviewResponse = (overviewResponseSuccess)

export const getOverviewUrl = (params: OverviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/bff/docz-documentos/overview?${stringifiedParams}` : `/api/v1/bff/docz-documentos/overview`
}

/**
 * @summary Retorna lista de documentos armazenados no smartdocs/docz
 */
export const overview = async (params: OverviewParams, options?: RequestInit): Promise<overviewResponse> => {

  return customInstanceDocumentos<overviewResponse>(getOverviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOverviewQueryKey = (params?: OverviewParams,) => {
    return [
    `/api/v1/bff/docz-documentos/overview`, ...(params ? [params] : [])
    ] as const;
    }


export const getOverviewQueryOptions = <TData = Awaited<ReturnType<typeof overview>>, TError = unknown>(params: OverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof overview>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOverviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof overview>>> = ({ signal }) => overview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof overview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OverviewQueryResult = NonNullable<Awaited<ReturnType<typeof overview>>>
export type OverviewQueryError = unknown


export function useOverview<TData = Awaited<ReturnType<typeof overview>>, TError = unknown>(
 params: OverviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof overview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof overview>>,
          TError,
          Awaited<ReturnType<typeof overview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOverview<TData = Awaited<ReturnType<typeof overview>>, TError = unknown>(
 params: OverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof overview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof overview>>,
          TError,
          Awaited<ReturnType<typeof overview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOverview<TData = Awaited<ReturnType<typeof overview>>, TError = unknown>(
 params: OverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof overview>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna lista de documentos armazenados no smartdocs/docz
 */

export function useOverview<TData = Awaited<ReturnType<typeof overview>>, TError = unknown>(
 params: OverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof overview>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOverviewQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type overviewFiltersResponse200 = {
  data: DoczBffOverviewFilterListDto
  status: 200
}

export type overviewFiltersResponseSuccess = (overviewFiltersResponse200) & {
  headers: Headers;
};
;

export type overviewFiltersResponse = (overviewFiltersResponseSuccess)

export const getOverviewFiltersUrl = (params: OverviewFiltersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/bff/docz-documentos/overview/filters?${stringifiedParams}` : `/api/v1/bff/docz-documentos/overview/filters`
}

/**
 * @summary Retorna total de documentos agrupados por metadados para serem utilizadas nos filtros do Smartdocs
 */
export const overviewFilters = async (params: OverviewFiltersParams, options?: RequestInit): Promise<overviewFiltersResponse> => {

  return customInstanceDocumentos<overviewFiltersResponse>(getOverviewFiltersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOverviewFiltersQueryKey = (params?: OverviewFiltersParams,) => {
    return [
    `/api/v1/bff/docz-documentos/overview/filters`, ...(params ? [params] : [])
    ] as const;
    }


export const getOverviewFiltersQueryOptions = <TData = Awaited<ReturnType<typeof overviewFilters>>, TError = unknown>(params: OverviewFiltersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof overviewFilters>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOverviewFiltersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof overviewFilters>>> = ({ signal }) => overviewFilters(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof overviewFilters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OverviewFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof overviewFilters>>>
export type OverviewFiltersQueryError = unknown


export function useOverviewFilters<TData = Awaited<ReturnType<typeof overviewFilters>>, TError = unknown>(
 params: OverviewFiltersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof overviewFilters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof overviewFilters>>,
          TError,
          Awaited<ReturnType<typeof overviewFilters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOverviewFilters<TData = Awaited<ReturnType<typeof overviewFilters>>, TError = unknown>(
 params: OverviewFiltersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof overviewFilters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof overviewFilters>>,
          TError,
          Awaited<ReturnType<typeof overviewFilters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOverviewFilters<TData = Awaited<ReturnType<typeof overviewFilters>>, TError = unknown>(
 params: OverviewFiltersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof overviewFilters>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna total de documentos agrupados por metadados para serem utilizadas nos filtros do Smartdocs
 */

export function useOverviewFilters<TData = Awaited<ReturnType<typeof overviewFilters>>, TError = unknown>(
 params: OverviewFiltersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof overviewFilters>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOverviewFiltersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type logsResponse200 = {
  data: DoczBffLogDto
  status: 200
}

export type logsResponseSuccess = (logsResponse200) & {
  headers: Headers;
};
;

export type logsResponse = (logsResponseSuccess)

export const getLogsUrl = (params: LogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/bff/docz-documentos/logs?${stringifiedParams}` : `/api/v1/bff/docz-documentos/logs`
}

/**
 * @summary Retorna log do documento
 */
export const logs = async (params: LogsParams, options?: RequestInit): Promise<logsResponse> => {

  return customInstanceDocumentos<logsResponse>(getLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogsQueryKey = (params?: LogsParams,) => {
    return [
    `/api/v1/bff/docz-documentos/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getLogsQueryOptions = <TData = Awaited<ReturnType<typeof logs>>, TError = unknown>(params: LogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logs>>> = ({ signal }) => logs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LogsQueryResult = NonNullable<Awaited<ReturnType<typeof logs>>>
export type LogsQueryError = unknown


export function useLogs<TData = Awaited<ReturnType<typeof logs>>, TError = unknown>(
 params: LogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof logs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof logs>>,
          TError,
          Awaited<ReturnType<typeof logs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLogs<TData = Awaited<ReturnType<typeof logs>>, TError = unknown>(
 params: LogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof logs>>,
          TError,
          Awaited<ReturnType<typeof logs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLogs<TData = Awaited<ReturnType<typeof logs>>, TError = unknown>(
 params: LogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna log do documento
 */

export function useLogs<TData = Awaited<ReturnType<typeof logs>>, TError = unknown>(
 params: LogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadByArquivoIdResponse200 = {
  data: DownloadByArquivoId200
  status: 200
}

export type downloadByArquivoIdResponseSuccess = (downloadByArquivoIdResponse200) & {
  headers: Headers;
};
;

export type downloadByArquivoIdResponse = (downloadByArquivoIdResponseSuccess)

export const getDownloadByArquivoIdUrl = (params: DownloadByArquivoIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/bff/docz-documentos/download?${stringifiedParams}` : `/api/v1/bff/docz-documentos/download`
}

/**
 * @summary Faz download do arquivo
 */
export const downloadByArquivoId = async (params: DownloadByArquivoIdParams, options?: RequestInit): Promise<downloadByArquivoIdResponse> => {

  return customInstanceDocumentos<downloadByArquivoIdResponse>(getDownloadByArquivoIdUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadByArquivoIdQueryKey = (params?: DownloadByArquivoIdParams,) => {
    return [
    `/api/v1/bff/docz-documentos/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadByArquivoIdQueryOptions = <TData = Awaited<ReturnType<typeof downloadByArquivoId>>, TError = unknown>(params: DownloadByArquivoIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadByArquivoId>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadByArquivoIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadByArquivoId>>> = ({ signal }) => downloadByArquivoId(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadByArquivoId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadByArquivoIdQueryResult = NonNullable<Awaited<ReturnType<typeof downloadByArquivoId>>>
export type DownloadByArquivoIdQueryError = unknown


export function useDownloadByArquivoId<TData = Awaited<ReturnType<typeof downloadByArquivoId>>, TError = unknown>(
 params: DownloadByArquivoIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadByArquivoId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadByArquivoId>>,
          TError,
          Awaited<ReturnType<typeof downloadByArquivoId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadByArquivoId<TData = Awaited<ReturnType<typeof downloadByArquivoId>>, TError = unknown>(
 params: DownloadByArquivoIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadByArquivoId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadByArquivoId>>,
          TError,
          Awaited<ReturnType<typeof downloadByArquivoId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadByArquivoId<TData = Awaited<ReturnType<typeof downloadByArquivoId>>, TError = unknown>(
 params: DownloadByArquivoIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadByArquivoId>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Faz download do arquivo
 */

export function useDownloadByArquivoId<TData = Awaited<ReturnType<typeof downloadByArquivoId>>, TError = unknown>(
 params: DownloadByArquivoIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadByArquivoId>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadByArquivoIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type detailsResponse200 = {
  data: DoczBffDetailDto
  status: 200
}

export type detailsResponseSuccess = (detailsResponse200) & {
  headers: Headers;
};
;

export type detailsResponse = (detailsResponseSuccess)

export const getDetailsUrl = (params: DetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/bff/docz-documentos/details?${stringifiedParams}` : `/api/v1/bff/docz-documentos/details`
}

/**
 * @summary Retorna lista de documentos armazenados no smartdocs/docz
 */
export const details = async (params: DetailsParams, options?: RequestInit): Promise<detailsResponse> => {

  return customInstanceDocumentos<detailsResponse>(getDetailsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDetailsQueryKey = (params?: DetailsParams,) => {
    return [
    `/api/v1/bff/docz-documentos/details`, ...(params ? [params] : [])
    ] as const;
    }


export const getDetailsQueryOptions = <TData = Awaited<ReturnType<typeof details>>, TError = unknown>(params: DetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof details>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDetailsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof details>>> = ({ signal }) => details(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof details>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DetailsQueryResult = NonNullable<Awaited<ReturnType<typeof details>>>
export type DetailsQueryError = unknown


export function useDetails<TData = Awaited<ReturnType<typeof details>>, TError = unknown>(
 params: DetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof details>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof details>>,
          TError,
          Awaited<ReturnType<typeof details>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDetails<TData = Awaited<ReturnType<typeof details>>, TError = unknown>(
 params: DetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof details>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof details>>,
          TError,
          Awaited<ReturnType<typeof details>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDetails<TData = Awaited<ReturnType<typeof details>>, TError = unknown>(
 params: DetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof details>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna lista de documentos armazenados no smartdocs/docz
 */

export function useDetails<TData = Awaited<ReturnType<typeof details>>, TError = unknown>(
 params: DetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof details>>, TError, TData>>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type approveDeleteRequestResponse204 = {
  data: Problem
  status: 204
}

export type approveDeleteRequestResponse404 = {
  data: Problem
  status: 404
}

export type approveDeleteRequestResponseSuccess = (approveDeleteRequestResponse204) & {
  headers: Headers;
};
export type approveDeleteRequestResponseError = (approveDeleteRequestResponse404) & {
  headers: Headers;
};

export type approveDeleteRequestResponse = (approveDeleteRequestResponseSuccess | approveDeleteRequestResponseError)

export const getApproveDeleteRequestUrl = (tenantId: string,
    pendingDocumentId: number,) => {




  return `/${tenantId}/pending-documents/${pendingDocumentId}/approve-delete-request`
}

/**
 * @summary Aprova solicitação de exclusão do documento
 */
export const approveDeleteRequest = async (tenantId: string,
    pendingDocumentId: number, options?: RequestInit): Promise<approveDeleteRequestResponse> => {

  return customInstanceDocumentos<approveDeleteRequestResponse>(getApproveDeleteRequestUrl(tenantId,pendingDocumentId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getApproveDeleteRequestMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveDeleteRequest>>, TError,{tenantId: string;pendingDocumentId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof approveDeleteRequest>>, TError,{tenantId: string;pendingDocumentId: number}, TContext> => {

const mutationKey = ['approveDeleteRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveDeleteRequest>>, {tenantId: string;pendingDocumentId: number}> = (props) => {
          const {tenantId,pendingDocumentId} = props ?? {};

          return  approveDeleteRequest(tenantId,pendingDocumentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveDeleteRequestMutationResult = NonNullable<Awaited<ReturnType<typeof approveDeleteRequest>>>

    export type ApproveDeleteRequestMutationError = Problem

    /**
 * @summary Aprova solicitação de exclusão do documento
 */
export const useApproveDeleteRequest = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveDeleteRequest>>, TError,{tenantId: string;pendingDocumentId: number}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveDeleteRequest>>,
        TError,
        {tenantId: string;pendingDocumentId: number},
        TContext
      > => {
      return useMutation(getApproveDeleteRequestMutationOptions(options), queryClient);
    }

export type cancelSignatureBatchByIdResponse200 = {
  data: CoverDto
  status: 200
}

export type cancelSignatureBatchByIdResponseSuccess = (cancelSignatureBatchByIdResponse200) & {
  headers: Headers;
};
;

export type cancelSignatureBatchByIdResponse = (cancelSignatureBatchByIdResponseSuccess)

export const getCancelSignatureBatchByIdUrl = (tenantId: string,
    coverId: string,) => {




  return `/${tenantId}/documents/covers/${coverId}/cancel`
}

export const cancelSignatureBatchById = async (tenantId: string,
    coverId: string,
    batchSignatureCancelInput: BatchSignatureCancelInput, options?: RequestInit): Promise<cancelSignatureBatchByIdResponse> => {

  return customInstanceDocumentos<cancelSignatureBatchByIdResponse>(getCancelSignatureBatchByIdUrl(tenantId,coverId),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(batchSignatureCancelInput)
  }
);}




export const getCancelSignatureBatchByIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSignatureBatchById>>, TError,{tenantId: string;coverId: string;data: BatchSignatureCancelInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelSignatureBatchById>>, TError,{tenantId: string;coverId: string;data: BatchSignatureCancelInput}, TContext> => {

const mutationKey = ['cancelSignatureBatchById'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelSignatureBatchById>>, {tenantId: string;coverId: string;data: BatchSignatureCancelInput}> = (props) => {
          const {tenantId,coverId,data} = props ?? {};

          return  cancelSignatureBatchById(tenantId,coverId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelSignatureBatchByIdMutationResult = NonNullable<Awaited<ReturnType<typeof cancelSignatureBatchById>>>
    export type CancelSignatureBatchByIdMutationBody = BatchSignatureCancelInput
    export type CancelSignatureBatchByIdMutationError = unknown

    export const useCancelSignatureBatchById = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSignatureBatchById>>, TError,{tenantId: string;coverId: string;data: BatchSignatureCancelInput}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelSignatureBatchById>>,
        TError,
        {tenantId: string;coverId: string;data: BatchSignatureCancelInput},
        TContext
      > => {
      return useMutation(getCancelSignatureBatchByIdMutationOptions(options), queryClient);
    }

export type clearCacheResponse200 = {
  data: void
  status: 200
}

export type clearCacheResponseSuccess = (clearCacheResponse200) & {
  headers: Headers;
};
;

export type clearCacheResponse = (clearCacheResponseSuccess)

export const getClearCacheUrl = (cacheName: string,) => {




  return `/cache/${cacheName}`
}

/**
 * @summary Limpa cache pelo nome
 */
export const clearCache = async (cacheName: string, options?: RequestInit): Promise<clearCacheResponse> => {

  return customInstanceDocumentos<clearCacheResponse>(getClearCacheUrl(cacheName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getClearCacheMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCache>>, TError,{cacheName: string}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof clearCache>>, TError,{cacheName: string}, TContext> => {

const mutationKey = ['clearCache'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearCache>>, {cacheName: string}> = (props) => {
          const {cacheName} = props ?? {};

          return  clearCache(cacheName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearCacheMutationResult = NonNullable<Awaited<ReturnType<typeof clearCache>>>

    export type ClearCacheMutationError = unknown

    /**
 * @summary Limpa cache pelo nome
 */
export const useClearCache = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCache>>, TError,{cacheName: string}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearCache>>,
        TError,
        {cacheName: string},
        TContext
      > => {
      return useMutation(getClearCacheMutationOptions(options), queryClient);
    }

export type clearCacheByKeyResponse200 = {
  data: void
  status: 200
}

export type clearCacheByKeyResponseSuccess = (clearCacheByKeyResponse200) & {
  headers: Headers;
};
;

export type clearCacheByKeyResponse = (clearCacheByKeyResponseSuccess)

export const getClearCacheByKeyUrl = (cacheName: string,
    key: string,) => {




  return `/cache/${cacheName}/${key}`
}

/**
 * @summary Limpa cache pelo nome e chave
 */
export const clearCacheByKey = async (cacheName: string,
    key: string, options?: RequestInit): Promise<clearCacheByKeyResponse> => {

  return customInstanceDocumentos<clearCacheByKeyResponse>(getClearCacheByKeyUrl(cacheName,key),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getClearCacheByKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCacheByKey>>, TError,{cacheName: string;key: string}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
): UseMutationOptions<Awaited<ReturnType<typeof clearCacheByKey>>, TError,{cacheName: string;key: string}, TContext> => {

const mutationKey = ['clearCacheByKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearCacheByKey>>, {cacheName: string;key: string}> = (props) => {
          const {cacheName,key} = props ?? {};

          return  clearCacheByKey(cacheName,key,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearCacheByKeyMutationResult = NonNullable<Awaited<ReturnType<typeof clearCacheByKey>>>

    export type ClearCacheByKeyMutationError = unknown

    /**
 * @summary Limpa cache pelo nome e chave
 */
export const useClearCacheByKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCacheByKey>>, TError,{cacheName: string;key: string}, TContext>, request?: SecondParameter<typeof customInstanceDocumentos>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearCacheByKey>>,
        TError,
        {cacheName: string;key: string},
        TContext
      > => {
      return useMutation(getClearCacheByKeyMutationOptions(options), queryClient);
    }

